window.theme = window.theme || {};

function gcd(a, b) {
  return b == 0 ? a : gcd(b, a % b);
}

String.prototype.createContext = function () {
  return document.createRange().createContextualFragment(this);
};

Date.prototype.stdTimezoneOffset = function () {
  var jan = new Date(this.getFullYear(), 0, 1);
  var jul = new Date(this.getFullYear(), 6, 1);
  return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
};

Date.prototype.isDstObserved = function () {
  return this.getTimezoneOffset() < this.stdTimezoneOffset();
};

function ProxyApp() {
  this.customerId = window.customerId;
  this.baseUrl = '/apps/hln';
}

(function ($) {
  $.fn.serializeObject = function () {
    var self = this,
      json = {},
      push_counters = {},
      patterns = {
        validate: /^[a-zA-Z][a-zA-Z0-9_]*(?:\[(?:\d*|[a-zA-Z0-9_]+)\])*$/,
        key: /[a-zA-Z0-9_]+|(?=\[\])/g,
        push: /^$/,
        fixed: /^\d+$/,
        named: /^[a-zA-Z0-9_]+$/,
      };

    this.build = function (base, key, value) {
      base[key] = value;
      return base;
    };

    this.push_counter = function (key) {
      if (push_counters[key] === undefined) {
        push_counters[key] = 0;
      }
      return push_counters[key]++;
    };

    $.each($(this).serializeArray(), function () {
      // Skip invalid keys
      if (!patterns.validate.test(this.name)) {
        return;
      }

      var k,
        keys = this.name.match(patterns.key),
        merge = this.value,
        reverse_key = this.name;

      while ((k = keys.pop()) !== undefined) {
        // Adjust reverse_key
        reverse_key = reverse_key.replace(new RegExp('\\[' + k + '\\]$'), '');

        // Push
        if (k.match(patterns.push)) {
          merge = self.build([], self.push_counter(reverse_key), merge);
        }

        // Fixed
        else if (k.match(patterns.fixed)) {
          merge = self.build([], k, merge);
        }

        // Named
        else if (k.match(patterns.named)) {
          merge = self.build({}, k, merge);
        }
      }

      json = $.extend(true, json, merge);
    });

    return json;
  };
})(jQuery);

String.prototype.slug = function () {
  // <-- removed the argument
  var str = this; // <-- added this statement

  str = str.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();
  str = str
    .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes
  return str;
};

ProxyApp.prototype = Object.assign({}, ProxyApp.prototype, {
  _tokenKey: function () {
    var customerSlug = this.customerId ? '_' + this.customerId : '';
    return (
      'PROXY_TOKEN' +
      this.baseUrl.replace(/\//g, '_').toUpperCase() +
      customerSlug
    );
  },
  _isLoggedIn: function () {
    var token = this.getToken();
    return typeof token === 'string' && !!token.length;
  },
  _setToken(token, expires) {
    var value = JSON.stringify({ token, expires });
    window.localStorage.setItem(this._tokenKey(), value);
  },
  /**
   * Retrieve the jwt token from localStorage
   */
  getToken() {
    var raw = window.localStorage.getItem(this._tokenKey());
    if (!raw) {
      return undefined;
    }
    try {
      var value = JSON.parse(raw);

      // Expiration check
      if (value.expires - Date.now() < 10000) {
        window.localStorage.removeItem(this._tokenKey());
        return undefined;
      }

      return value.token;
    } catch (e) {
      console.warn('Failed to parse token after retrieval');
      return undefined;
    }
  },
  /**
   * Attempts to log in user if not already logged in.
   * Callback will either contain an error as the first
   * parameter if login has failed or empty on success
   * @param {(error?: Error) => void} callback
   */
  login: function (callback) {
    if (!callback) {
      throw new Error('ProxyApp.login called without callback function');
    }

    if (this._isLoggedIn()) {
      callback();
      return;
    }

    if (!this.customerId) {
      callback(Error('Customer not logged in'));
      return;
    }

    var body = JSON.stringify({
      customer_id: this.customerId,
    });

    $.ajax({
      url: this.baseUrl + '/login',
      type: 'POST',
      dataType: 'json',
      data: body,
      success: function (response) {
        this._setToken(response.access_token, Date.now() + 14 * 60 * 1000);
        callback();
      }.bind(this),
      error: function (response) {
        if (response.error) {
          callback(Error(response.error));
        } else {
          callback(Error('Login failed'));
        }
      }.bind(this),
    });
  },
  request: function (path, args) {
    function afterLogin(e) {
      if (e) {
        error(e);
        return;
      }
      var config = {
        url: this.baseUrl + path,
        headers: {
          Authorization: 'Bearer ' + this.getToken(),
        },
        dataType: 'json',
      };
      Object.assign(config, args || {});
      $.ajax(config);
    }

    this.login(afterLogin.bind(this));
  },
});
window.proxyApp = new ProxyApp();

function createUniqueId(length) {
  var characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  var id = '';

  for (var i = 0; i < length; i++) {
    id += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return id;
}

/* ================ SLATE ================ */

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    'shopify:section:load',
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    'shopify:section:unload',
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    'shopify:section:select',
    this._onSelect.bind(this)
  );
  document.addEventListener(
    'shopify:section:deselect',
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    'shopify:block:select',
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    'shopify:block:deselect',
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute('data-section-id');
    var type = container.getAttribute('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === 'function') {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onSelect === 'function'
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onDeselect === 'function'
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onBlockSelect === 'function'
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onBlockDeselect === 'function'
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function (container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

window.slate = window.slate || {};

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
  getParameterByName: function (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  resizeSelects: function (selects) {
    selects.forEach(function (select) {
      var arrowWidth = 55;

      var test = document.createElement('span');
      test.innerHTML = select.selectedOptions[0].label;

      document.querySelector('.site-footer').appendChild(test);

      var width = test.offsetWidth + arrowWidth;
      test.remove();

      select.style.width = width + 'px';
    });
  },

  keyboardKeys: {
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    LEFTARROW: 37,
    RIGHTARROW: 39,
  },
};

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {NodeList} options.tables - Elements of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    options.tables.forEach(function (table) {
      var wrapper = document.createElement('div');
      wrapper.classList.add(options.tableWrapperClass);

      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {NodeList} options.iframes - Elements of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    options.iframes.forEach(function (iframe) {
      var wrapper = document.createElement('div');
      wrapper.classList.add(options.iframeWrapperClass);

      iframe.parentNode.insertBefore(wrapper, iframe);
      wrapper.appendChild(iframe);

      iframe.src = iframe.src;
    });
  },
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  state: {
    firstFocusable: null,
    lastFocusable: null,
  },
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects
   *
   * @param {HTMLElement} element - The element to be acted upon
   */
  pageLinkFocus: function (element) {
    if (!element) return;
    var focusClass = 'js-focus-hidden';

    element.setAttribute('tabIndex', '-1');
    element.focus();
    element.classList.add(focusClass);
    element.addEventListener('blur', callback, { once: true });

    function callback() {
      element.classList.remove(focusClass);
      element.removeAttribute('tabindex');
    }
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {HTMLElement} options.container - Container to trap focus within
   * @param {HTMLElement} options.elementToFocus - Element to be focused when focus leaves container
   */
  trapFocus: function (options) {
    var focusableElements = Array.from(
      options.container.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      )
    ).filter(function (element) {
      var width = element.offsetWidth;
      var height = element.offsetHeight;

      return (
        width !== 0 &&
        height !== 0 &&
        getComputedStyle(element).getPropertyValue('display') !== 'none'
      );
    });

    this.state.firstFocusable = focusableElements[0];
    this.state.lastFocusable = focusableElements[focusableElements.length - 1];

    if (!options.elementToFocus) {
      options.elementToFocus = options.container;
    }

    options.container.setAttribute('tabindex', '-1');
    options.elementToFocus.focus();

    this._setupHandlers();

    document.addEventListener('focusin', this._onFocusInHandler);
    document.addEventListener('focusout', this._onFocusOutHandler);
  },

  _setupHandlers: function () {
    if (!this._onFocusInHandler) {
      this._onFocusInHandler = this._onFocusIn.bind(this);
    }

    if (!this._onFocusOutHandler) {
      this._onFocusOutHandler = this._onFocusIn.bind(this);
    }

    if (!this._manageFocusHandler) {
      this._manageFocusHandler = this._manageFocus.bind(this);
    }
  },

  _onFocusOut: function () {
    document.removeEventListener('keydown', this._manageFocusHandler);
  },

  _onFocusIn: function (evt) {
    if (
      evt.target !== this.state.lastFocusable &&
      evt.target !== this.state.firstFocusable
    )
      return;

    document.addEventListener('keydown', this._manageFocusHandler);
  },

  _manageFocus: function (evt) {
    if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

    /**
     * On the last focusable element and tab forward,
     * focus the first element.
     */
    if (evt.target === this.state.lastFocusable && !evt.shiftKey) {
      evt.preventDefault();
      this.state.firstFocusable.focus();
    }
    /**
     * On the first focusable element and tab backward,
     * focus the last element.
     */
    if (evt.target === this.state.firstFocusable && evt.shiftKey) {
      evt.preventDefault();
      this.state.lastFocusable.focus();
    }
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {HTMLElement} options.container - Container to trap focus within
   */
  removeTrapFocus: function (options) {
    if (options.container) {
      options.container.removeAttribute('tabindex');
    }
    document.removeEventListener('focusin', this._onFocusInHandler);
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {HTMLElement} options.links - Specific links to be targeted
   */
  accessibleLinks: function (options) {
    var body = document.querySelector('body');

    var idSelectors = {
      newWindow: 'a11y-new-window-message',
      external: 'a11y-external-message',
      newWindowExternal: 'a11y-new-window-external-message',
    };

    if (options.links === undefined || !options.links.length) {
      options.links = document.querySelectorAll(
        'a[href]:not([aria-describedby])'
      );
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== 'object') {
        customMessages = {};
      }

      var messages = Object.assign(
        {
          newWindow: 'Opens in a new window.',
          external: 'Opens external website.',
          newWindowExternal: 'Opens external website in a new window.',
        },
        customMessages
      );

      var container = document.createElement('ul');
      var htmlMessages = '';

      for (var message in messages) {
        htmlMessages +=
          '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
      }

      container.setAttribute('hidden', true);
      container.innerHTML = htmlMessages;

      body.appendChild(container);
    }

    function _externalSite(link) {
      var hostname = window.location.hostname;

      return link.hostname !== hostname;
    }

    options.links.forEach(function (link) {
      var target = link.getAttribute('target');
      var rel = link.getAttribute('rel');
      var isExternal = _externalSite(link);
      var isTargetBlank = target === '_blank';

      if (isExternal) {
        link.setAttribute('aria-describedby', idSelectors.external);
      }

      if (isTargetBlank) {
        if (!rel || rel.indexOf('noopener') === -1) {
          var relValue = rel === undefined ? '' : rel + ' ';
          relValue = relValue + 'noopener';
          link.setAttribute('rel', relValue);
        }

        link.setAttribute('aria-describedby', idSelectors.newWindow);
      }

      if (isExternal && isTargetBlank) {
        link.setAttribute('aria-describedby', idSelectors.newWindowExternal);
      }
    });

    generateHTML(options.messages);
  },
};

/* ================ MODULES ================ */
theme.Activities = (function () {
  var cache = {
    lock: false,
    current_products: {},
    activity_loader: false,
  };

  function init() {
    loadActivityData();
  }

  /**
   * Periodically get the latest activity data. If called, interupt the current
   * period and load imediately.
   */
  function loadActivityData() {
    clearInterval(cache.activity_loader);

    _getActivityData();
    cache.activity_loader = setInterval(_getActivityData, 60000);
  }

  /**
   * Fetch the activity data for the current user. And store it in the cache.
   *
   * Function has a locking mechanism which will prevent it from being called
   * multiple times in a row to prevent and API overload.
   *
   * Each customer type should have their own activity loader and cam
   * have their own set of unique data.
   *
   * @see /templates/collection.educator_activities
   * @see /templates/customers/account.activities
   */
  function _getActivityData() {
    if (!cache.lock) {
      cache.lock = true;

      var promise = new Promise(function (resolve, reject) {
        if (theme.customer && theme.customer.access == 'educator') {
          $.ajax({
            url:
              '/collections/' + theme.customer.id + '?view=educator_activities',
            method: 'GET',
            success: function (r) {
              resolve(JSON.parse(r));
            },
            error: function (r) {
              console.error(
                '----- ---------------------------------------------------- -----'
              );
              console.error(
                '----- An error has occured fetching educator activity data -----'
              );
              console.error(r.responseText);
              console.error(
                '----- ---------------------------------------------------- -----'
              );
              reject(r.responseText);
            },
          });
        } else if (theme.customer) {
          $.ajax({
            url: '/account?view=activities',
            method: 'GET',
            success: function (r) {
              resolve(JSON.parse(r));
            },
            error: function (r) {
              console.error(
                '----- --------------------------------------------------- -----'
              );
              console.error(
                '----- An error has occured fetching learner activity data -----'
              );
              console.error(r.responseText);
              console.error(
                '----- --------------------------------------------------- -----'
              );
              reject(r.responseText);
            },
          });
        }
      });

      promise.then(function (r) {
        cache.activity_data = r.payload;
        cache.lock = false;
      });

      return promise;
    }
  }

  function formatActivityData() {
    let formatted_data = {};
    let array_indeces = {};

    $("[name*='map:']").each(function () {
      var input_type = $(this).attr('type');
      var reference = $(this).attr('name').slice(4).split('.');
      var value = $(this).val();
      var depth = reference.length - 1;
      let target = formatted_data;

      reference.forEach((reference, index) => {
        var is_array = false;

        if (reference.indexOf('()') > -1) {
          is_array = true;
          reference = reference.substring(0, reference.length - 2);

          if (typeof array_indeces[reference] == 'undefined') {
            array_indeces[reference] = 0;
          } else {
            array_indeces[reference] += 1;

            if (depth > index) {
              target[reference][array_indeces[reference]] = {};
            }
          }
        } else if (reference.indexOf('[]') > -1) {
          is_array = true;
          reference = reference.substring(0, reference.length - 2);
        }

        if (typeof target[reference] == 'undefined') {
          if (is_array) {
            target[reference] = [];

            if (depth > index) {
              target[reference][array_indeces[reference]] = {};
            }
          } else if (depth > index) {
            target[reference] = {};
          } else {
            target[reference] = '';
          }
        }

        if (depth == index) {
          if (
            input_type == 'text' ||
            input_type == 'hidden' ||
            input_type == 'number'
          ) {
            if (reference == 'start_date') {
              value = theme.Time.convertTimeToSourceTimezone(value);
            }

            if (/^\d+$/.test(value) && typeof value != 'object') {
              value = parseInt(value);
            }

            if (value == '' && input_type == 'number') {
              value = 0;
            }

            if (typeof target[reference] == 'object') {
              if (typeof value == 'object') {
                target[reference] = value;
              } else {
                target[reference].push(value);
              }
            } else {
              target[reference] = value === 'null' ? null : value;
            }
          } else if (input_type == 'radio') {
            if ($(this).is(':checked')) {
              target[reference] = value;
            }
          } else if (input_type == 'checkbox') {
            if ($(this).is(':checked')) {
              target[reference].push(value);
            }
          }
        } else {
          if (is_array) {
            target = target[reference][array_indeces[reference]];
          } else {
            target = target[reference];
          }
        }
      });
    });

    return { activity: formatted_data };
  }

  function saveActivity(data) {
    if (!cache.lock) {
      cache.lock = true;
      var interval;

      if (theme.ActivitiesEdit.getChangeStatus()) {
        data.activity.status = 'draft';
      }

      if (data.activity.video == 'DELETE') {
        var params = {
          type: 'DELETE',
          contentType: 'application/json; charset=utf-8',
        };
        proxyApp.request(
          `/media/media_id?activity_id=${data.activity.id}`,
          params
        );
      }

      var promise = new Promise(function (resolve, reject) {
        data.activity.info.token = createUniqueId(10);

        proxyApp.request(
          '/activities' + (data.activity.id != 0 ? '/' + data.activity.id : ''),
          {
            type: data.activity.id == 0 ? 'POST' : 'PUT',
            data: JSON.stringify(data),
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            success: function (r) {
              interval = setInterval(function () {
                $.ajax({
                  url: '/products/' + r.activity.handle,
                  data: { view: 'json' },
                  success: function (r) {
                    var json = JSON.parse(r);

                    if (json.payload.token == data.activity.info.token) {
                      resolve(json.payload);
                    }
                  },
                });
              }, 500);
            },
            error: function (r) {
              reject(r);
            },
          }
        );
      });

      promise
        .then(function (r) {
          clearInterval(interval);
          cache.lock = false;

          if (
            data.activity.video &&
            data.activity.video != '' &&
            data.activity.video != 'DELETE'
          ) {
            var params = {
              type: 'POST',
              data: JSON.stringify({
                media: {
                  resource_url: data.activity.video,
                  activity_id: r.id,
                },
              }),
              dataType: 'json',
              contentType: 'application/json; charset=utf-8',
            };

            proxyApp.request('/media', params);
          }

          setActivityData(r);

          $.fancybox.close();
        })
        .catch(function (r) {
          cache.lock = false;
          console.error(r);
        });

      return promise;
    }

    return false;
  }

  function submitActivity(data) {
    if (!cache.lock) {
      cache.lock = true;

      var promise = new Promise(function (resolve, reject) {
        proxyApp.request('/activities/' + data + '/submit', {
          type: 'PUT',
          dataType: 'json',
          contentType: 'application/json; charset=utf-8',
          success: function (r) {
            resolve(true);
          },
          error: function (r) {
            reject(r);
          },
        });
      });

      promise
        .then(function (r) {
          cache.lock = false;
          setActivityData(r);

          var string = `
          <p>You activity was successfully submitted and is now pending review</p>
          <div style='text-align: center;'>
            <a class="btn btn--primary" href="/account?q=educator-activities" role="link">Back to dashboard</a>
          </div>`;

          theme.Global.generateModal('success', 'Success!', string);
        })
        .catch(function (r) {
          cache.lock = false;

          console.error(r);
          theme.Global.generateModal(
            'error',
            'Error...',
            'An error has occured, please contact your administrator!',
            r.responseText
          );
        });

      return promise;
    } else {
      console.warn('Activity Object is locked.');
      return false;
    }
  }

  function getActivity(id) {
    return getActivities(id);
  }

  function getActivities(id) {
    if (id) {
      var promise = new Promise(function (resolve, reject) {
        if (cache.activity_data[id]) {
          resolve(cache.activity_data[id]);
        } else {
          reject('No activity with Id: ' + id + ' found');
        }
      });
    } else {
      var promise = new Promise(function (resolve, reject) {
        if (cache.activity_data) {
          resolve(cache.activity_data);
        } else {
          var interval = setInterval(function () {
            if (cache.activity_data) {
              clearInterval(interval);
              resolve(cache.activity_data);
            }
          }, 100);
        }
      });
    }

    return promise;
  }

  function getAllActivities() {
    return new Promise(function (resolve) {
      var params = {
        url: '/collections/all?view=educator_activities',
        method: 'GET',
        complete: function (r) {
          let response = {};
          if (r.status == 200) {
            response = JSON.parse(r.responseText);
          }
          resolve(response);
        },
      };
      $.ajax(params);
    });
  }

  function setActivityData(data) {
    cache.activity_data[data.id] = data;

    return data;
  }

  function deleteActivity(id) {
    if (!cache.lock) {
      cache.lock = true;

      var interval;

      if (typeof id == 'object') {
        id.preventDefault();
        id = $(this).attr('data-activity-id');
      }

      var promise = new Promise(function (resolve) {
        var params = {
          method: 'DELETE',
          type: 'DELETE',
          contentType: 'application/json; charset=utf-8',
          complete: function (r) {
            interval = setInterval(function () {
              $.ajax({
                url: '/products/' + cache.activity_data[id].handle,
                data: { view: 'json' },
                success: function (r) {},
                error: function (r) {
                  resolve();
                },
              });
            }, 500);
          },
        };

        proxyApp.request(`/activities/${id}`, params);
      });

      promise
        .then(function () {
          cache.lock = false;
          clearInterval(interval);
          delete cache.activity_data[id];
        })
        .catch(function () {
          clearInterval(interval);
          cache.lock = false;
        });

      return promise;
    } else {
      return false;
    }
  }

  function cancelActivity(id) {
    if (!cache.lock) {
      cache.lock = true;

      var activity = cache.activity_data[id];

      var promise = new Promise(function (resolve, reject) {
        var params = {
          type: 'POST',
          data: JSON.stringify({
            cancellation: {
              order_level: false,
              order_id: activity.order_id + '',
              line_items: [
                {
                  id: activity.id + '',
                  quantity: activity.quantity,
                },
              ],
            },
          }),
          dataType: 'json',
          contentType: 'application/json; charset=utf-8',
          complete: function (r) {
            cache.lock = false;

            if (r.status == 200) {
              resolve(JSON.parse(r.responseText));
            } else {
              reject(r);
            }
          },
        };
        proxyApp.request('/orders', params);
      });

      promise.then(function () {
        cache.lock = false;

        $.each(cache.activity_data, function (key, value) {
          if (value.unique_key == activity.unique_key) {
            delete cache.activity_data[key];
          }
        });
      });

      return promise;
    }
  }

  function duplicateActivity(id, title) {
    let interval;

    const data = {
      duplicate: {
        include_images: true,
        title: `Copy of ${title}`,
      },
    };

    var promise = new Promise(function (resolve, reject) {
      var params = {
        type: 'POST',
        data: JSON.stringify(data),
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: function (r) {
          interval = setInterval(function () {
            $.ajax({
              url: '/products/' + r.duplicate.handle,
              data: { view: 'json' },
              success: function (r) {
                const json = JSON.parse(r);
                json.payload.filled = false;

                cache.activity_data[json.payload.id] = json.payload;

                resolve(json.payload);
              },
            });
          }, 500);
        },
        error: function (r) {
          reject(r);
        },
      };
      proxyApp.request(`/activities/${id}/duplicate`, params);
    });

    promise.then(function (r) {
      clearInterval(interval);
      setActivityData(r);
    });

    return promise;
  }

  function changeActivityProfile(id, profile_id, uniqueKey) {
    const activity = cache.activity_data.find(
      (a) => `${a.unique_key}` === uniqueKey
    );

    var promise = new Promise(function (resolve, reject) {
      var params = {
        type: 'PUT',
        data: JSON.stringify({
          activity_assignment: {
            variant_id: activity.variant_id,
            order_id: activity.order_id,
            unique: activity.unique_key,
            profile_id: profile_id,
          },
        }),
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: function (r) {
          activity.participant = profile_id;
          resolve(activity.unique_key);
        },
        error: function (r) {
          reject(r);
        },
      };
      proxyApp.request(
        '/activities/' + activity.product_id + '/assign',
        params
      );
    });

    return promise;
  }

  function loadActivity(handle) {
    const promise = new Promise(function (resolve, reject) {
      if (cache.current_products[handle]) {
        resolve(current_products[handle]);
      } else {
        $.ajax({
          url: `/products/${handle}`,
          method: 'GET',
          data: { view: 'json' },
          success: function (r) {
            resolve(JSON.parse(r));
          },
          error: function (r) {
            console.error(
              '----- ---------------------------------------------------- -----'
            );
            console.error(
              '----- An error has occured fetching PDP activity data -----'
            );
            console.error(r.responseText);
            console.error(
              '----- ---------------------------------------------------- -----'
            );
            reject(r.responseText);
          },
        });
      }
    });

    promise.then((a) => {
      cache.current_products[handle] = a.payload;
    });
    return promise;
  }

  function hasValidVariant(activity) {
    for (let i = 0; i < activity.variants.length; i++) {
      const variant = activity.variants[i];
      if (variant.available) {
        return true;
      }
    }

    return false;
  }

  /**
   * Returns true if any variant in the activity has participant(s)
   * Returns false if none of the variants have participants
   *
   * @param   {object} activity An entire activity object
   * @returns {bool}
   */
  function hasVariantWithParticipants(activity) {
    for (let i = 0; i < activity.variants.length; i++) {
      const variant = activity.variants[i];
      if (variant.current_participants > 0 && !variant.completed) {
        return true;
      }
    }
    return false;
  }

  return {
    init: init,

    loadActivityData: loadActivityData,
    getActivity: getActivity,
    getActivities: getActivities,
    saveActivity: saveActivity,
    setActivityData: setActivityData,
    deleteActivity: deleteActivity,
    submitActivity: submitActivity,
    cancelActivity: cancelActivity,
    loadActivity: loadActivity,
    duplicateActivity: duplicateActivity,
    getAllActivities: getAllActivities,
    hasValidVariant: hasValidVariant,
    hasVariantWithParticipants: hasVariantWithParticipants,

    changeActivityProfile: changeActivityProfile,

    formatActivityData: formatActivityData,
  };
})();

theme.Resources = (function () {
  var cache = {
    is_educator: theme.customer ? !theme.customer.is_learner : false,
  };

  function init() {
    $(document).on('submit', '[data-create-resource]', createResource);
    $(document).on('click', '[data-resource-delete]', deleteResource);
    $(document).on('change', '#file_upload', handleFileChange);
    $(document).on(
      'change',
      '[data-create-resource] input[type="radio"]',
      toggleResourceType
    );
  }

  function getResources(activity_resources) {
    let url = cache.is_educator
      ? '/collections/' + theme.customer.id + '?view=resources'
      : '/account?view=resources';

    var promise = new Promise(function (resolve, reject) {
      $.ajax({
        url: url,
        method: 'GET',
        success: function (r) {
          if (cache.is_educator) {
            resolve(_reduceEducatorResources(r, activity_resources));
          } else {
            resolve(_reduceLearnerResources(r));
          }
        },
        error: function (r) {
          console.error(
            '----- ---------------------------------------------------- -----'
          );
          console.error(
            '----- An error has occured fetching educator resources -----'
          );
          console.error(r.responseText);
          console.error(
            '----- ---------------------------------------------------- -----'
          );
          reject(r.responseText);
        },
      });
    });

    promise.then(function (r) {
      cache.resources = r;
    });

    return promise;
  }

  function createResource(e) {
    e.preventDefault();

    const form_array = $('[data-create-resource]').serializeArray();
    const error_string = _validateResource(form_array);
    const target = $(this).attr('data-target');

    if (error_string) {
      $('[data-create-resource] .error').html(error_string);
      return;
    } else {
      $('[data-create-resource] .error').html('');
    }

    theme.Global.generateModal('ring', 'Saving', 'Please wait...');
    const formatted_data = _handleDataFormatting(form_array);

    const promise = new Promise(function (resolve) {
      const params = {
        type: 'POST',
        data: JSON.stringify(formatted_data),
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: function (res) {
          res.resource.created_at = res.resource.created_at.substring(0, 10);
          res.resource['when'] = formatted_data.resource.when;
          res.resource['type'] = formatted_data.resource.type;
          cache.resources[res.resource.id] = res.resource;

          theme.ActivitiesEdit.updateResources(
            cache.resources[res.resource.id],
            target
          );
          $.fancybox.close(true);
        },
        error: function (err) {
          console.error(err);
          $.fancybox.open('An error has occured. Contact your administrator.');
        },
        complete: function (r) {
          resolve(JSON.parse(r.responseText));
        },
      };
      proxyApp.request(
        `/collections/${encodeURIComponent(
          theme.customer.collection_id
        )}/resources`,
        params
      );
    });

    return promise;
  }

  function _validateResource(form_array) {
    let error_string = 'Please fill out the following fields:  ';
    let error_arr = [];

    $.each(form_array, function (i, field) {
      if (!field.value) {
        error_arr.push(
          field.name.charAt(0).toUpperCase() + field.name.slice(1)
        );
      }
    });

    if (error_arr.length) {
      return `<p>${error_string} <ul>${error_arr
        .map((err) => `<li>${err}</li>`)
        .join('')}</ul></p>`;
    } else {
      return false;
    }
  }

  function deleteResource(e) {
    e.preventDefault();
    const $resource_markup = $(this).parent();
    const resource_id = this.id;
    theme.Global.showLoadingButton($(this), true);
    $(this).attr('disabled', true);

    const promise = new Promise(function (resolve) {
      const params = {
        type: 'DELETE',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: function (res) {
          $resource_markup.remove();
          $('[data-add-resource]').attr('disabled', false);
        },
        error: function (err) {
          console.error(err);
          $.fancybox.open('An error has occured. Contact your administrator.');
        },
        complete: function (r) {
          resolve(JSON.parse(r.responseText));
          $(this).attr('disabled', false);
          theme.Global.showLoadingButton($(this), false);
        },
      };
      proxyApp.request(
        `/collections/${theme.customer.collection_id}/resources/${resource_id}`,
        params
      );
    });

    return promise;
  }

  function _handleDataFormatting(form_array) {
    const data_obj = { resource: {} };
    form_array.forEach(function (el) {
      data_obj.resource[el.name] = el.value;
    });

    return data_obj;
  }

  function _reduceLearnerResources(response) {
    var resources = JSON.parse(response).payload;
    var result = {};

    $.each(resources, function (index, resource) {
      if (result[resource.id]) {
        result[resource.id].activities.push({
          title: resource.activity_title,
          when: resource.when,
        });
        return;
      }

      result[resource.id] = {
        title: resource.title,
        link: resource.link,
        created_at: resource.created_at,
        type: resource.type,
        id: resource.id,
        participant: resource.participant,
        activities: [
          {
            title: resource.activity_title,
            when: resource.when,
          },
        ],
      };
    });

    return result;
  }

  function _reduceEducatorResources(response, activity_resources) {
    var resources = JSON.parse(response);
    var result = { before: [], after: [] };

    $.each(resources, function (index, resource) {
      if (activity_resources) {
        if (
          activity_resources.before.includes(resource.id) ||
          activity_resources.after.includes(resource.id)
        ) {
          const when = activity_resources.before.includes(resource.id)
            ? 'before'
            : 'after';
          result[when].push({
            title: resource.title,
            link: resource.link,
            type: resource.type,
            created_at: resource.created_at,
            id: resource.id,
          });
        }
      }
    });

    return result;
  }

  function openCreateResource() {
    const target = $(this).attr('data-target');
    const when = $(this).attr('data-when');

    const content = `
      <div class="account-resource-create">
        <h2 class="account-resource-create__title">Add a Resource</h2>
        <form data-create-resource data-target='${target}'>
          <input type="hidden" name="collection_id" value="${theme.customer.collection_id}" />
          <input type="hidden" name="when" value="${when}" />

          <div class="account-resource-create__name row">
            <label class='row__title' for="resource_title">Name your resource. Max 30 characters</label>
            <input type="text" name="title" id="resource_title">
          </div>

          <div class="row">
            <label class='row__title'>Choose your resource type.</label>

            <div class='row__checkboxes'>
              <div class='row__checkbox'>
                <input id='resource-type-file' type="radio" name="type" checked value="file" />
                <label for='resource-type-file' class="account-resource-create__radio-label account-resource-create__radio-label--file">
                  <span>File</span>
                  <span class="account-resource-create__radio-label--fine">Max 5 MB.</span>
                </label>
              </div>

              <div class='row__checkbox'>
                <input id='resource-type-link' type="radio" name="type" value="link" />
                <label for='resource-type-link' class="account-resource-create__radio-label">Link</label>
              </div>
            </div>
          </div>

          <div class='row'>
            <div class="account-resource-create__file">
              <label for="file_upload" class="btn btn--primary">Choose</label>
              <input type="file" id="file_upload" data-resource-type />
              <input type="hidden" name="base64" data-resource-type style="display:none"/>
            </div>
            <div class="account-resource-create__link">
              <label for="link">Paste the link to the resource below.</label>
              <input type="text" id="link" name="link" data-resource-type disabled/>
            </div>
          </div>
          <div class="account-resource-create__actions row">
            <div class='error'></div>

            <button type="submit" disabled class="btn btn--primary btn--round account__resource--create">Create</button>
          </div>
        </form>
      </div>
    `;

    $.fancybox.open(content);
  }

  function handleFileChange(e) {
    if (this.files[0].size >= 5242880) {
      $.fancybox.open(
        '<h2>Oops!</h2><p>File size exceeds 5MB limit. Please choose a smaller file.</p>'
      );
      return false;
    }
    _getBase64(this.files[0]).then((b64) => {
      $('[name="base64"]').val(b64);
      $('.account__resource--create').attr('disabled', false);
    });
  }

  function _getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        let encoded = reader.result.toString();
        resolve(encoded);
      };
      reader.onerror = (error) => reject(error);
    });
  }

  function toggleResourceType() {
    const type = $(this).val();

    $('[data-resource-type]').each((_, el) => {
      if ($(el).attr('disabled')) {
        $(el).attr('disabled', false);
      } else {
        $(el).attr('disabled', true);
      }
    });

    if (type === 'link') {
      $('.account__resource--create').attr('disabled', false);
      $('input[name="base64"]').attr('disabled', true);
      $('.account-resource-create__link').show();
      $('.account-resource-create__file').hide();
    } else {
      if (!$('input[name="base64"]').val()) {
        $('.account__resource--create').attr('disabled', true);
      }
      $('input[name="base64"]').attr('disabled', false);
      $('.account-resource-create__link').hide();
      $('.account-resource-create__file').show();
    }
  }

  return {
    init: init,
    createResource: createResource,
    getResources: getResources,
    deleteResource: deleteResource,
    openCreateResource: openCreateResource,
  };
})();

theme.Shopify = (function () {
  var cache = {};

  function init() {
    $(document).on('submit', '[data-product-form]', addItemFromForm);
    $(document).on('click', '[data-cart-popup-close]', closeCartPopup);
  }

  function _createId(length) {
    var characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    var id = '';

    for (var i = 0; i < length; i++) {
      id += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return id;
  }

  function addItemFromForm(e) {
    e.preventDefault();
    var $form = $(this);

    cache.previouslyFocusedElement = document.activeElement;

    if ($form.find("[name='properties[_unique]']").length > 0) {
      $form.find("[name='properties[_unique]']").val(_createId(10));
    }

    var promise = new Promise(function (resolve, reject) {
      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: $form.serialize(),
        dataType: 'json',
        success: resolve,
        error: reject,
      };
      $.ajax(params);
    });

    promise
      .then(function (item) {
        fetch('/cart.js')
          .then((response) => {
            return response.json();
          })
          .then((cart) => {
            $('[data-cart-count-bubble]').html(cart.item_count);

            var note = {};
            var headers = new Headers({ 'Content-Type': 'application/json' });

            $.each(cart.attributes, function (unique, profile_id) {
              note[unique] = '';
            });

            $.each(cart.items, function (index, item) {
              note[item.properties['_unique']] = item.properties['_profile_id'];
            });

            var request = {
              method: 'POST',
              headers: headers,
              body: JSON.stringify({ attributes: note }),
            };

            fetch('/cart/update.js', request).catch();
          });

        var string = `
        <div class="cart-popup" data-cart-popup tabindex="-1">
          <div class='cart-popup__header'>
            <span class='h2'>Just added to your cart</span>
            <button class="naked-link cart-popup__close" aria-label="Close" data-cart-popup-close></button>
          </div>
          <div class='cart-popup__item'>
            <div class='cart-popup__item-image image-wrapper'>
              <img src='${item.featured_image.url}' alt='' />
            </div>
            <div class='cart-popup__item-info'>
              <label class='cart-popup__item-info--title'>${item.title}</label>
              <span class='cart-popup__item-info--price'>$${(
                item.price / 100
              ).toFixed(0)}</span>
            </div>
          </div>
          <a href="/cart" class="cart-popup__view small btn btn--primary btn--full">
            View Cart
          </a>
        </div>`;

        $('body').append(string);

        slate.a11y.trapFocus({
          container: document.querySelector('[data-cart-popup]'),
          elementToFocus: document.querySelector('[data-cart-popup]'),
          namespace: 'cartPopup',
        });

        setTimeout((e) => {
          theme.Shopify.closeCartPopup();
        }, 5000);
      })
      .catch(function (r) {
        if (r.responseText) {
          r = JSON.parse(r.responseText);
        }
        console.error(r);
        cache.previouslyFocusedElement.focus();
      });

    return promise;
  }

  function closeCartPopup(e) {
    slate.a11y.removeTrapFocus({
      container: document.querySelector('[data-cart-popup]'),
      namespace: 'cartPopup',
    });

    $('[data-cart-popup]').fadeOut(600);

    if (typeof cache.previouslyFocusedElement != 'undefined') {
      cache.previouslyFocusedElement.focus();
    }
  }

  return {
    init: init,
    closeCartPopup: closeCartPopup,
  };
})();

theme.Time = (function () {
  var cache = {
    hours: [
      '12',
      '01',
      '02',
      '03',
      '04',
      '05',
      '06',
      '07',
      '08',
      '09',
      '10',
      '11',
    ],
    weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    weekdays_long: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ],
    months: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
  };

  function init() {
    $('[data-shop-time]').arrive(buildDisplayTime);
  }

  function buildDisplayTime() {
    var datetime = $(this).attr('data-shop-datetime');

    $(this).html(
      "<span class='datetime'>" + convertTimeToLocal(datetime) + '</span>'
    );
  }

  function getCurrentTime(timezone) {
    var date = new Date()
      .toLocaleString('en-CA', {
        timeZone: timezone
          ? timezone
          : Intl.DateTimeFormat().resolvedOptions().timeZone,
      })
      .replace(',', '')
      .replace('p.m.', 'PM')
      .replace('a.m.', 'AM');

    return (
      date.slice(0, date.lastIndexOf(':')) +
      date.slice(date.lastIndexOf(':') + 3)
    );
  }

  function stripSeconds(value) {
    return (
      value.slice(0, value.lastIndexOf(':')) +
      value.slice(value.lastIndexOf(':') + 3)
    );
  }

  function normalizeDateString(value) {
    return value.replace(/-/g, '/').replace('\u202f', ' ').trim();
  }

  function getSourceTimezone() {
    return theme.sourceTimezone || 'America/Vancouver';
  }

  function parseNaiveDateParts(value) {
    var match = normalizeDateString(value).match(
      /^(\d{4})\/(\d{1,2})\/(\d{1,2})(?:\s+(\d{1,2})(?::(\d{2}))?(?:\s*([AP]M))?)?$/i
    );

    if (!match) {
      return null;
    }

    var hour = parseInt(match[4] || '0', 10);
    var meridiem = match[6] ? match[6].toUpperCase() : '';

    if (meridiem === 'PM' && hour < 12) {
      hour += 12;
    }

    if (meridiem === 'AM' && hour === 12) {
      hour = 0;
    }

    return {
      year: parseInt(match[1], 10),
      month: parseInt(match[2], 10),
      day: parseInt(match[3], 10),
      hour: hour,
      minute: parseInt(match[5] || '0', 10),
      second: 0,
    };
  }

  function getTimeZoneDateParts(date, timeZone) {
    var formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });
    var parts = {};

    formatter.formatToParts(date).forEach(function (part) {
      if (part.type !== 'literal') {
        parts[part.type] = part.value;
      }
    });

    return {
      year: parseInt(parts.year, 10),
      month: parseInt(parts.month, 10),
      day: parseInt(parts.day, 10),
      hour: parseInt(parts.hour, 10),
      minute: parseInt(parts.minute, 10),
      second: parseInt(parts.second, 10),
    };
  }

  function parseDateInTimezone(value, timeZone) {
    var dateParts = parseNaiveDateParts(value);

    if (!dateParts) {
      return new Date(normalizeDateString(value));
    }

    var utcGuess = new Date(
      Date.UTC(
        dateParts.year,
        dateParts.month - 1,
        dateParts.day,
        dateParts.hour,
        dateParts.minute,
        dateParts.second
      )
    );
    var zonedParts = getTimeZoneDateParts(utcGuess, timeZone);
    var zonedTime = Date.UTC(
      zonedParts.year,
      zonedParts.month - 1,
      zonedParts.day,
      zonedParts.hour,
      zonedParts.minute,
      zonedParts.second
    );
    var targetTime = Date.UTC(
      dateParts.year,
      dateParts.month - 1,
      dateParts.day,
      dateParts.hour,
      dateParts.minute,
      dateParts.second
    );

    return new Date(utcGuess.getTime() + (targetTime - zonedTime));
  }

  function getLocalTimezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  function convertTimeToSourceTimezone(date) {
    var parsedDate = new Date(normalizeDateString(date));

    if (isNaN(parsedDate.getTime())) {
      return date;
    }

    var localizedDate = parsedDate
      .toLocaleString('en-CA', { timeZone: getSourceTimezone() })
      .replace(',', '')
      .replace('p.m.', 'PM')
      .replace('a.m.', 'AM');

    return stripSeconds(localizedDate);
  }

  function convertTimeToLocal(date) {
    var localizedDate = parseDateInTimezone(date, getSourceTimezone())
      .toLocaleString('en-CA')
      .replace(',', '')
      .replace('p.m.', 'PM')
      .replace('a.m.', 'AM')
      .replace('\u202f', ' ');

    return stripSeconds(localizedDate);
  }

  function convertTimeToLocalInput(date) {
    var localizedDate = parseDateInTimezone(date, getSourceTimezone())
      .toLocaleString('en-US')
      .replace(',', '')
      .replace('p.m.', 'PM')
      .replace('a.m.', 'AM')
      .replace('\u202f', ' ');

    return stripSeconds(localizedDate);
  }

  function getTimezone() {
    return getSourceTimezone();
  }

  function getTimezoneName() {
    const dateString = new Date().toLocaleDateString('en-CA', {
      timeZoneName: 'long',
    });
    const timezone = dateString.split(', ')[1];

    const TIMEZONE_ABBREVIATION_MAP = {
      'Pacific Standard Time': 'PST',
      'Pacific Daylight Saving Time': 'PDT',
      'Mountain Standard Time': 'MST',
      'Mountain Daylight Saving Time': 'MDT',
      'Central Standard Time': 'CST',
      'Central Daylight Saving Time': 'CDT',
      'Eastern Standard Time': 'EST',
      'Eastern Daylight Saving Time': 'EDT',
      'Atlantic Standard Time': 'AST',
      'Atlantic Daylight Saving Time': 'ADT',
      'Newfoundland Standard Time': 'NST',
      'Newfoundland Daylight Saving Time': 'NDT',
    };

    return TIMEZONE_ABBREVIATION_MAP[timezone]
      ? TIMEZONE_ABBREVIATION_MAP[timezone]
      : timezone;
  }

  function convertTimeToDisplay(date, end_date) {
    var date = parseDateInTimezone(date, getSourceTimezone());

    var weekday =
      "<span class='weekday'>" +
      date.getFullYear() +
      ' ' +
      cache.weekdays[date.getDay()] +
      ', ' +
      cache.months[date.getMonth()] +
      ' ' +
      date.getDate() +
      '</span>';
    var time = '';

    if (end_date) {
      var start_period = (end_period = 'AM'),
        end_date = parseDateInTimezone(end_date, getSourceTimezone());

      if (date.getHours() > 11) {
        start_period = 'PM';
      }

      if (end_date.getHours() > 11) {
        end_period = 'PM';
      }

      var time =
        "<span class='time'>" +
        cache.hours[date.getHours() % 12] +
        ':' +
        ('0' + date.getMinutes()).slice(-2) +
        ' ' +
        start_period +
        ' - ' +
        cache.hours[end_date.getHours() % 12] +
        ':' +
        ('0' + end_date.getMinutes()).slice(-2) +
        ' ' +
        end_period +
        '</span>';
    }

    return weekday + time;
  }

  function convertTimeToDisplayDayOfWeekOnly(date) {
    var date = parseDateInTimezone(date, getSourceTimezone());

    var weekday =
      "<span class='weekday'>" + cache.weekdays_long[date.getDay()] + '</span>';

    return weekday;
  }

  function convertTimeToDisplayMonthAndDayOnly(date) {
    var date = parseDateInTimezone(date, getSourceTimezone());

    var weekday =
      "<span class='weekday'>" +
      cache.months[date.getMonth()] +
      ' ' +
      date.getDate() +
      '</span>';

    return weekday;
  }

  function convertTimeToDisplayDateOnly(date) {
    var date = parseDateInTimezone(date, getSourceTimezone());

    var weekday =
      "<span class='weekday'>" +
      cache.weekdays[date.getDay()] +
      ', ' +
      cache.months[date.getMonth()] +
      ' ' +
      date.getDate() +
      '</span>';

    return weekday;
  }

  function convertTimeToDisplayLongDateOnly(date) {
    var date = parseDateInTimezone(date, getSourceTimezone());

    var weekday =
      "<span class='weekday'>" +
      cache.weekdays_long[date.getDay()] +
      ', ' +
      cache.months[date.getMonth()] +
      ' ' +
      date.getDate() +
      '</span>';

    return weekday;
  }

  function convertTimeToDisplayDateAndYearOnly(date) {
    var date = parseDateInTimezone(date, getSourceTimezone());

    var weekday =
      "<span class='weekday'>" +
      cache.months[date.getMonth()] +
      ' ' +
      date.getDate() +
      ', ' +
      date.getFullYear() +
      '</span>';

    return weekday;
  }

  function convertTimeToDisplayTimeOnly(date, end_date) {
    var date = parseDateInTimezone(date, getSourceTimezone());

    var start_period = 'AM';

    if (date.getHours() > 11) {
      start_period = 'PM';
    }

    var start_time =
      "<span class='starttime'>" +
      cache.hours[date.getHours() % 12] +
      ':' +
      ('0' + date.getMinutes()).slice(-2) +
      ' ' +
      start_period +
      '</span>';
    var end_time = '';

    if (end_date) {
      var end_period = 'AM',
        end_date = parseDateInTimezone(end_date, getSourceTimezone());

      if (end_date.getHours() > 11) {
        end_period = 'PM';
      }

      end_time =
        "<span class='endtime'> - " +
        cache.hours[end_date.getHours() % 12] +
        ':' +
        ('0' + end_date.getMinutes()).slice(-2) +
        ' ' +
        end_period +
        '</span>';
    }

    return start_time + end_time;
  }

  init();

  return {
    getCurrentTime: getCurrentTime,
    getTimezone: getTimezone,
    getTimezoneName: getTimezoneName,
    getLocalTimezone: getLocalTimezone,
    convertTimeToSourceTimezone: convertTimeToSourceTimezone,
    convertTimeToLocal: convertTimeToLocal,
    convertTimeToLocalInput: convertTimeToLocalInput,
    convertTimeToDisplay: convertTimeToDisplay,
    convertTimeToDisplayDayOfWeekOnly: convertTimeToDisplayDayOfWeekOnly,
    convertTimeToDisplayMonthAndDayOnly: convertTimeToDisplayMonthAndDayOnly,
    convertTimeToDisplayDateOnly: convertTimeToDisplayDateOnly,
    convertTimeToDisplayLongDateOnly: convertTimeToDisplayLongDateOnly,
    convertTimeToDisplayDateAndYearOnly: convertTimeToDisplayDateAndYearOnly,
    convertTimeToDisplayTimeOnly: convertTimeToDisplayTimeOnly,
  };
})();

theme.Global = (function () {
  var cache = {
    active_profile: null,
    sliders: {},
  };

  function init() {
    window.addEventListener('load', function () {
      document.querySelector('body').style.opacity = 1;
    });

    $(document).on(
      'mouseenter focus',
      '.product-card__image',
      _handleCardImageMouseEnter
    );
    $(document).on(
      'mouseleave blur',
      '.product-card__image',
      _handleCardImageMouseLeave
    );

    $(document).on('click', '[data-tooltip]', buildTooltip);

    $(document).arrive('[multiple]', initializeMultiSelect);

    $(document).arrive('.date-time-picker', initializeDateTimePicker);
    $(document).arrive('.time-picker', initializeTimePicker);
    $(document).arrive('.date-picker', initializeDatePicker);
    $(document).arrive('.rich-text-editor', initializeRichTextEditor);

    document.querySelectorAll('[data-carousel]').forEach(initializeTinySlider);
  }

  /* Tinyslider */
  function initializeTinySlider(target) {
    if (target.dataset.carousel && target.dataset.carousel != '') {
      cache.sliders[target.dataset.carousel] = tns({
        preventScrollOnTouch: 'auto',
        mode: target.dataset.mode ? target.dataset.mode : 'carousel',
        container: '[data-carousel="' + target.dataset.carousel + '"]',
        items: target.dataset.items ? target.dataset.items : 1,
        slideBy: target.dataset.slideBy ? target.dataset.slideBy : 1,
        loop: target.dataset.loop ? target.dataset.loop == 'true' : true,
        controls: target.dataset.controls ? true : false,
        gutter: target.dataset.gutter ? parseInt(target.dataset.gutter) : 15,
        mouseDrag: true,
        nav: target.dataset.nav ? target.dataset.nav == 'true' : false,
        navPosition: target.dataset.navPosition
          ? target.dataset.navPosition
          : 'top',
        edgePadding: target.dataset.edgePadding
          ? safeParseInt(target.dataset.edgePadding)
          : 0,
        autoplay: false,

        autoplay: target.dataset.autoplay
          ? target.dataset.autoplay == 'true'
          : false,
        autoplayTimeout: target.dataset.autoplayTimeout
          ? safeParseInt(target.dataset.autoplayTimeout)
          : 5000,

        controlsText: [
          "<span class='material-icons'>arrow_back_ios</span>",
          "<span class='material-icons'>arrow_forward_ios</span>",
        ],

        responsive: {
          [window.theme.breakpoints.tablet]: {
            items: target.dataset.itemsTablet
              ? target.dataset.itemsTablet
              : target.dataset.items
              ? target.dataset.items
              : 1,
            gutter: target.dataset.gutterTablet
              ? safeParseInt(target.dataset.gutterTablet)
              : target.dataset.gutter
              ? safeParseInt(target.dataset.gutter)
              : 15,
            disable: target.dataset.disableTablet
              ? target.dataset.disableTablet == 'true'
              : false,
          },
          [window.theme.breakpoints.desktop]: {
            items: target.dataset.itemsDesktop
              ? target.dataset.itemsDesktop
              : target.dataset.itemsTablet
              ? target.dataset.itemsTablet
              : target.dataset.items
              ? target.dataset.items
              : 1,
          },
        },
      });

      return cache.sliders[target.dataset.carousel];
    }
  }
  /**/

  /* Chosen */
  function initializeMultiSelect() {
    $(this).chosen();
    _configureSearchableSelect();
  }

  function _configureSearchableSelect() {
    const $searchableSelect = $('.searchable_select');
    const $chosenContainer = $('.chosen-container');

    $chosenContainer.on('click', function () {
      if ($chosenContainer.hasClass('dropdown-open')) {
        $searchableSelect.trigger('chosen:close');
      } else {
        $chosenContainer.addClass('dropdown-open');
      }
    });

    $searchableSelect.on('change', function (e, params) {
      setTimeout(function () {
        $searchableSelect.trigger('chosen:close');
        $chosenContainer.removeClass('dropdown-open');
      }, 0);
    });

    $searchableSelect.on('chosen:hiding_dropdown', function () {
      $chosenContainer.removeClass('dropdown-open');
    });
  }
  /**/

  /* Datetime picker */
  function initializeTimePicker() {
    $(this).datetimepicker({
      format: 'g:i A',
      datepicker: false,
      validateOnBlur: false,
    });
  }

  function initializeDatePicker() {
    $(this).datetimepicker({
      format: 'Y-m-d',
      timepicker: false,
      validateOnBlur: false,
    });
  }

  function initializeDateTimePicker() {
    if (this.id === 'date_of_birth') {
      $(this).datetimepicker({ timepicker: false, format: 'Y-m-d' });
    } else {
      $(this).datetimepicker({
        format: 'm/d/Y g:i A',
        formatTime: 'g:i A',
        validateOnBlur: false,
        minDate: 0,
      });
    }
  }
  /**/

  function safeParseInt(str) {
    const parsed = Number.parseInt(str, 10);
    if (Number.isNaN(parsed)) {
      return 0;
    }

    return parsed;
  }

  function initializeRichTextEditor() {
    return new Quill('.rich-text-editor', {
      theme: 'snow',
    });
  }

  function showLoadingButton($button, show) {
    if (show) {
      if ($button.find('.btn-loading').length == 0) {
        $button.append(
          `<div class="rubik-loading btn-loading"><img src='https://cdn.shopify.com/s/files/1/0450/1418/8196/files/RUBIK_1.gif?v=1650659116' alt='Rubiks cube loading icon'></div>`
        );
        $button.css('color', 'transparent');
      }
    } else {
      $button.css('color', 'initial');
      $('.rubik-loading.btn-loading').remove();
    }
  }

  function showLoadingOverlay(show, $parentContext, message) {
    if (show) {
      $parentContext.prepend(
        `<div class="rubik-loading overlay"><p class="loading_message">${
          message ? message : ''
        }</p><img src='https://cdn.shopify.com/s/files/1/0450/1418/8196/files/RUBIK_1.gif?v=1650659116' alt='Rubiks cube loading icon'></div>`
      );
    } else {
      $('.rubik-loading.overlay').remove();
    }
  }

  /**
   * PROFILES
   *
   *
   */

  function smoothScroll(target) {
    var scrollContainer = target;
    do {
      //find scroll container
      scrollContainer = scrollContainer.parentNode;
      if (!scrollContainer) return;
      scrollContainer.scrollTop += 1;
    } while (scrollContainer.scrollTop == 0);
    var targetY = 0;
    do {
      //find the top of target relatively to the container
      if (target == scrollContainer) break;
      targetY += target.offsetTop;
    } while ((target = target.offsetParent));
    scroll = function (c, a, b, i) {
      i++;
      if (i > 30) return;
      c.scrollTop = a + ((b - 100 - a) / 30) * i; // offset 100px due to fixed header
      setTimeout(function () {
        scroll(c, a, b, i);
      }, 20);
    };
    // start scrolling
    scroll(scrollContainer, scrollContainer.scrollTop, targetY, 0);
  }

  function getGlobalCache() {
    return cache;
  }

  function buildTooltip(e) {
    e.preventDefault();

    var content = $(this).find('[data-tooltip-content]').html();
    $.fancybox.open("<div class='modal'>" + content + '</div>');
  }

  function generateModal(type, title, content, code, action) {
    var string = "<div class='modal'> \
      <div class='modal__container'>";

    if (title && title != '') {
      string += "<h2 class='modal__title'>" + title + '</h2>';
    }

    if (type && type == 'ring') {
      string +=
        " \
        <div class='modal__graphic'> \
          <img src='https://cdn.shopify.com/s/files/1/0450/1418/8196/files/RUBIK_1.gif?v=1650659116' alt='Rubiks cube loading icon'> \
        </div>";
    }

    if (content && content != '') {
      string += "<div class='modal__content'>" + content + '</div>';
    }

    if (code && code != '') {
      if (typeof code == 'object' && code.responseJSON) {
        if (typeof code.responseJSON.error == 'object') {
          var json = code.responseJSON.error;
        } else {
          var json = code.responseJSON.error;
        }

        string +=
          "<div class='modal__code'><strong>Error " +
          code.status +
          '</strong><br/>' +
          json.message +
          '</div>';
      } else if (typeof code == 'object') {
        string += "<pre class='modal__code'>Error " + code.status + '</pre>';
      } else {
        string += "<pre class='modal__code'>" + code + '</pre>';
      }
    }

    if (action) {
      string += action;
    }
    string += ' \
        </div> \
      </div>';

    $.fancybox.open(string);

    return string;
  }

  function _handleCardImageMouseEnter() {
    var video = $(this).attr('data-video');
    var image = $(this).attr('data-image');

    if (video) {
      var string =
        " \
	    <video playsinline='playsinline' autoplay='autoplay' preload='auto' muted='muted' data-src='" +
        video +
        "' poster='" +
        image +
        "'> \
          <source src='" +
        video +
        "' type='video/mp4'> \
        </video>";

      $(this).append(string);
    }
  }

  function _handleCardImageMouseLeave() {
    const $video = $(this).children('video');

    if ($video.length > 0) {
      $video.remove();
    }
  }

  /**
   * Initializes Slick slider to display product images/videos within existing '.slider-for' and '.slider-nav' containers
   *
   * @param {object} activity An object containing media data for an activity
   */

  function buildProductImages(activity) {
    const length = activity.media.length;

    $.each(activity.media, function (index, media) {
      if (media.type === 'image') {
        $('.slider-for').append(
          `<div class="product__image" alt="">${media.markup}</div>`
        );
        if (length > 1) {
          $('.slider-nav').append(
            `<div class="product__thumbnail" alt="${activity.title} image thumbnail">${media.markup}</div>`
          );
        }
      } else {
        $('.slider-for').prepend(
          `<div class="product__image" alt="">${media.markup}</div>`
        );
        if (length > 1) {
          $('.slider-nav').prepend(
            `<div class="product__thumbnail"><img src="${media.src}" alt="${activity.title} image thumbnail"></div>`
          );
        }
      }
    });

    $('.slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.slider-nav',
    });
    $('.slider-nav').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      dots: false,
      focusOnSelect: true,
    });
  }

  function copyToClipboard(value, showNotification, notificationText) {
    var $temp = $('<input>');
    $('body').append($temp);
    $temp.val(value).select();
    document.execCommand('copy');
    $temp.remove();

    if (typeof showNotification === 'undefined') {
      showNotification = true;
    }
    if (typeof notificationText === 'undefined') {
      notificationText = 'Copied to clipboard';
    }

    var notificationTag = $('div.copy-notification');
    if (showNotification && notificationTag.length == 0) {
      notificationTag = $('<div/>', {
        class: 'copy-notification',
        text: notificationText,
      });
      $('body').append(notificationTag);

      notificationTag.fadeIn('slow', function () {
        setTimeout(function () {
          notificationTag.fadeOut('slow', function () {
            notificationTag.remove();
          });
        }, 1000);
      });
    }
  }

  function renderActivityDuration(minutes) {
    let hours = Math.round((minutes / 60) * 10) / 10;

    if (minutes % 60 !== 0) {
      hours = hours.toFixed(1);
    }

    return `${hours} hour${minutes <= 60 ? '' : 's'}`;
  }

  function addProtocolToLink(url) {
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }

    return `https://${url}`;
  }

  return {
    init: init,
    generateModal: generateModal,
    showLoadingOverlay: showLoadingOverlay,
    showLoadingButton: showLoadingButton,
    smoothScroll: smoothScroll,
    getGlobalCache: getGlobalCache,
    buildProductImages: buildProductImages,
    copyToClipboard: copyToClipboard,
    initializeMultiSelect: initializeMultiSelect,
    initializeTinySlider: initializeTinySlider,
    renderActivityDuration: renderActivityDuration,
    addProtocolToLink: addProtocolToLink,
    safeParseInt: safeParseInt,
  };
})();

theme.Account = (function () {
  var cache = {
    $account_body: $('.account-body'),
    $account_content: $('.account-content'),
    $account_actions: $('.account-actions'),
  };

  function init() {
    _preloadUserActivities();
  }

  /**
   * Begins loading all of the user's activities
   *
   * @see getUserActivities
   */
  function _preloadUserActivities() {
    getUserActivities();
  }

  function getUserActivities() {
    return new Promise(function (resolve) {
      if (theme.customer.user_activities) {
        resolve(theme.customer.user_activities);
      } else {
        var params = {
          url: '/account?view=activities',
          method: 'GET',
          complete: function (r) {
            if (r.status == 200) {
              theme.customer.user_activities = JSON.parse(r.responseText);
            } else {
              theme.customer.user_activities = [];
            }
            resolve(theme.customer.user_activities);
          },
        };
        $.ajax(params);
      }
    });
  }

  function reset() {
    cache.$account_content.empty();
  }

  function getBody() {
    return cache.$account_body;
  }

  function getContent() {
    return cache.$account_content;
  }

  function getActions() {
    return cache.$account_actions;
  }

  return {
    init: init,
    reset: reset,
    getBody: getBody,
    getContent: getContent,
    getActions: getActions,
    getUserActivities: getUserActivities,
  };
})();

theme.AccountNavigation = (function () {
  var cache = {
    $navigation_selector: $('[data-account-dropdown]'),
    $navigation_tabs: $('[data-account-tab]'),
    session: 'active_account_navigation',
  };

  function AccountNavigation(container) {
    theme.Account.init();

    cache.$navigation_tabs.on('focus', _checkEducatorProfileFormCompletion);
    cache.$navigation_tabs.on('click', _setSelectedTab);
    cache.$navigation_selector.on('focus', _checkEducatorProfileFormCompletion);
    cache.$navigation_selector.on('change', _setSelectedTab);

    var initial_navigation = cache.$navigation_selector.val();

    const parameters = new URLSearchParams(window.location.search);

    if (parameters.get('q')) {
      initial_navigation = parameters.get('q');
      window.history.replaceState({}, document.title, '/' + 'account');
    } else if (theme.customer.is_learner) {
      initial_navigation = 'learner-realtime-activities';
    } else {
      initial_navigation = 'educator-activities';
    }

    _setSelectedTab(initial_navigation);
  }

  function _checkEducatorProfileFormCompletion(e) {
    if (
      sessionStorage.getItem('active_account_navigation') !== 'educator-profile'
    ) {
      return;
    }

    if (theme.EducatorProfile.isFormDirty()) {
      theme.EducatorProfile.showDirtyFormModal();
    }
  }

  function _setSelectedTab(navigation) {
    // New Learner Tabs
    if (
      (typeof navigation === 'string' && navigation.startsWith('learner-')) ||
      (typeof navigation === 'object' &&
        this.hasAttribute('data-account-learner-tab'))
    ) {
      let tab = navigation;

      if (
        typeof navigation === 'object' &&
        this.hasAttribute('data-account-learner-tab')
      ) {
        tab = this.getAttribute('data-account-learner-tab');
      }

      cache.$navigation_tabs.attr('aria-selected', false);
      cache.$navigation_tabs
        .filter("[aria-controls='" + tab + "']")
        .attr('aria-selected', true);

      _setSelectedBlock(tab);
    } else {
      // Old Guide Tabs
      if (typeof navigation == 'string') {
        cache.$navigation_selector.val(navigation).change();
      } else if ($(this).is('button')) {
        cache.$navigation_selector.val($(this).attr('aria-controls')).change();
      } else {
        var block = $(this).val();

        cache.$navigation_tabs.attr('aria-selected', false);
        cache.$navigation_tabs
          .filter("[aria-controls='" + block + "']")
          .attr('aria-selected', true);

        _setSelectedBlock(block);
      }
    }
  }

  function _setSelectedBlock(block) {
    if (!block) {
      return;
    }

    let navigation = block;
    if (block.startsWith('learner-')) {
      navigation = 'learner-activities';
    }

    sessionStorage.setItem(cache.session, block);

    theme.Account.reset();
    theme.Account.getBody().attr('id', block);

    switch (navigation) {
      case 'educator-activities':
        dom_string = theme.EducatorActivities.init();
        break;
      case 'educator-profile':
        dom_string = theme.EducatorProfile.init();
        break;
      case 'learner-activities':
        theme.LearnerActivities.init(block);
        break;
      case 'admin-activities':
        theme.AdminActivities.init();
        break;

      default:
        dom_string = _domError();
    }
  }

  // TODO: Make a good error page.
  function _domError() {
    return '<label>THIS IS THE ERROR PAGE</label>';
  }

  return AccountNavigation;
})();

theme.AdminActivities = (function () {
  var cache = {};

  function getCache() {
    return cache;
  }

  function init(container) {
    if (!cache.loaded) {
      document
        .querySelector('[data-account-content]')
        .classList.add('admin-account');

      // Activity Table Functions
      $(document).on(
        'change',
        '[data-educator-list]',
        _fetchAndBuildEducatorActivityList
      );
      $(document).on('click', '[data-admin-edit]', theme.ActivitiesEdit.edit);
    }
    /*
      if(!cache.loaded) {      
        // Click on the edit button to get activity data and build the forms.
          $(document).on("click", "[data-edit-activity]", theme.ActivitiesEdit.edit);

        // Click on any view to return to activities listing
          $(document).on("click", "[data-activities-back]", theme.EducatorActivities.init)
      }
    */
    buildEducatorList();

    cache.loaded = true;
  }

  function buildEducatorList() {
    new Promise((resolve) => {
      var params = {
        url: '/collections?view=json',
        method: 'GET',
        complete: function (r) {
          if (r.status == 200) {
            response = JSON.parse(r.responseText);
          }
          resolve(response);
        },
      };
      $.ajax(params);
    }).then((collections) => {
      var educator_list = '';

      for (const handle in collections) {
        if (!/[a-zA-Z]/.test(handle)) {
          educator_list += `<option value='${handle}:${collections[handle].id}'>${collections[handle].title}</option>`;
        }
      }

      var string = `
        <div class='admin__actions'>
          <select class='admin__actions-educators' id='educator-list' data-educator-list>
            <option value=''>Select a Profile</option>
            ${educator_list}
          </select>
        </div>
        <table class='admin-table'>
          <thead>
            <tr>
              <th class='admin-table__image'></th>
              <th class='admin-table__activity'>Activity</th>
              <th class='admin-table__status'>Status</th>
              <th class='admin-table__icons'></th>
            </tr>
          </thead>
          <tbody data-admin-activities>
            <tr>
              <td colspan='4' style='text-align: center;'>
                No profile selected
              </td>
            </tr>
          </tbody>
        </table>
      `;

      document.querySelector('[data-account-content]').innerHTML = string;
    });
  }

  function _fetchAndBuildEducatorActivityList() {
    if (this.value == '') {
      document.querySelector('[data-admin-activities]').innerHTML = `
        <tr>
          <td colspan='4' style='text-align: center;'>
            No profile selected
          </td>
        </tr>
      `;

      return;
    }

    const collection_handle = this.value.split(':')[0];
    const collection_id = this.value.split(':')[1];

    theme.customer.id = collection_handle;
    theme.customer.collection_id = collection_id;

    theme.Resources.getResources();

    new Promise((resolve) => {
      var params = {
        url: `/collections/${collection_handle}?view=educator_activities`,
        method: 'GET',
        complete: function (r) {
          if (r.status == 200) {
            response = JSON.parse(r.responseText);
          }
          resolve(response);
        },
      };
      $.ajax(params);
    }).then((activities) => {
      var activity_list = '';

      for (const activity_id in activities.payload) {
        var activity = activities.payload[activity_id];

        theme.Activities.setActivityData(activity);

        const firstImageMedia = activity.media.find((m) => m.type === 'image');
        activity_list += `
          <tr>
            <td class='admin-table__image'>${
              firstImageMedia ? firstImageMedia.markup : ''
            }</td>
            <td class='admin-table__activity'>${activity.title}</td>
            <td class='admin-table__status'>${activity.status}</td>
            <td class='admin-table__icons'>
              <div role='button' tabindex='0' class='admin-table__icons--action' data-admin-edit='${activity_id}' data-activity-id='${activity_id}'>
                <span class="material-icons">edit</span>
              </button>
              <a class='admin-table__icons--action' href='${activity.url}'>
                <span class="material-icons">visibility</span>
              </a>
            </td>
          </tr>
        `;
      }

      document.querySelector('[data-admin-activities]').innerHTML =
        activity_list;
    });
  }

  return {
    init: init,
    getCache: getCache,
  };
})();

theme.ActivitiesEdit = (function () {
  var cache = {
    info_change: false,
    type_map: {
      draft: 'In Draft',
      pending: 'In Review',
      rejected: 'Rejected',
      live: 'Available',
    },
  };

  function _init() {
    $(document).on('click', '[edit-accordion-toggle]', _toggleEditAccordion);
    $(document).on('click', '[edit-accordion-close]', _closeEditAccordion);
    $(document).on('click', '[edit-accordion-next]', _nextEditAccordion);

    $(document).on('keyup', "[name='map:title']", _updateEditDisplayTitle);

    $(document).on('click', '[edit-add-timeslot]', _renderTimeslot);
    $(document).on('click', '[edit-remove-timeslot]', _removeTimeslot);

    $(document).on('click', '[edit-add-session]', _renderSession);

    $(document).on(
      'click',
      '[data-add-resource]',
      theme.Resources.openCreateResource
    );

    $(document).on(
      'change',
      '[data-activity-image]',
      _handleActivityImageUpload
    );
    $(document).on('click', '[data-delete-image]', removeImage);
    $(document).on(
      'change',
      '[data-activity-video]',
      _handleActivityVideoUpload
    );
    $(document).on(
      'click',
      '[data-activity-video-discard]',
      _handleActivityVideoDelete
    );

    $(document).on('click', '[data-save-activity]', _saveAndExitActivity);
    $(document).on('click', '[data-submit-activity]', _saveAndPreviewActivity);
    $(document).on('click', '[data-delete-activity]', _confirmDeleteActivity);
    $(document).on('click', '[data-delete-activity-confirm]', _deleteActivity);

    $(document).on('change', '[name]', function () {
      if ($(this).attr('name').indexOf('variant') == -1) {
        cache.info_change = true;
      }
    });
  }

  function _updateEditDisplayTitle() {
    $('[data-edit-title]').html($(this).val());
  }

  function _syncSavedActivity(activity) {
    cache.activity = activity;
    cache.info_change = false;

    $("[name='map:id']").val(activity.id);
    $("[name='map:status']").val(activity.status);

    $("[name='map:variants().id']").each(function (index) {
      var variant = activity.variants && activity.variants[index];
      $(this).val(variant ? variant.id : null);
    });

    $("[name='map:variants[].price']").each(function (index) {
      var variant = activity.variants && activity.variants[index];
      $(this).val(variant ? variant.price : $(this).val());
    });
  }

  function _saveAndExitActivity() {
    var activity_data = theme.Activities.formatActivityData();

    if (_validateActivity(activity_data.activity, true)) {
      var was_new_activity = cache.activity.id == 0;

      theme.Global.generateModal(
        'ring',
        'Saving your activity',
        'Please wait...'
      );

      theme.Activities.saveActivity(activity_data).then(function (r) {
        _syncSavedActivity(r);

        var promise = new Promise((resolve) => {
          if (was_new_activity) {
            theme.ActivitiesEdit.uploadImages(r.id).then(() => {
              resolve();
            });
          } else {
            resolve();
          }
        });

        promise.then(() => {
          if (theme.customer.access == 'admin') {
            theme.Account.reset();
            theme.AdminActivities.init();
          } else {
            theme.Account.reset();
            theme.EducatorActivities.init();
          }
        });
      });
    }
  }

  function _saveAndPreviewActivity() {
    var activity_data = theme.Activities.formatActivityData();

    if (_validateActivity(activity_data.activity)) {
      var was_new_activity = cache.activity.id == 0;

      theme.Global.generateModal(
        'ring',
        'Building Activity Preview',
        'Please wait...'
      );

      theme.Activities.saveActivity(activity_data).then(function (activity) {
        _syncSavedActivity(activity);

        var promise = new Promise((resolve) => {
          if (was_new_activity) {
            theme.ActivitiesEdit.uploadImages(activity.id).then(() => {
              resolve();
            });
          } else {
            resolve();
          }
        });

        promise.then(() => {
          window.location.href = activity.url;
        });
      });
    }
  }

  function _confirmDeleteActivity() {
    var activity_id = $(this).attr('data-delete-activity');

    var string =
      " \
      <div class='modal'> \
        <h2>Are you sure you want to delete?</h2> \
        <div class='account-activity__planning--actions-confirm'> \
          <button class='btn btn--error' data-delete-activity-confirm='" +
      activity_id +
      "'>Delete</button> \
          <button class='btn btn--secondary' onclick='$.fancybox.close()'>Cancel</button> \
        </div> \
      </div>";

    $.fancybox.open(string);
  }

  function _deleteActivity() {
    theme.Global.generateModal(
      'ring',
      'Deleting your activity',
      'Please wait...'
    );

    theme.Activities.deleteActivity(
      $(this).attr('data-delete-activity-confirm')
    ).then(function (r) {
      $.fancybox.close(true);

      theme.Account.reset();

      if (theme.customer.access == 'admin') {
        theme.AdminActivities.init();
      } else {
        theme.EducatorActivities.init();
      }
    });
  }

  function _validateActivity(activity, soft_mode) {
    var error = [];

    if (activity.title.trim().length == 0) {
      error.push({
        target: 'map:title',
        message: 'You missed a section!',
      });
    }

    if (
      activity.product_type !== 'Anytime' &&
      activity.variants &&
      activity.variants.length > 0
    ) {
      activity.variants.forEach((variant, index) => {
        if (!Date.parse(variant.info.start_date.replace(/-/g, '/'))) {
          error.push({
            target: 'map:variants[].info.start_date|' + index,
            message: 'Invalid date!',
          });
        } else if (variant.info.start_date.trim() == '') {
          error.push({
            target: 'map:variants[].info.start_date|' + index,
            message: 'You missed a section!',
          });
        }

        if (
          variant.info.max_participants <= 0 ||
          variant.info.max_participants == ''
        ) {
          error.push({
            target: 'map:variants[].info.max_participants|' + index,
            message: 'You missed a section!',
          });
        }

        if (variant.info.link.trim() == '') {
          error.push({
            target: 'map:variants[].info.link|' + index,
            message: 'You missed a section!',
          });
        }
      });
    }

    if (!soft_mode) {
      if (activity.description.trim().length == 0) {
        error.push({
          target: 'map:description',
          message: 'You missed a section!',
        });
      }

      if (activity.info.special.trim().length == 0) {
        error.push({
          target: 'map:info.special',
          message: 'You missed a section!',
        });
      }

      if (activity.info.materials.trim().length == 0) {
        error.push({
          target: 'map:info.materials',
          message: 'You missed a section!',
        });
      }

      if (activity.info.goal.trim().length == 0) {
        error.push({
          target: 'map:info.goal',
          message: 'You missed a section!',
        });
      }

      if (activity.info.session_data && activity.info.session_data.length > 0) {
        activity.info.session_data.forEach((session, index) => {
          if (
            session.hasOwnProperty('introduction') &&
            session.introduction.trim().length == 0
          ) {
            error.push({
              target: 'map:info.session_data().introduction|' + index,
              message: 'You missed a section!',
            });
          }

          if (
            session.hasOwnProperty('description') &&
            session.description.trim().length == 0
          ) {
            error.push({
              target: 'map:info.session_data[].description|' + index,
              message: 'You missed a section!',
            });
          }

          if (
            session.hasOwnProperty('closing') &&
            session.closing.trim().length == 0
          ) {
            error.push({
              target: 'map:info.session_data[].closing|' + index,
              message: 'You missed a section!',
            });
          }

          if (
            session.hasOwnProperty('title') &&
            session.title.trim().length == 0
          ) {
            error.push({
              target: 'map:info.session_data().title|' + index,
              message: 'You missed a section!',
            });
          }

          if (
            session.hasOwnProperty('materials') &&
            session.materials.trim().length == 0
          ) {
            error.push({
              target: 'map:info.session_data[].materials|' + index,
              message: 'You missed a section!',
            });
          }
        });
      }
    }

    document.querySelectorAll("[aria-invalid='true']").forEach((node) => {
      node.removeAttribute('aria-invalid');
      node.closest('.edit__accordion').classList.remove('error');

      if (node.tagName == 'SELECT') {
        node.nextSibling.nextSibling.remove();
      } else {
        node.nextSibling.remove();
      }
    });

    if (error.length == 0) {
      return true;
    } else {
      error.forEach((error, index) => {
        if (error.target.indexOf('|') > -1) {
          var target_index = error.target.split('|');
          var target = document.querySelectorAll(
            "[name='" + target_index[0] + "']"
          )[target_index[1]];
        } else {
          var target = document.querySelector("[name='" + error.target + "']");
        }

        if (target.tagName == 'SELECT') {
          target.nextSibling.insertAdjacentHTML(
            'afterend',
            "<p role='alert' class='edit__row-error'>" + error.message + '</p>'
          );
        } else {
          target.insertAdjacentHTML(
            'afterend',
            "<p role='alert' class='edit__row-error'>" + error.message + '</p>'
          );
        }

        target.setAttribute('aria-invalid', true);
        target.closest('.edit__accordion').classList.add('error');
      });

      var $trigger = $(
        '.edit__accordion.error .edit__accordion-toggle'
      ).first();

      if ($trigger.attr('aria-expanded') == 'false') {
        $trigger.click();
      }

      setTimeout(function () {
        $('html, body').animate(
          {
            scrollTop:
              $("[aria-invalid='true']").first().parent().offset().top - 180,
          },
          700
        );
      }, 100);

      return false;
    }
  }

  function _toggleEditAccordion(e) {
    if ($(this).attr('aria-expanded') == 'true') {
      $(this).attr('aria-expanded', 'false');
      $(this).next().slideUp(300);
    } else {
      $(this).attr('aria-expanded', 'true');
      $(this).next().slideDown(300);
    }
  }

  function _closeEditAccordion(e) {
    $(this).closest('.edit__accordion-contents').prev().click();
    $(this)
      .closest('.edit__accordion')
      .next()
      .find('[edit-accordion-toggle]')
      .click();
  }

  function _nextEditAccordion() {
    var $next = $(this).closest('.edit__accordion').next();
    $(this).closest('.edit__accordion-contents').prev().click();
    $next.find('[edit-accordion-toggle]').click();

    setTimeout(function () {
      $('html, body').animate(
        {
          scrollTop: $next.offset().top - 160,
        },
        700
      );
    }, 300);
  }

  function _generateBlankActivity(type) {
    return {
      id: 0,
      type: type,
      multi_session: type == 'Single' || type == 'Anytime' ? false : true,
      status: 'draft',
      title: 'Untitled Activity',
      variants: [],
      disabled: false,
      price: theme.activityPrices[type],
    };
  }

  function createNewActivity(type) {
    if (typeof type != 'string') {
      type = $(this).attr('data-new-activity');
    }

    _createActivityForm(_generateBlankActivity(type));

    $.fancybox.close();
  }

  function editExistingActivity(id) {
    if (typeof id != 'string') {
      id = $(this).attr('data-activity-id');
    }

    theme.Activities.getActivity(id).then(_createActivityForm);
  }

  function editDuplicateActivity(id) {
    theme.Activities.getActivity(id).then((activity) => {
      _createActivityForm({
        ...activity,
        id: 0,
        title: activity.handle,
        status: 'draft',
        variants: [],
        media: [],
      });
    });
  }

  function _createActivityForm(activity) {
    theme.Account.getContent().empty();

    activity.variants.forEach((variant, index) => {
      if (variant.current_participants && variant.current_participants > 0) {
        activity.disabled = true;
        return false;
      }
    });

    cache.activity = activity;

    _renderActivityData();
    _renderActivityTitle();
    _renderActivityOverview();

    if (activity.type !== 'Anytime') {
      _renderScheduling();
    }

    _renderInformation();
    _renderLearningGoals();
    _renderSubjects();

    if (activity.type == 'Single') {
      _renderActivityPlan();
    } else if (activity.type == 'Camp' || activity.type == 'Series') {
      _renderSessionSummary();
    }

    if (activity.type == 'Anytime') {
      _renderDownloadableResources();
    }

    _renderImageAndVideo();

    _renderActionButtons();

    window.scrollTo({ top: 0 });
  }

  function _renderActivityData() {
    let string = `
      <input type='hidden' name='map:id' value='${cache.activity.id}' />
      <input type='hidden' name='map:vendor' value='${theme.customer.id}' />
      <input type='hidden' name='map:status' value='${cache.activity.status}' />
      <input type='hidden' name='map:product_type' value='${
        cache.activity.type
      }' />
      <input type='hidden' name='map:price' value='${cache.activity.price}' />
      <input type='hidden' name='map:info.educator_name' value='${
        cache.activity.educator_name
          ? cache.activity.educator_name
          : theme.customer.first_name
      }' />
      ${
        cache.activity.type == 'Anytime'
          ? `<input type='hidden' name='map:variants().id' value='${
              cache.activity.variants.length > 0
                ? cache.activity.variants[0].id
                : 0
            }' />`
          : ''
      }
      ${
        cache.activity.type == 'Anytime'
          ? `<input type='hidden' name='map:variants[].price' value='${theme.activityPrices['Anytime']}' />`
          : ''
      }
    `;

    theme.Account.getContent().append(string);
  }

  function _renderActivityTitle() {
    var string = `
      <div class='edit__header'>
        <span class='edit__header-status'>${
          cache.type_map[cache.activity.status]
        }</span>
        <h1 class='edit__header-title' data-edit-title>${
          cache.activity.title
        }</h1>
      </div>`;

    theme.Account.getContent().append(string);
  }

  function _renderActivityOverview() {
    if (cache.activity.type == 'Camp') {
      var tooltip = `
        <span class='tooltip-wrapper' tabindex='0' data-tooltip>
          <div class='tooltip-content' data-tooltip-content>
            <h2>For naming camps, use this format.</h2>
            <p>Activity Name: Bake a Cake: Grade 1-2.</p>
          </div>
        </span>`;
    }

    var string = `
      <div class='edit__accordion'>
        <div class='edit__accordion-toggle' edit-accordion-toggle role='button' tabindex='0' id='overview-title' aria-expanded='false' aria-controls='overview'>
          <h2>Activity Overview</h2>
          <p>Name your activity and give it an exciting tagline.</p>
        </div>
        <div class='edit__accordion-contents' id='overview' role='region' aria-labelledby='overview-title'>
          <div class='edit__row'>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>
                What is the name of your activity? ${tooltip ? tooltip : ''}
              </h3>
              <p class='edit__row-info'>Max 40 characters</p>
            </div>
            <input maxlength='40' ${
              cache.activity.disabled ? 'disabled' : ''
            } class='edit__row-text' type='text' name='map:title' value='${
      cache.activity.title && cache.activity.title != 'Untitled Activity'
        ? cache.activity.title
        : ''
    }' />
          </div>
          <div class='edit__row'>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>
                What will the activity be about?
              </h3>
              <p class='edit__row-info'>Give a brief, but informative description of your activity. Max 100 characters</p>
            </div>
            <textarea maxlength='100' class='edit__row-text' type='text' name='map:description'>${
              cache.activity.description ? cache.activity.description : ''
            }</textarea>
          </div>
          <div class='edit__row'>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>
              Describe what makes this Activity special.
              </h3>
              <p class='edit__row-info'>Give a fantastic, exciting, enticing, enthusiastic description of this Activity. Include the process and the outcome without giving away the ending! Max 500 characters.</p>
            </div>
            <textarea maxlength='500' class='edit__row-text' type='text' name='map:info.special'>${
              cache.activity.special ? cache.activity.special : ''
            }</textarea>
          </div> \
          <div class='edit__close'>
            <button edit-accordion-next class='text-link'>Next Section</button>
          </div>
        </div>
      </div>`;

    theme.Account.getContent().append(string);
  }

  function _renderScheduling() {
    const textMap = {
      Camp: 'Choose the dates when your camp will occur. All sessions must take place within the same week. A minimum of 3 sessions is required, with a possible maximum of 5 sessions.',
      Series:
        'Provide the session dates for your series. Sessions will repeat on a regular interval. A minimum of 2 sessions is required, with a possible maximum of 8 sessions.',
      Single: 'Choose when your activity will occur.',
    };

    var string = `
      <div class='edit__accordion'>
        <div class='edit__accordion-toggle' edit-accordion-toggle role='button' tabindex='0' id='scheduling-title' aria-expanded='false' aria-controls='scheduling'>
          <h2>Scheduling</h2>
          <p>${
            cache.activity.multi_session
              ? textMap[cache.activity.type]
              : textMap['Single']
          }</p>
        </div>
        <div class='edit__accordion-contents' id='scheduling' role='region' aria-labelledby='scheduling-title'>
          <div class='edit__row' edit-timeslots>

          </div>
          <div class='edit__row'>
            <h3 class='edit__row-title'>
              Add a Time
            </h3>
            <button edit-add-timeslot class='edit__row-action btn btn--primary'>Add</button>
          </div>
        </div>
      </div>`;

    theme.Account.getContent().append(string);

    cache.activity.variants.forEach((variant, index) => {
      string += _renderTimeslot(variant);
    });
  }

  function _renderTimeslot(variant) {
    if (variant.target) {
      variant = {
        id: null,
        current_participants: 0,
        session_count: 2,
        session_interval: 1,
        price: cache.activity.price,
      };
    }

    let session_count = `
      <option value='1'>1</option>
    `;

    if (cache.activity.multi_session) {
      if (cache.activity.type === 'Series') {
        session_count = `
          <option ${
            variant.session_count == '2' ? 'selected="selected"' : ''
          } value='2'>2</option>
          <option ${
            variant.session_count == '3' ? 'selected="selected"' : ''
          } value='3'>3</option>
          <option ${
            variant.session_count == '4' ? 'selected="selected"' : ''
          } value='4'>4</option>
          <option ${
            variant.session_count == '5' ? 'selected="selected"' : ''
          } value='5'>5</option>
          <option ${
            variant.session_count == '6' ? 'selected="selected"' : ''
          } value='6'>6</option>
          <option ${
            variant.session_count == '7' ? 'selected="selected"' : ''
          } value='7'>7</option>
          <option ${
            variant.session_count == '8' ? 'selected="selected"' : ''
          } value='8'>8</option>
        `;
      } else if (cache.activity.type === 'Camp') {
        session_count = `
          <option ${
            variant.session_count == '3' ? 'selected="selected"' : ''
          } value='3'>3</option>
          <option ${
            variant.session_count == '4' ? 'selected="selected"' : ''
          } value='4'>4</option>
          <option ${
            variant.session_count == '5' ? 'selected="selected"' : ''
          } value='5'>5</option>
        `;
      }
    }

    let session_interval = `
      <option value='0'>0</option>
    `;

    if (cache.activity.multi_session) {
      if (cache.activity.type === 'Series') {
        session_interval = `
          <option ${
            variant.session_interval == '7' ? 'selected="selected"' : ''
          } value='7'>1 week</option>
          <option ${
            variant.session_interval == '14' ? 'selected="selected"' : ''
          } value='14'>2 weeks</option>
        `;
      } else if (cache.activity.type === 'Camp') {
        session_interval = `
          <option ${
            variant.session_interval == '1' ? 'selected="selected"' : ''
          } value='1'>1 day</option>
          <option ${
            variant.session_interval == '2' ? 'selected="selected"' : ''
          } value='2'>2 days</option>
        `;
      }
    }

    var string = `
      <div class='edit__timeslot edit__timeslot--single' >
        <input type='hidden' name='map:variants().id' value='${variant.id}' />
        <input type='hidden' name='map:variants[].price' value='${
          variant.price
        }' />

        <div class='edit__group'>

          <div class='edit__row edit__row--inline'>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>
                Choose Start Date
              </h3>
              <p class='edit__row-info'>Select the date of the first session of your activity.</p>
            </div>
            <input autocomplete='off' class='edit__row-text date-time-picker' ${
              variant.current_participants > 0 ? 'disabled' : ''
            } type='text' name='map:variants[].info.start_date' value='${
      variant.start_date
        ? theme.Time.convertTimeToLocalInput(variant.start_date)
        : ''
    }' />
          </div>

          <div class='edit__row edit__row--inline' ${
            !cache.activity.multi_session ? "style='display: none;'" : ''
          }>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>
                Number of Sessions
              </h3>
              <p class='edit__row-info'>Decide how many sessions you will have in your series. Set a minimum of 2 to a maximum of 8 sessions.</p>
            </div> \
            <select class='edit__row-select' ${
              variant.current_participants > 0 ? 'disabled' : ''
            } type='text' name='map:variants[].info.session_count' value=''>
              ${session_count}
            </select>
          </div>

          <div class='edit__row edit__row--inline'>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>
              Session Duration
              </h3>
              <p class='edit__row-info'>Select the length of time for each session.</p>
            </div>
            <select class='edit__row-select' ${
              variant.current_participants > 0 ? 'disabled' : ''
            } type='text' name='map:variants[].info.duration'>
              <option ${
                variant.duration && variant.duration == 30
                  ? "selected='selected'"
                  : ''
              } value='30'>30 minutes</option>
              <option ${
                variant.duration && variant.duration == 60
                  ? "selected='selected'"
                  : ''
              } value='60'>1 hour</option>
              <option ${
                variant.duration && variant.duration == 90
                  ? "selected='selected'"
                  : ''
              } value='90'>1.5 hours</option>
              <option ${
                variant.duration && variant.duration == 120
                  ? "selected='selected'"
                  : ''
              } value='120'>2 hours</option>
            </select>
          </div>

          <div class='edit__row edit__row--inline' ${
            !cache.activity.multi_session ? "style='display: none;'" : ''
          }>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>
                Session Interval
              </h3>
              <p class='edit__row-info'>Select the length of time that passes between successive sessions of the Activity.</p>
            </div> \
            <select class='edit__row-select' ${
              variant.current_participants > 0 ? 'disabled' : ''
            } type='text' name='map:variants[].info.session_interval' value=''>
              ${session_interval}
            </select>
          </div>

          <div class='edit__row edit__row--full edit__row--inline'>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>
                Activity Meeting Link
              </h3>
              <p class='edit__row-info'>
                Paste the meeting link to your series. You must generate this link yourself. The link is the same for all sessions.
              </p>
            </div>
            <input class='edit__row-text' type='text' name='map:variants[].info.link' value='${
              variant.link ? variant.link : ''
            }' />
          </div>

          <div class='edit__row edit__row--full edit__row--inline'>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>
                Max Participants
              </h3>
              <p class='edit__row-info'>The number of participants is the same for all sessions. </p>
            </div>
            <input class='edit__row-text' type='number' name='map:variants[].info.max_participants' value='${
              variant.max_participants ? variant.max_participants : ''
            }' />
          </div>
        </div>

        <button class='btn btn--error medium' edit-remove-timeslot>
          Delete Time Slot
        </button>
      </div>`;

    $('[edit-timeslots]').append(string);

    if ($('[edit-timeslots]').children().length > 0) {
      $('[edit-timeslots]').css('display', 'grid');
    }
  }

  function _removeTimeslot() {
    $(this).closest('.edit__timeslot').remove();
  }

  function _renderInformation() {
    const ageArray = [
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
    ];
    const ages = ageArray
      .map(
        (age) => `
                      <label class="edit__row-checkbox">
                        <input type="checkbox" name="map:info.age_range[]" value="${age}" ${
          cache.activity.age_range && cache.activity.age_range.indexOf(age) > -1
            ? 'checked="checked"'
            : ''
        }>
                        ${age}
                      </label>`
      )
      .join('');

    const skillLevelArray = [
      'I am confident & have done this before.',
      'I am new to this type of Activity.',
      'All experience levels are welcome.',
    ];
    const skillLevel = skillLevelArray
      .map(
        (skillLevel) =>
          `<option ${
            cache.activity.skill_level &&
            cache.activity.skill_level == skillLevel
              ? 'selected="selected"'
              : ''
          } value='${skillLevel}'>${skillLevel}</option>`
      )
      .join('');

    const readingLevelArray = [
      'All reading levels are welcome.',
      'I can read independently.',
    ];
    const readingLevel = readingLevelArray
      .map(
        (readingLevel) =>
          `<option ${
            cache.activity.reading_level &&
            cache.activity.reading_level == readingLevel
              ? 'selected="selected"'
              : ''
          } value='${readingLevel}'>${readingLevel}</option>`
      )
      .join('');

    var string = `
      <div class='edit__accordion'>
        <div class='edit__accordion-toggle' edit-accordion-toggle role='button' tabindex='0' id='information-title' aria-expanded='false' aria-controls='information'>
          <h2>Information for Kids</h2>
          <p>Describe more details about your activity.</p>
        </div>
        <div class='edit__accordion-contents' id='information' role='region' aria-labelledby='information-title'>
          <div class='edit__row'>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>
                What materials do Kids need for this activity?
              </h3>
              <p class='edit__row-info'>Describe anything required for the activity (e.g. materials, technology, space required, etc.). Separate each item with a comma. Max 500 characters.</p>
            </div>
            <textarea maxlength='500' class='edit__row-text' type='text' name='map:info.materials'>${
              cache.activity.materials ? cache.activity.materials : ''
            }</textarea>
          </div>
          <div class='edit__row edit__row--inline'>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>
                What are the ages of the participants?
              </h3>
              <p class='edit__row-info'>Select all that apply - <b>must be sequential</b></p>
            </div>
            <div class='edit__row-checkboxes'>
              ${ages}
            </div>
          </div>
          <div class='edit__row edit__row--inline'>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>
                What level of experience is needed?
              </h3>
              <p class='edit__row-info'>Select one. Choices are written from the Kid perspective.</p>
            </div>
            <select class='edit__row-select' type='text' name='map:info.skill_level'>
              ${skillLevel}
            </select>
          </div>
          <div class='edit__row edit__row--inline'>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>
                What reading level is required to participate?
              </h3>
              <p class='edit__row-info'>Select one. Choices are written from the Kid perspective.</p>
            </div>
            <select class='edit__row-select' type='text' name='map:info.reading_level'>
              ${readingLevel}
            </select>
          </div>
          <div class='edit__row edit__row--inline'>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>
                Is Parent/Guardian supervision required?
              </h3>
              <p class='edit__row-info'>Select one. Choices are written from the Kid perspective.</p>
            </div>
            <select class='edit__row-select' type='text' name='map:info.guardian_required'>
              <option ${
                cache.activity.guardian_required ? 'selected="selected"' : ''
              } value='true'>My parents need to be around.</option>
              <option ${
                !cache.activity.guardian_required ? 'selected="selected"' : ''
              } value='false'>I can do this independently.</option>
            </select>
          </div>
          <div class='edit__close'>
            <button edit-accordion-next class='text-link'>Next Section</button>
          </div>
        </div>
      </div>`;

    theme.Account.getContent().append(string);
  }

  function _renderLearningGoals() {
    var string =
      " \
      <div class='edit__accordion'> \
        <div class='edit__accordion-toggle' edit-accordion-toggle role='button' tabindex='0' id='goals-title' aria-expanded='false' aria-controls='goals'> \
          <h2>Learning Goals</h2> \
          <p>Explain the educational benefits of this activity.</p> \
        </div> \
        <div class='edit__accordion-contents' id='goals' role='region' aria-labelledby='goals-title'> \
          <div class='edit__row'> \
            <div class='edit__row-details'> \
              <h3 class='edit__row-title'> \
                What is the goal of attending this activity? \
              </h3> \
              <p class='edit__row-info'>State simply and briefly what Kids gain from attending this activity. Max 70 characters.</p> \
            </div> \
            <textarea maxlength='70' class='edit__row-text' type='text' name='map:info.goal'>" +
      (cache.activity.goal ? cache.activity.goal : '') +
      "</textarea> \
          </div> \
          <div class='edit__close'> \
            <button edit-accordion-next class='text-link'>Next Section</button> \
          </div> \
        </div> \
      </div>";

    theme.Account.getContent().append(string);
  }

  function _renderSubjects() {
    var string =
      " \
      <div class='edit__accordion'> \
        <div class='edit__accordion-toggle' edit-accordion-toggle role='button' tabindex='0' id='subject-title' aria-expanded='false' aria-controls='subject'> \
          <h2>Subjects</h2> \
          <p>Select all the subjects that your activity applies to.</p> \
        </div> \
        <div class='edit__accordion-contents' id='subject' role='region' aria-labelledby='subject-title'> \
          <div class='edit__row'> \
            <div class='edit__row-details'> \
              <h3 class='edit__row-title'> \
                Choose Subjects \
                <span class='tooltip-wrapper' tabindex='0' data-tooltip> \
                  <div class='tooltip-content' data-tooltip-content> \
                    <h2>Selecting subjects</h2> \
                    <p>Remember, at HomeLearners Network, our activities are interdisciplinary!</p> \
                  </div> \
                </span> \
              </h3> \
              <div class='edit__row-checkboxes'> \
                <div class='edit__row-details'>";

    theme.subjects.forEach((subject, x) => {
      string +=
        " \
                  <label class='edit__row-checkbox'> \
                    <input type='checkbox' name='map:info.subjects[]' value='" +
        subject +
        "' " +
        (cache.activity.subjects &&
        cache.activity.subjects.indexOf(subject) > -1
          ? "checked='checked'"
          : '') +
        ' /> \
                    ' +
        subject +
        ' \
                  </label>';
    });

    string +=
      " \
                </div> \
              </div> \
            </div> \
          </div> \
          <div class='edit__row'> \
            <div class='edit__row-details'> \
              <h3 class='edit__row-title'> \
                Competencies \
              </h3> \
              <p class='edit__row-info'>Select all that apply.</p> \
              <div class='edit__row-checkboxes'> \
                <div class='edit__row-details'>";

    theme.competencies.forEach((competency, x) => {
      string +=
        " \
                  <label class='edit__row-checkbox'> \
                    <input type='checkbox' name='map:info.competencies[]' value='" +
        competency +
        "' " +
        (cache.activity.competencies &&
        cache.activity.competencies.indexOf(competency) > -1
          ? "checked='checked'"
          : '') +
        ' /> \
                    ' +
        competency +
        ' \
                  </label>';
    });

    string +=
      " \
                </div> \
              </div> \
            </div> \
          </div> \
          <div class='edit__close'> \
            <button edit-accordion-next class='text-link'>Next Section</button> \
          </div> \
        </div>";

    theme.Account.getContent().append(string);
  }

  function _renderActivityPlan() {
    let before_resources = '';
    let after_resources = '';

    if (
      cache.activity.session_data &&
      cache.activity.session_data.length > 0 &&
      cache.activity.session_data[0].before_resources
    ) {
      before_resources = cache.activity.session_data[0].before_resources
        .map((resource) => {
          return `
          <div class="edit__resource">
            <input name='map:info.session_data[].before_resources[]' type='hidden' value='${
              resource.id
            }' />
            
            <label class='resource__type'>${
              resource.upload_type === 'file' ? 'File' : 'Link'
            }</label>
            <a href="${theme.Global.addProtocolToLink(
              resource.link
            )}" class="resource__link" target="_blank">${resource.title}</a>
            <button class="btn btn--link resource__delete" data-resource-delete id="${
              resource.id
            }">Delete</button>
          </div>
        `;
        })
        .join('');
    }

    if (
      cache.activity.session_data &&
      cache.activity.session_data.length > 0 &&
      cache.activity.session_data[0].after_resources
    ) {
      after_resources = cache.activity.session_data[0].after_resources
        .map((resource) => {
          return `
          <div class="edit__resource">
            <input name='map:info.session_data[].after_resources[]' type='hidden' value='${
              resource.id
            }' />
            
            <label class='resource__type'>${
              resource.upload_type === 'file' ? 'File' : 'Link'
            }</label>
            <a href="${theme.Global.addProtocolToLink(
              resource.link
            )}" class="resource__link" target="_blank">${resource.title}</a>
            <button class="btn btn--link resource__delete" data-resource-delete id="${
              resource.id
            }">Delete</button>
          </div>`;
        })
        .join('');
    }

    var string = `
      <div class='edit__accordion'>
        <div class='edit__accordion-toggle' edit-accordion-toggle role='button' tabindex='0' id='plan-title' aria-expanded='false' aria-controls='plan'>
          <h2>Activity Plan</h2>
          <p>Describe what Kids will do during this activity. This will be shared with Kids after they have registered for the activity.</p>
        </div>
        <div class='edit__accordion-contents' id='plan' role='region' aria-labelledby='plan-title'>
          <div class='edit__row'>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>
                Introduction
              </h3>
              <p class='edit__row-info'>Name games, icebreakers, warm-up tasks, or other introductions you are planning. Max 2000 characters.</p>
            </div>
            <textarea maxlength='2000' class='edit__row-text' type='text' data-array='true' name='map:info.session_data().introduction'>${
              cache.activity.session_data &&
              cache.activity.session_data.length > 0 &&
              cache.activity.session_data[0].introduction
                ? cache.activity.session_data[0].introduction
                : ''
            }</textarea>
          </div>

          <div class='edit__row'>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>
                Activity
              </h3>
              <p class='edit__row-info'>Describe the main tasks related to the activity (e.g. art project components, steps of the science experiment, etc...). Max 2000 characters.</p>
            </div>
            <textarea maxlength='2000' class='edit__row-text' type='text' data-array='true' name='map:info.session_data[].description'>${
              cache.activity.session_data &&
              cache.activity.session_data.length > 0 &&
              cache.activity.session_data[0].description
                ? cache.activity.session_data[0].description
                : ''
            }</textarea>
          </div>

          <div class='edit__row'>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>
                Closing
              </h3>
              <p class='edit__row-info'>Describe how you will wrap up the activity (e.g. sharing final results, presenting projects, sharing reflections, etc...). Max 2000 characters.</p>
            </div>
            <textarea maxlength='2000' class='edit__row-text' type='text' data-array='true' name='map:info.session_data[].closing'>${
              cache.activity.session_data &&
              cache.activity.session_data.length > 0 &&
              cache.activity.session_data[0].closing
                ? cache.activity.session_data[0].closing
                : ''
            }</textarea>
          </div>

          <div class='edit__row'>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>
                Pre-Activity Resources
              </h3>
              <p class='edit__row-info'>What resources will be shared within the Kids before the activity starts? Upload 1 minimum</p>
            </div>

            ${before_resources}

            <button data-add-resource data-when="before" data-target='${createUniqueId(
              5
            )}' class="btn btn--primary btn--round">Add</button>
          </div>

          <div class='edit__row'>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>
                Post-Activity Resources
              </h3>
              <p class='edit__row-info'>What resources will be shared within the Kids after the activity starts? Upload 1 minimum</p>
            </div>

            ${after_resources}

            <button data-add-resource data-when="after" data-target='${createUniqueId(
              5
            )}' class="btn btn--primary btn--round">Add</button>
          </div>

          <div class='edit__close'>
            <button edit-accordion-next class='text-link'>Next Section</button>
          </div>
        </div>
      </div>`;

    theme.Account.getContent().append(string);
  }

  function _renderSessionSummary() {
    var string = `
      <div class='edit__accordion'>
        <div class='edit__accordion-toggle' edit-accordion-toggle role='button' tabindex='0' id='plan-title' aria-expanded='false' aria-controls='plan'>
          <h2>Session Summary</h2>
          <p>Describe what happens in each session of this Activity and add session-specific materials and resources.</p>
        </div>
        <div class='edit__accordion-contents' id='plan' role='region' aria-labelledby='plan-title'>
          <div class='edit__row' edit-sessions>

          </div>
          <div class='edit__row'>
            <h3 class='edit__row-title'>
              Add a Session Summary
            </h3>
            <button edit-add-session class='edit__row-action btn btn--primary'>Add</button>
          </div>
        </div>
      </div>`;

    theme.Account.getContent().append(string);

    if (cache.activity.session_data) {
      cache.activity.session_data.forEach((session, index) => {
        string += _renderSession(session);
      });
    }
  }

  function _renderSession(session) {
    let before_resources = '';
    let after_resources = '';

    if (session.before_resources) {
      before_resources = session.before_resources
        .map((resource) => {
          return `
          <div class="edit__resource">
            <input name='map:info.session_data[].before_resources[]' type='hidden' value='${
              resource.id
            }' />
            
            <label class='resource__type'>${
              resource.upload_type === 'file' ? 'File' : 'Link'
            }</label>
            <a href="${theme.Global.addProtocolToLink(
              resource.link
            )}" class="resource__link" target="_blank">${resource.title}</a>
            <button class="btn btn--link resource__delete" data-resource-delete id="${
              resource.id
            }">Delete</button>
          </div>
        `;
        })
        .join('');
    }

    if (session.after_resources) {
      after_resources = session.after_resources
        .map((resource) => {
          return `
          <div class="edit__resource">
            <input name='map:info.session_data[].after_resources[]' type='hidden' value='${
              resource.id
            }' />
            
            <label class='resource__type'>${
              resource.upload_type === 'file' ? 'File' : 'Link'
            }</label>
            <a href="${theme.Global.addProtocolToLink(
              resource.link
            )}" class="resource__link" target="_blank">${resource.title}</a>
            <button class="btn btn--link resource__delete" data-resource-delete id="${
              resource.id
            }">Delete</button>
          </div>`;
        })
        .join('');
    }

    var string = `
      <div class='edit__timeslot edit__timeslot--single' >
        <div class='edit__group'>

          <div class='edit__row edit__row--full'>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>What is the name of this session?</h3>
              <p class='edit__row-info'>Name your Session based on your Activity. e.g. ActivityName #1. Max 60 characters.</p>
            </div>
            <textarea maxlength='60' class='edit__row-text' type='text' name='map:info.session_data().title' data-array='true'>${
              session.title ? session.title : ''
            }</textarea>
          </div>

          <div class='edit__row edit__row--full'>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>What happens during this session?</h3>
              <p class='edit__row-info'>Describe what will happen in this session (intro, activity, closing).</p>
            </div>
            <textarea maxlength='3000' class='edit__row-text' type='text' name='map:info.session_data[].description' data-array='true'>${
              session.description ? session.description : ''
            }</textarea>
          </div>

          <div class='edit__row edit__row--full'>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>What materials are needed for this session?</h3>
              <p class='edit__row-info'>List the materials needed for the session. Use a comma to divide each item e.g. calculator, pencil, eraser. There is no limit to the number of materials.</p>
            </div>
            <textarea class='edit__row-text' type='text' name='map:info.session_data[].materials' data-array='true'>${
              session.materials ? session.materials : ''
            }</textarea>
          </div>


          <div class='edit__row edit__row--full'>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>Pre-Session Resources</h3>
              <p class='edit__row-info'>Add resources to be viewed before the session starts.</p>
            </div>

            ${before_resources}

            <button data-add-resource data-target='${createUniqueId(
              5
            )}' data-when="before" class="btn btn--primary btn--round">Add</button>
          </div>

          <div class='edit__row edit__row--full'>
            <div class='edit__row-details'>
              <h3 class='edit__row-title'>Post-Session Resources</h3>
              <p class='edit__row-info'>Add resources to be viewed after the session ends.</p>
            </div>

            ${after_resources}

            <button data-add-resource data-target='${createUniqueId(
              5
            )}' data-when="after" class="btn btn--primary btn--round">Add</button>
          </div>
        </div>

        <button class='btn btn--error medium' edit-remove-timeslot>
          Delete Session Summary
        </button>
      </div>`;

    $('[edit-sessions]').append(string);

    if ($('[edit-sessions]').children().length > 0) {
      $('[edit-sessions]').css('display', 'grid');
    }
  }

  function _renderDownloadableResources() {
    const before =
      cache.activity.session_data && cache.activity.session_data.length
        ? cache.activity.session_data[0].before_resources
        : [];
    const before_resources = before
      .map((resource) => {
        const type = resource.type === 'file' ? 'File' : 'Web Link';
        return `<div data-before-resource class="edit__resource">
        <label class="resource__type">${type}</label>
        <input name='map:info.session_data[].before_resources[]' type='hidden' value='${
          resource.id
        }' />
        <a href="${theme.Global.addProtocolToLink(
          resource.link
        )}" class="resource__link" target="_blank">${resource.title}</a>
        <button class="btn btn--link resource__delete" data-resource-delete id="${
          resource.id
        }">Delete</button>
      </div>`;
      })
      .join('');
    const resources_markup = `<div data-before-resources>
      <input type='hidden' name='map:info.session_data().title' value="Anytime">
      <h3>Add PDF</h3>
      <p>Upload the PDF that has been created and approved </p>
      ${before_resources}
    </div>
    <button data-add-resource data-activity-type="${cache.activity.type.toLowerCase()}" data-when="before" class="btn btn--primary btn--round" ${
      before_resources.length ? 'disabled' : ''
    }>Add</button>`;

    const string =
      " \
      <div class='edit__accordion'> \
        <div class='edit__accordion-toggle' edit-accordion-toggle role='button' tabindex='0' id='resource-title' aria-expanded='false' aria-controls='resource'> \
          <h2>Downloadable Resources</h2> \
          <p>This is the downloadable version of this activity, that Kids can print and access from home.</p> \
        </div> \
        <div class='edit__accordion-contents' id='resource' role='region' aria-labelledby='resource-title'> \
          " +
      resources_markup +
      " \
          <div class='edit__close'> \
            <button edit-accordion-next class='text-link'>Next Section</button> \
          </div> \
        </div> \
      </div>";
    theme.Account.getContent().append(string);
  }

  function updateResources(new_resource, target) {
    const type = new_resource.type === 'file' ? 'File' : 'Web Link';
    const new_resource_markup = `
      <div data-${new_resource.when}-resource class="edit__resource">
        <input name='map:info.session_data[].${
          new_resource.when
        }_resources[]' type='hidden' value='${new_resource.id}' />
        <label class="resource__type">${type}</label>
        <a href="${theme.Global.addProtocolToLink(
          new_resource.link
        )}" class="resource__link" target="_blank">${new_resource.title}</a>
        <button class="btn btn--link resource__delete" data-resource-delete id="${
          new_resource.id
        }">Delete</button>
      </div>`;

    if (target && target !== 'undefined') {
      $(`[data-add-resource][data-target='${target}']`).before(
        new_resource_markup
      );
    } else {
      $(`[data-${new_resource.when}-resources]`).append(new_resource_markup);
      $('[data-add-resource]').attr('disabled', true);
    }
  }

  function _renderImageAndVideo() {
    var string =
      " \
      <div class='edit__accordion'> \
        <div class='edit__accordion-toggle' edit-accordion-toggle role='button' tabindex='0' id='media-title' aria-expanded='false' aria-controls='media'> \
          <h2>Product Image and Video</h2> \
          <p>Select media that represents your activity. The media is featured on the product page and browse activity page.</p> \
        </div> \
        <div class='edit__accordion-contents' id='media' role='region' aria-labelledby='media-title'> \
          <h3 class='edit__row-title'> \
            Product Image \
          </h3> \
          <p>A representative image of your activity. This photo is featured on the product and browse activity pages. Upload the edited and approved photo. Max 5 MB. Aspect ratio 3:2.</p> \
          <div class='edit__images'>";

    if (cache.activity.media) {
      cache.activity.media.forEach((media) => {
        if (media.type == 'image') {
          string += `
                  <div class='edit__image' data-image-id='${media.id}' style='background-image: url("${media.src}")'>
                    <button id='activity_image-${media.id}' data-delete-image='${media.id}' class='visually-hidden'></button>
                    <label class='edit__image-change' for='activity_image-${media.id}'>Remove Image</label><br/> \
                  </div>
                `;
        }
      });
    }
    string += `
          <div class='edit__image' data-image-id='new'>
            <input type='hidden' name='map:image_base64' value='' data-activity-base64='new' />
            <input type='file' class='visually-hidden' id='activity_image-new' accept='image/*' data-activity-image='new' />
            <label class='edit__image-change' for='activity_image-new'>Add Image</label> \
          </div>`;

    string +=
      " \
          </div> \
          <div class='edit__row'> \
            <input type='hidden' name='map:video' value='' data-activity-video-src /> \
            <input type='file' class='visually-hidden' id='activity_video' accept='video/mp4,video/x-m4v,video/*' value='' data-activity-video /> \
            <div class='edit__row-details'> \
              <h3 class='edit__row-title'> \
                Product Video \
              </h3> \
              <p>A preview video of your activity. This video is featured on the product and browse activity pages. Upload the edited and approved video. Max 1GB. Max 60 seconds in length. Aspect ratio 3:2.</p> \
            </div> \
            <div class='edit__videos'> \
              <div class='edit__video'> \
                <div data-activity-video-preview>";

    if (cache.activity.media) {
      cache.activity.media.forEach((media) => {
        if (media.type == 'video') {
          string += media.markup;
        }
      });
    }

    string +=
      " \
                </div> \
                <div class='edit__video-actions'> \
                  <label role='button' tabindex='0' class='edit__video--edit' for='activity_video'><span>Change Video</span></label> \
                  <button class='text-link edit__video--discard' data-activity-video-discard data-activity-id='${activity.id}'>Discard </button> \
                </div> \
              </div> \
            </div> \
          </div> \
          <div class='edit__close'> \
            <button edit-accordion-close class='text-link'>Next</button> \
          </div> \
        </div> \
      </div>";

    theme.Account.getContent().append(string);
  }

  function _renderActionButtons() {
    var string =
      " \
      <div class='edit__actions'> \
        <button class='btn btn--primary' data-save-activity>Save & Exit</button>";

    if (cache.activity.id != 0) {
      string +=
        " \
        <button class='btn btn--error' data-delete-activity='" +
        cache.activity.id +
        "'>Delete Activity</button>";
    }
    string +=
      " \
        <button class='btn btn--primary' data-submit-activity>Save & Preview</button> \
      </div>";

    theme.Account.getContent().append(string);
  }

  /**
   * Support function that will read the uploaded image file
   * and set the preview and base64 input.
   *
   * @listens    document:change:[data-activity-image]
   */
  function _handleActivityImageUpload(e) {
    e.preventDefault();

    var reader = new FileReader();

    reader.addEventListener('load', function (e) {
      let src = reader.result;

      let base64 = reader.result.replace(/^data:.+;base64,/, '');
      let random = createUniqueId(7);

      var img = new Image();
      img.src = src;

      let markup = `
        <div class="edit__image" data-image-id="new-${random}">
          <input type="hidden" name="map:image_base64" value="" data-activity-base64="new-${random}" />
          <input type="file" class="visually-hidden" id="activity_image-new-${random}" accept="image/*" data-activity-image="new-${random}" />
          <button id='activity_image-${media.id}' data-delete-image='${media.id}' class='visually-hidden'></button>
          <label class='edit__image-change' for='activity_image-${media.id}'>Remove Image</label><br/> \
        </div>`;

      $('[data-image-id="new"]').before(markup);

      $(`[data-image-id="new-${random}"]`).css(
        'background-image',
        `url(${img.src})`
      );
      $(`[data-activity-base64="new-${random}"]`).val(base64);

      if (cache.activity.id != 0) {
        uploadImages(cache.activity.id);
      }
    });

    reader.readAsDataURL(this.files[0]);
  }

  function uploadImages(activity_id) {
    var promises = [];

    $('.edit__image[data-image-id]').each(function () {
      var id = $(this).attr('data-image-id');
      var target = $(this);

      if (id.indexOf('new') > -1 && id.length > 3) {
        let base64 = $(this).find('[data-activity-base64]').val();

        let promise = new Promise((resolve, reject) => {
          let params = {
            type: 'POST',
            data: JSON.stringify({
              image: {
                attachment: base64,
              },
            }),
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            success: function (r) {
              target.attr('data-image-id', r.image.id);
              target
                .find('[data-delete-image]')
                .attr('data-delete-image', r.image.id);

              resolve(r);
            },
            error: function (r) {
              reject(r);
            },
          };

          proxyApp.request(`/activities/${activity_id}/images`, params);
        });

        promises.push(promise);
      }
    });

    if (promises.length > 0) {
      theme.Global.generateModal(
        'ring',
        'Uploading Images...',
        'Please wait...'
      );

      return Promise.all(promises).then(() => {
        $.fancybox.close(true);
      });
    } else {
      return new Promise((resolve) => {
        resolve();
      });
    }
  }

  function removeImage() {
    if (cache.activity.id == 0) {
      $(this).parent().remove();
    } else {
      theme.Global.generateModal(
        'ring',
        'Deleting Images...',
        'Please wait...'
      );

      var image_id = $(this).attr('data-delete-image');
      var promise = new Promise((resolve, reject) => {
        let params = {
          type: 'DELETE',
          dataType: 'json',
          contentType: 'application/json; charset=utf-8',
          success: function (r) {
            resolve(r);
          },
          error: function (r) {
            reject(r);
          },
        };

        proxyApp.request(
          `/activities/${cache.activity.id}/images/${image_id}`,
          params
        );
      });

      promise.then(() => {
        $.fancybox.close(true);
        $(this).parent().remove();
      });
    }
  }

  /**
   * Support function that will read the uploaded video file
   * and set the preview and video_src input.
   *
   * @listens    document:change:[data-activity-video]
   */
  function _handleActivityVideoUpload(e) {
    e.preventDefault();

    var file = this.files[0];
    var temporary_video_src = URL.createObjectURL(this.files[0]);

    if (file.size >= 1073741824) {
      // 1gb
      $.fancybox.open(
        '<h2>Oops!</h2><p>File size exceeds 1GB limit. Please choose a smaller file.</p>'
      );
      return false;
    } else {
      theme.Global.showLoadingOverlay(
        true,
        $('.row__image.row__video'),
        'Loading video. Please Wait.'
      );

      new Promise(function (resolve, reject) {
        // Stage Media background process step 1.
        proxyApp.request('/media_upload', {
          type: 'POST',
          data: JSON.stringify({
            media_upload: {
              file_name: file.name,
              file_size: file.size,
              mime_type: file.type,
            },
          }),
          dataType: 'json',
          contentType: 'application/json; charset=utf-8',
          success: function (r) {
            // With the return of stage media. We start the background process 2.
            // This is a call directly to shopify's aws storage. It requires
            // a very specific format, so we have to format it first.
            // We also won't be using any of the data it returns, so
            // we set the new src of the video imediately as well.
            // This src will be used when saving to actually upload the video
            // to the product.
            var formData = new FormData();
            $.each(r.media_upload.parameters, function (index, parameter) {
              formData.append(parameter.name, parameter.value);
            });
            formData.append('file', file);

            $('[data-activity-video-src]').val(r.media_upload.resource_url);

            $.ajax({
              type: 'POST',
              enctype: 'multipart/form-data',
              url: r.media_upload.url,
              processData: false,
              contentType: false,
              cache: false,
              data: formData,
              success: resolve,
              error: reject,
            });
          },
          error: reject,
        });
      })
        .then(function (r) {
          $('[data-activity-video-preview]').html(
            "<video controls='controls' type='video/mp4' src='" +
              temporary_video_src +
              "'></video>"
          );
          theme.Global.showLoadingOverlay(false, $('.row__image.row__video'));
        })
        .catch(function () {
          console.error('bad?');
        });
    }
  }

  /**
   * Support function that will set the uploaded video file
   * to "DELETE" this is a special value that will trigger the
   * delete process in theme.Activities.saveActivity
   *
   * @listens    document:click:[data-activity-video-discard]
   */
  function _handleActivityVideoDelete(e) {
    e.preventDefault();

    $('[data-activity-video-src]').val('DELETE');
    $('[data-activity-video-preview]').html('');

    return true;
  }

  function getChangeStatus() {
    return cache.info_change;
  }

  document.addEventListener('DOMContentLoaded', () => {
    _init();
  });

  return {
    create: createNewActivity,
    edit: editExistingActivity,
    editDuplicateActivity: editDuplicateActivity,
    getChangeStatus: getChangeStatus,
    updateResources: updateResources,
    uploadImages: uploadImages,
  };
})();

theme.EducatorActivities = (function () {
  var cache = {};

  function getCache() {
    return cache;
  }

  const ACTIVITY_STATUSES = {
    draft: { title: 'In Draft', icon: '<i class="fas fa-pencil-ruler"></i>' },
    pending: { title: 'In Review', icon: '<i class="far fa-sync-alt"></i>' },
    rejected: {
      title: 'Rejected',
      icon: '<i class="far fa-exclamation-square"></i>',
    },
    available: {
      title: 'Available',
      icon: '<i class="far fa-check-circle"></i>	',
    },
    live: { title: 'Available', icon: '<i class="far fa-check-circle"></i>	' },
    available: {
      title: 'Available',
      icon: '<i class="far fa-check-circle"></i>	',
    },
    completed: {
      title: 'Complete',
      icon: '<i class="far fa-check-circle"></i>	',
    },
    complete: {
      title: 'Complete',
      icon: '<i class="far fa-check-circle"></i>	',
    },
    active: { title: 'Active', icon: '<i class="far fa-check-circle"></i>	' },
  };

  const ACTIVITY_STATUS_TOOLTIPS = {
    draft: `
      <li>Your Activity is not available on the HomeLearners Network website</li>
      <li>Kids cannot register into the Activity</li>
      <li>You can freely edit, duplicate, or delete this Activity</li>
      <li>You must submit your activity for review before the Activity becomes available for enrollment</li>
    `,
    pending: `
      <li>Your Activity is being reviewed by our team and will become available for enrollment if approved</li>
      <li>You can edit the Activity but it will stop the review process, and you will need to submit for review again after making changes</li>
    `,
    live: `
      <li>Your Activity has been approved, and is available on the HomeLearners website for enrollment</li>
      <li>You can add additional sessions to this Activity</li>
      <li>You cannot freely make edits to the activity content; if you do, you need to resubmit the Activity for review</li>
      <li>Kids are able to register into the Activity</li>
    `,
    available: `
      <li>Your Activity has been approved, and is available on the HomeLearners website for enrollment</li>
      <li>You can add additional sessions to this Activity</li>
      <li>You cannot freely make edits to the activity content; if you do, you need to resubmit the Activity for review</li>
      <li>Kids are able to register into the Activity</li>
    `,
    active: `
      <li>Your Activity is starting in the next 60 minutes or is currently in session</li>
      <li>You may not make changes to the Activity</li>
      <li>You can no longer Upload Resources to the Activity</li>
      <li>New Kids can no longer register into the Activity</li>
      <li>You can only add new future sessions to the Activity</li>
      <li>If you need to make changes or declare an emergency absence, you must contact us through the Help form</li>
    `,
    complete: `
      <li>Your Activity has no future Timeslots</li>
      <li>You can add new Timeslots to your Activity at the View or Add Timeslots link</li>
      <li>When you add new Timeslots, your Activity becomes available again and can be registered into by Kids</li>
    `,
  };

  function init(container) {
    if (!cache.loaded) {
      // Activity Table Functions
      // Show the participants when you click on the participarts number.
      $(document).on('click', '[data-registered-participants]', function () {
        const activity_id = $(this).attr('data-activity-id');
        _buildRegisteredParticipantsView(activity_id);
      });
      $(document).on('click', '[data-expand-activity]', _handleExpandToggle);
      $(document).on(
        'change',
        '[data-update-registered-participants]',
        _fetchRegisteredParticipants
      );

      // click on the add activity button to show the popup.
      $(document).on(
        'click',
        '[data-activity-create-options]',
        _openActivityCreateOptions
      );
      $(document).on(
        'click',
        '[data-open-activity-duplicate]',
        _openActivityDuplicate
      );
      $(document).on(
        'change',
        '[data-activity-duplicate-select]',
        _handleChangeActivityToDuplicate
      );
      $(document).on(
        'click',
        '[data-open-activity-create]',
        _buildCreateActivities
      );
      $(document).on('click', '[data-activity-duplicate]', _duplicateActivity);

      $(document).on(
        'click',
        '[data-new-activity]',
        theme.ActivitiesEdit.create
      );

      // Click on the edit button to get activity data and build the forms.
      $(document).on(
        'click',
        '[data-edit-activity]',
        theme.ActivitiesEdit.edit
      );

      // Click on any view to return to activities listing
      $(document).on(
        'click',
        '[data-activities-back]',
        theme.EducatorActivities.init
      );

      // Activity card functions
      $(document).on('click', '[data-view-timeslots]', _openViewTimeslots);
      $(document).on(
        'change',
        '[data-sort-timeslots]',
        _handleTimeslotsSortChange
      );
      $(document).on('click', '[data-edit-timeslots]', _buildEditTimeslots);
      $(document).on('click', '[data-edit-resources]', _buildEditResources);
      $(document).on('click', '[data-help-modal]', _openHelp);
      $(document).on('click', '[data-share-link]', _handleShareLinks);
    }

    function sortChildrenByHandle(parentObject) {
      // Create an array from the parent object with keys and values
      const childrenArray = Object.keys(parentObject).map((key) => {
        return { key, ...parentObject[key] };
      });
      // Sort the array by the ‘handle’ property of the children
      childrenArray.sort((a, b) => {
        const handleA = a.handle.toUpperCase();
        const handleB = b.handle.toUpperCase();
        if (handleA < handleB) {
          return -1;
        }
        if (handleA > handleB) {
          return 1;
        }
        // handles must be equal
        return 0;
      });
      // Convert the sorted array back to an object
      const sortedObject = {};
      childrenArray.forEach((child) => {
        sortedObject[child.key] = child;
        delete sortedObject[child.key].key; // Remove the ‘key’ property
      });
      return sortedObject;
    }

    theme.Activities.getActivities().then(function (activities) {
      _buildEducatorActivityTable(sortChildrenByHandle(activities));

      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      if (params.has('activity_id')) {
        const id = params.get('activity_id');
        $("[data-edit-activity][data-activity-id='" + id + "']").click();
      }
    });

    theme.Resources.getResources().then(function (resources) {
      cache.resources = Object.entries(resources).map(([key, r]) => r);
    });

    cache.loaded = true;
  }

  function _fetchRegisteredParticipants() {
    const activity_id = $(this)
      .find('option:selected')
      .attr('data-activity-id')
      .toString();
    const variant_index = Number(
      $(this).find('option:selected').attr('data-variant-index')
    );

    theme.Activities.getActivity(activity_id).then((a) => {
      if (a.variants[variant_index].current_participants <= 0) {
        cache.current_profiles = null;
        return _buildRegisteredParticipants();
      }

      // TODO
      //theme.Global.showLoadingOverlay(true, $(".account-content"))

      $.fancybox.close();
      theme.Global.generateModal(
        'ring',
        'Fetching registered participants',
        'Please wait...'
      );

      const data = JSON.stringify({
        user_profiles: a.variants[variant_index].participants,
      });
      return new Promise(function (resolve) {
        proxyApp.request('/get_user_profiles', {
          type: 'POST',
          data: data,
          contentType: 'application/json; charset=utf-8',
          success: function (res) {
            $.fancybox.close();
            cache.current_profiles = res.user_profiles;
            _buildRegisteredParticipants();
          },
          error: function (err) {
            $.fancybox.close();
            console.error(err);
            $.fancybox.open(
              'An error has occured. Contact your administrator.'
            );
          },
          complete: function (r) {
            resolve(JSON.parse(r.responseText));
          },
        });
      });
    });
  }

  function _handleExpandToggle(e) {
    e.preventDefault();
    const element = $(this)
      .parent()
      .parent()
      .siblings('.participant-card__expanded');
    $(element).toggleClass('visible');
    if ($(element).hasClass('visible')) {
      $(element).parents('.participant-card').addClass('expanded');
    } else {
      $(element).parents('.participant-card').removeClass('expanded');
    }
  }

  function _buildRegisteredParticipants() {
    if (!cache.current_profiles) {
      const empty_markup = `<h2>No Participants for this Timeslot yet</h2>`;
      return theme.Account.getContent().html(empty_markup);
    }

    const registered_participants_markup = cache.current_profiles
      .map((profile, i) => {
        if (
          typeof profile.online_support === 'object' &&
          !Array.isArray(profile.online_support)
        ) {
          profile.online_support = Object.keys(profile.online_support);
        }

        let expand_markup =
          "<button data-expand-activity class='btn btn--link'>See details <span class='down-arrow'>&#x25BC;</span></button>";
        let accommodation_markup = profile.online_support
          ? 'Additional support needed.'
          : '';
        if (!profile.reading_level || !profile.pronoun) {
          accommodation_markup = '';
          expand_markup = '';
        }

        const name = profile.first_name ? profile.first_name : profile.initials;
        const grade = profile.grade ? profile.grade : '';
        const pronoun = profile.pronoun ? profile.pronoun : '';
        const seperator = grade && pronoun ? '&#183;' : '';

        let description = `
        <div class='row__checkboxes'>
        ${
          profile.online_support?.includes('review_steps')
            ? `
          <div class='inline_checkbox'>
            <input checked='checked' disabled id="online_support.review_steps" type="checkbox" name="online_support.review_steps" value="Review the steps, details, and tools required for an activity in advance  " >
            <label for='online_support.review_steps'>Review the steps, details, and tools required for an activity in advance  </label>
          </div>`
            : ''
        }
        ${
          profile.online_support?.includes('additional_instructions')
            ? `
          <div class='inline_checkbox'>
            <input checked='checked' disabled id="online_support.additional_instructions" type="checkbox" name="online_support.additional_instructions" value="Have visuals to support verbal instructions " >
            <label for='online_support.additional_instructions'>Have visuals to support verbal instructions </label>
          </div>`
            : ''
        }
        ${
          profile.online_support?.includes('simplified_instructions')
            ? `
          <div class='inline_checkbox'>
            <input checked='checked' disabled id='online_support.simplified_instructions' type="checkbox" name="online_support.simplified_instructions" value="Have simplified instructions in a step-by-step form or checklist." />
            <label for='online_support.simplified_instructions'>Have simplified instructions in a step-by-step form or checklist.</label>
          </div>`
            : ''
        }
        ${
          profile.online_support?.includes('focused_instructions')
            ? `
          <div class='inline_checkbox'>
            <input checked='checked' disabled id='online_support.focused_instructions' type="checkbox" name="online_support.focused_instructions" value="" >
            <label for='online_support.focused_instructions'>See fewer items on a page or line and/or larger font size to read easilySee fewer items on a page or line and/or larger font size to read easily</label>
          </div>`
            : ''
        }
        ${
          profile.online_support?.includes('extra_time')
            ? `
          <div class='inline_checkbox'>
            <input checked='checked' disabled id='online_support.extra_time' type="checkbox" name="online_support.extra_time" value="Have extra time to process oral information and directions" >
            <label for='online_support.extra_time'>Have extra time to process oral information and directions</label>
          </div>`
            : ''
        }
        ${
          profile.online_support?.includes('response_time')
            ? `
          <div class='inline_checkbox'>
            <input checked='checked' disabled id='online_support.response_time' type="checkbox" name="online_support.response_time" value="Have time to provide verbal or written responses when called upon " >
            <label for='online_support.response_time'>Have time to provide verbal or written responses when called upon </label>
          </div>`
            : ''
        }
        ${
          profile.online_support?.includes('self_regulation')
            ? `
          <div class='inline_checkbox'>
            <input checked='checked' disabled id='online_support.self_regulation' type="checkbox" name="online_support.self_regulation" value="Use self-regulation tools to help them focus such as fidget toys, doodling, etc." >
            <label for='online_support.self_regulation'>Use self-regulation tools to help them focus such as fidget toys, doodling, etc.</label>
          </div>`
            : ''
        }
        ${
          profile.online_support?.includes('frequent_breaks')
            ? `
          <div class='inline_checkbox'>
            <input checked='checked' disabled id='online_support.frequent_breaks' type="checkbox" name="online_support.frequent_breaks" value="Have frequent breaks and/or movement breaks " >
            <label for='online_support.frequent_breaks'>Have frequent breaks and/or movement breaks </label>
          </div>`
            : ''
        }
        ${
          profile.online_support?.includes('limited_comfort')
            ? `
          <div class='inline_checkbox'>
            <input checked='checked' disabled id='online_support.limited_comfort' type="checkbox" name="online_support.limited_comfort" value="Have their camera and/or microphone off until they are comfortable. " >
            <label for='online_support.limited_comfort'>Have their camera and/or microphone off until they are comfortable. </label>
          </div>`
            : ''
        }
        ${
          profile.online_support?.includes('zoom_message')
            ? `
          <div class='inline_checkbox'>
            <input checked='checked' disabled id='online_support.zoom_message' type="checkbox" name="online_support.zoom_message" value="Can message the Guide directly in Zoom, rather than using group chat. " >
            <label for='online_support.zoom_message'>Can message the Guide directly in Zoom, rather than using group chat.</label>
          </div>`
            : ''
        }
        </div>
    `;

        return `
        <li class='participant-card'>
          <div class='participant__preview'>
            <div class='participant-card__details'>
              <h2>${name}</h2>
              <p>${grade}${seperator}${pronoun}</p>
            </div>
            <div class='participant-card__details'>
              <h3>${accommodation_markup}</h3>
              ${expand_markup}
            </div>
          </div>
          <div class='participant-card__expanded'>
            <div class='expanded-details'>
              <div class='expanded-details__section'>
                ${
                  profile.interests
                    ? `
                  <label class='h3'>Interests</label>
                  <p class='participant__information'>${profile.interests}</p>
                `
                    : ''
                }
                <label class='h3'>Reading Level</label>
                <p class='participant__information'>${profile.reading_level}</p>
   
              ${
                profile.more_info
                  ? `
              <label class='h3'>More Info for Guide</label>
              ${profile.more_info}

            `
                  : ''
              }
        ${
          profile.uses_technology
            ? `
            <label class='h3'>Technology Support</label>
            ${profile.uses_technology}
          </div>
            `
            : ''
        }
        </div>
            <div class='expanded-details'>
              <div class='expanded-details__section'>
                <label class='h3'>Description</label>
                ${description}
              </div>
            </div>
          </div>
        </li>
      `;
      })
      .join('');

    const dom = `<h2>Registered Participants</h2><ol class='participant-cards'>${registered_participants_markup}</ol>`;
    theme.Account.getContent().html(dom);
  }

  function _buildRegisteredParticipantsView(activity_id) {
    theme.Activities.getActivity(activity_id).then((a) => {
      const timeslots_select_markup = a.variants
        .map((v, i) => {
          const timeslots = v.title.split(',');
          const timeslot = timeslots
            .map((t) => {
              return theme.Time.convertTimeToDisplay(t);
            })
            .join(' & ');
          if (v.current_participants <= 0) {
            return `<option value="${v.title}" data-activity-id="${activity_id}" data-variant-index="${i}" disabled>${timeslot}</option>`;
          }
          return `<option value="${v.title}" data-activity-id="${activity_id}" data-variant-index="${i}">${timeslot}</option>`;
        })
        .join('');

      const dom = `<div class="participants__select--container">
        <label>Select Timeslot to see your Kid</label>
        <select data-update-registered-participants>
          <option disabled selected>Select a timeslot</option>
          ${timeslots_select_markup}
        </select>
      </div>
      <button class="btn btn--primary btn--round" data-activities-back>Back</button>`;

      theme.Account.getActions().html(dom);
      theme.Account.getContent().html('').css('min-height', '300px');
    });
  }

  /**
   * Generates the educator activity table DOM
   *
   * @param {object}  activities Object containing all activity data
   * @see             theme.Activities.getActivities()
   */
  function _buildEducatorActivityTable(activities) {
    var activities_markdown =
      " \
      <div class='guide-cards'> \
        <button class='btn btn--primary account-activities__create-activity' data-activity-create-options> \
          Create an Activity \
        </button>";

    $.each(activities, function (id, activity) {
      var current_variant = (next_session = false);
      var session_number = 1;

      if (activity.variants.length > 0) {
        if (activity.type == 'Single') {
          activity.variants.sort(function (a, b) {
            return (
              new Date(a.title.replace(/-/g, '/')) -
              new Date(b.title.replace(/-/g, '/'))
            );
          });

          $.each(activity.variants, function (index, variant) {
            if (variant.sessions[0].is_future_session) {
              current_variant = variant;
              next_session = variant.sessions[0];

              return false;
            }
          });
        } else if (activity.type == 'Camp' || activity.type == 'Series') {
          activity.variants.sort(function (a, b) {
            return (
              new Date(a.start_date.replace(/-/g, '/')) -
              new Date(b.start_date.replace(/-/g, '/'))
            );
          });

          $.each(activity.variants, function (index, variant) {
            if (variant.available) {
              current_variant = variant;
              return false;
            }
          });

          if (!current_variant) {
            current_variant = activity.variants[0];
          }

          $.each(current_variant.sessions, function (index, session) {
            if (session.is_future_session) {
              session_number = index + 1;
              next_session = session;
              return false;
            }
          });

          if (!next_session) {
            next_session = activity.variants[0].sessions[0];
          }
        } else {
          current_variant = activity.variants[0];
        }
      }

      if (next_session) {
        var next_session_markup = `
          <div class='card__information--sessions'>
            <p class='next_date'>Next Date &#183; Session ${session_number} of ${
          current_variant.sessions.length
        }</p>
            <p class='next_time'>${theme.Time.convertTimeToDisplay(
              next_session.datetime
            )} ${theme.Time.convertTimeToDisplayTimeOnly(
          next_session.datetime
        )}</p>
          </div>`;
      } else {
        var next_session_markup = '';
      }

      let active_status = activity.status;
      let current_status = ACTIVITY_STATUSES[activity.status.toLowerCase()];

      if (activity.type == 'Anytime') {
        next_session_markup = '<p></p>';
      } else if (activity.status === 'draft') {
        next_session_markup = '<p>Next date: N/A</p>';
      } else if (activity.status == 'live' && next_session) {
        active_status = next_session.status;
        current_status = ACTIVITY_STATUSES[active_status];

        if (next_session.status == 'completed') {
          next_session_markup = '<p>No upcoming timeslots</p>';
        }
      }

      activities_markdown += `
        <div class='guide-card' data-status='${activity.status}'>
          <div class='guide-card__title'>
            <div class='card__type card__type--${activity.type}'>${
        activity.type
      }</div>
            <h2 class='card__title'>${activity.title}</h2>
          </div>
          <div class='guide-card__inner'>
            <div class='card__information'>
              <div class='card__information--media image-wrapper video-wrapper'>
                ${activity.media.length > 0 ? activity.media[0].markup : ''}
              </div>
              <div class='card__information--actions'>
                <a class='btn text-link' ${
                  activity.status === 'live'
                    ? `href='${activity.url}'`
                    : 'disabled'
                }>View on Website</a>
                ${next_session_markup}
                <div class='card__information--buttons'>
                  <button class='btn btn--primary small' data-share-link data-activity-id='${id}'>Share Link</button>
                  <button class='btn btn--secondary small' data-help-modal>Help</button>
                </div>
              </div>
            </div>
            <div class='card__actions'>
              <button class='btn text-link' data-edit-activity data-activity-id='${id}'>Manage Activity</button>
              ${
                activity.type.toLowerCase() === 'anytime'
                  ? ''
                  : `<button class='btn text-link' data-view-timeslots data-activity-id='${id}'>Manage Schedule</button>`
              }
              <button class='btn text-link' data-edit-resources data-activity-id='${id}'>Upload Resources</button>
              ${
                activity.type.toLowerCase() === 'anytime'
                  ? ''
                  : `<button class='btn text-link' data-registered-participants data-activity-id='${id}'>See your Kids</button>`
              }
            </div>
            <div class='card__status'>
              ${
                active_status == 'active'
                  ? `<h4>Starts in ${next_session.seconds_till_start} seconds</h4>`
                  : ''
              }
              <div>
                <span class='activity__status'>${ACTIVITY_STATUSES[
                  active_status
                ].title.toUpperCase()}</span>
                ${
                  ACTIVITY_STATUS_TOOLTIPS[active_status]
                    ? `
                    <div class="tooltip-wrapper" data-tooltip tabindex="0">
                      <div class='tooltip-content' data-tooltip-content>
                        <h2>What does ${ACTIVITY_STATUSES[
                          active_status
                        ].title.toUpperCase()} mean?</h2>
                        <ul>${ACTIVITY_STATUS_TOOLTIPS[active_status]}</ul>
                      </div>
                    </div>
                  `
                    : ''
                }
              </div>${
                next_session
                  ? `<a href='${theme.Global.addProtocolToLink(
                      current_variant.link
                    )}' ${
                      next_session.status !== 'active' ? 'disabled' : ''
                    } target="_blank" class='btn btn--primary start__activity'>Start</a>`
                  : ''
              }              
            </div>
          </div>
        </div>`;
    });

    activities_markdown += ' \
      </div>';

    theme.Account.getActions().html('');
    theme.Account.getContent().html(activities_markdown);
  }

  function _openViewTimeslots(e) {
    e.preventDefault();
    const activity_id = $(this).data().activityId;

    theme.Activities.getActivity(activity_id).then((a) => {
      const { markup, count } = _buildSortedTimeslots(a);

      const string = `
        <div class="timeslots__popup">
          <h1 class="h3">${a.title}</h1>
          <div class="timeslots__popup--select">
            <select data-sort-timeslots data-activity-id="${activity_id}">
              <option value="dateAsc" selected>Show All: Upcoming Activities</option>
              <option value="dateDesc">Show All: By Date</option>
            </select>
          </div>
          <label><span data-popup-timeslots-count>${count}</span> total</label>
          <ol class="timeslots__popup--list" data-popup-timeslots-list>${markup}</ol>
          <button class='btn btn--round btn--primary' data-edit-timeslots data-activity-id='${activity_id}'>Add or Edit Timeslots</button>
        </div>
      `;

      $.fancybox.open(string);
    });
  }

  function _handleTimeslotsSortChange(e) {
    e.preventDefault();

    const ascending = e.target.value === 'dateAsc';
    const activity_id = $(this).data().activityId;

    theme.Activities.getActivity(activity_id).then((a) => {
      const { markup, count } = _buildSortedTimeslots(a, ascending);
      document.querySelector('[data-popup-timeslots-list]').innerHTML = markup;
      document.querySelector('[data-popup-timeslots-count]').innerHTML = count;
    });
  }

  function _buildSortedTimeslots(activity, ascending = true) {
    const variants = [...activity.variants];

    if (!ascending) {
      variants.sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
    }

    const timeslots = variants
      .filter((v) => {
        // ascending AKA "Upcoming Activities" - sort date ascending and hide variants where all sessions are complete
        const isCompleted = v.sessions.every((s) => s.status === 'completed');
        if (ascending && isCompleted) {
          return false;
        }

        // descending AKA "By Date" - sort date descending and hide variants with a session more than 1 year old
        const isMoreThanOneYearOld = v.sessions.some(
          (s) => s.seconds_till_start < -1 * 365 * 24 * 60 * 60
        );
        if (!ascending && isMoreThanOneYearOld) {
          return false;
        }

        return true;
      })
      .map((v) => {
        const edit_markup =
          v.current_participants > 0
            ? `
              <span class="edit_status">Cannot edit 
              
              <div class="tooltip-wrapper" data-tooltip tabindex="0">
                <i class='fas fa-question-circle' aria-label=''></i>
                
                <div class='tooltip-content' data-tooltip-content>
                  <h2>Why can't I edit this Timeslot?</h2>
                  <p>Once Kids have registered into an Activity Timeslot, you cannot change that Timeslot anymore</p>
                </div>
              </div>
            `
            : "<span class='edit_status'>Can edit</span>";

        const schedule = v.sessions
          .map((session) => {
            return theme.Time.convertTimeToDisplay(
              session.datetime,
              session.end_datetime
            );
          })
          .join('<br/>');

        return `
          <li class=${
            v.current_participants > 0 ? 'disabled' : ''
          }><div>${schedule}</div>${edit_markup}</li>
        `;
      });

    return {
      markup: timeslots.join(''),
      count: timeslots.length,
    };
  }

  function _buildEditTimeslots(e) {
    const activity_id = $(this).data().activityId.toString();
    theme.ActivitiesEdit.edit(activity_id);
    $.fancybox.close();
    $(document).arrive('#scheduling-title', _handleSchedulingClick);
  }

  function _buildEditResources(e) {
    const activity_id = $(this).data().activityId.toString();
    theme.ActivitiesEdit.edit(activity_id);
    $(document).arrive('#resource-title', _handleResourcesClick);
  }

  function _handleSchedulingClick(e) {
    if ($('#scheduling-title').attr('aria-expanded') === 'false') {
      $('#scheduling-title').click();
    }
    $('html, body').animate(
      {
        scrollTop: $('#scheduling-title').offset().top - 70,
      },
      700
    );
  }

  function _handleResourcesClick(e) {
    if ($('#resource-title').attr('aria-expanded') === 'false') {
      $('#resource-title').click();
    }
    $('html, body').animate(
      {
        scrollTop: $('#resource-title').offset().top - 70,
      },
      700
    );
  }

  function _openHelp(e) {
    e.preventDefault();
    const string = `<div class='help__modal'>
      <p>We're here with you.</p>
      <p>If you are unable to attend your scheduled activity, please contact us at:</p>
      <a href='mailto:support@homelearnersnetwork.ca'>support@homelearnersnetwork.ca</a>
    </div>`;

    $.fancybox.open(string);
  }

  function _handleShareLinks(e) {
    e.preventDefault();

    if ($(e.target).hasClass('variant_link')) {
      theme.Global.copyToClipboard($(this).data().link, true, 'Link copied');
      return;
    }

    const activity_id = $(this).data().activityId;
    theme.Activities.getActivity(activity_id).then((a) => {
      if (a.variants.length === 1) {
        theme.Global.copyToClipboard(a.variants[0].link, true, 'Link copied');
      } else {
        const links = a.variants
          .map((v) => {
            const title = v.title
              .split(',')
              .map((datetime) => theme.Time.convertTimeToDisplay(datetime))
              .join(' & ');
            return `<li><div>${title}</div><button data-share-link data-link="${v.link}" class='btn btn--secondary btn--round variant_link'>${v.link}<i class="far fa-copy"></i></button></li>`;
          })
          .join('');

        const string = `<div class='share__links'>
          <h1 class='h3'>Share the Links to your Activity</h1>
          <ul>${links}</ul>
          <p class='header_paragraph'>Please only share links with Kids who are enrolled.</p>
          <p>By sharing the link with any other Kids who are not <br/>enrolled, the privacy of enrolled Kids is compromised.</p>
        </div>`;

        $.fancybox.open(string);
      }
    });
  }

  /**
   * Opens a modal with the option to either duplicate an activity or create a new one from scratch
   *
   * @listens document:click:[data-activity-create-options]
   */
  function _openActivityCreateOptions() {
    const markup = `
      <div class='modal'>
        <div class="activity-create-options__modal">
          <h2>What will you do today?</h2>
          <div class="activity-create-options__actions">
            <button class="btn btn--secondary" data-open-activity-duplicate>Duplicate Activity</button>
            <button class="btn btn--primary" data-open-activity-create>Create a New Activity</button>
          </div>
        </div>
      </div>
    `;

    $.fancybox.open(markup, { autoFocus: false });
  }

  /**
   * Opens a modal with a select menu where the user can choose an activity to duplicate
   *
   * @listens document:click:[data-open-activity-duplicate]
   */
  function _openActivityDuplicate() {
    $.fancybox.close();

    theme.Activities.getActivities().then(function (activities) {
      const markup = `
        <div class='modal'>
          <div class="activity-duplicate__modal">
            <h2>Choose an activity to duplicate</h2>
            <select class="activity-duplicate__select" data-activity-duplicate-select>
              <option value="">Select...</option>
              ${Object.values(activities).map(
                (activity) =>
                  `<option data-id="${activity.id}" data-title="${activity.title}">${activity.title}</option>`
              )}
            </select>
            <button class="btn btn--primary activity-duplicate__duplicate" data-activity-duplicate disabled>Duplicate Activity</button>
          </div>
        </div>
      `;

      $.fancybox.open(markup, { autoFocus: false });
    });
  }

  /**
   * Updates the data attributes for the duplicate activity button depending on which activity is selected in a dropdown
   *
   * @listens [data-activity-duplicate-select]
   */
  function _handleChangeActivityToDuplicate() {
    const $duplicateButton = $('[data-activity-duplicate]');
    const id = this.options[this.selectedIndex].getAttribute('data-id');
    const title = this.options[this.selectedIndex].getAttribute('data-title');
    if (id && title) {
      $duplicateButton.attr('data-id', id);
      $duplicateButton.attr('data-title', title);
      $duplicateButton.prop('disabled', false);
    } else {
      $duplicateButton.attr('data-id', '');
      $duplicateButton.attr('data-title', '');
      $duplicateButton.prop('disabled', true);
    }
  }

  /**
   * Builds the create Activity form
   *
   * @listens [data-open-create-activity]
   */
  function _buildCreateActivities() {
    $.fancybox.close();
    const dom = `
      <div class='modal'>
        <div class="account-activity__create">
          <h2>Inspire an <span class="highlight">AHA</span> moment!</h2>
          <p class="account-activity__create--caption">
            Design an <span class="highlight"><b class="text-bold">A</b>t <b>H</b>ome <b>A</span>ctivity</b> for Kids from K - Gr 12.
          </p>

          <h3>What type of <span class="highlight">AHA</span> are you offering?</h3>
          <div class="account-activity__create--grid">
            <div role='button' tabindex='0' data-new-activity='Single'>
              <div class='image-wrapper'>
                <img src='https://cdn.shopify.com/s/files/1/0488/1042/6535/files/image-20201113-233311.png?v=1614376795' alt='' />
              </div>
              <h4>Single</h4>
              <p>Kids join in a video room at a set date and time for one live online activity.</p>
            </div>
            <div role='button' tabindex='0' data-new-activity='Camp'>
              <div class='image-wrapper'>
                <img src='https://cdn.shopify.com/s/files/1/0488/1042/6535/files/image-20201113-233311.png?v=1614376795' alt='' />
              </div>
              <h4>Camp</h4>
              <p>Kids join in a video room over multiple days for a series of live online activities.</p>
            </div>
            <div role='button' tabindex='0' data-new-activity='Series'>
              <div class='image-wrapper'>
                <img src='https://cdn.shopify.com/s/files/1/0488/1042/6535/files/image-20201113-233311.png?v=1614376795' alt='' />
              </div>
              <h4>Series</h4>
              <p>Kids join in a video room over multiple weeks for a series of live online activities.</p>
            </div>
            <div role='button' tabindex='0' data-new-activity='Anytime'>
              <div class='image-wrapper'>
                <img src='https://cdn.shopify.com/s/files/1/0488/1042/6535/files/image-20201113-233311.png?v=1614376795' alt='' />
              </div>
              <h4>Anytime</h4>
              <p>Create an activity that can be done at home anytime by a Kid, solo or with friends.</p>
            </div>
          </div>
        </div>
      </div>
    `;

    $.fancybox.open(dom);
  }

  function _duplicateActivity(e) {
    e.preventDefault();
    $(this).attr('disabled', true);

    var activity_id = $(this).attr('data-id');

    theme.ActivitiesEdit.editDuplicateActivity(activity_id);
    $.fancybox.close();
  }

  return {
    init: init,
    getCache: getCache,
  };
})();

theme.EducatorProfile = (function () {
  var cache = {
    loaded: false,
  };

  function init(container) {
    if (!cache.loaded) {
      $(document).on('click', '[data-guide-image-upload]', function (e) {
        e.preventDefault();
        $('[data-guide-image-file]').click();
      });

      $(document).on('change', '[data-guide-image-file]', uploadImage);
      $(document).on('click', '[data-profile-save]', _handleSubmit);

      $(document).on(
        'click',
        '[data-guide-photo-requirements]',
        _showPhotoRequirements
      );
      window.onbeforeunload = _checkFormBeforeRedirecting;
    }

    theme.Account.reset();
    _setContent();
    cache.form_reset = false;

    cache.loaded = true;
  }

  function uploadImage() {
    var file = this.files[0];
    var reader = new FileReader();

    reader.onload = function (e) {
      $('[data-guide-image]').attr('src', e.target.result);
    };

    reader.onloadend = function () {
      // Since it contains the Data URI, we should remove the prefix and keep only Base64 string
      var b64 = reader.result.replace(/^data:.+;base64,/, '');
      $('[data-guide-image-b64]').val(b64);

      var data = $('[data-guide-profile-form]').serializeObject();

      var data = {
        collection: {
          id: educator_data.id,
          description: data.description,
          image_base64: data.image_base64,
          profile: {
            metafield_id: data.metafield_id,
            credentials: data.credentials,
            fun_facts: data.facts,
          },
        },
      };

      new Promise(function (resolve) {
        proxyApp.request('/collections/' + theme.customer.collection_id, {
          type: 'PUT',
          data: JSON.stringify(data),
          dataType: 'json',
          contentType: 'application/json; charset=utf-8',
        });
      });
    };

    reader.readAsDataURL(file);
  }

  function isFormDirty() {
    var is_form_dirty = false;
    if (!cache.current_profile) {
      return false;
    }
    var form_data = $('.educator__profile').serializeArray();
    if (
      JSON.stringify(form_data) !== cache.current_profile &&
      !cache.form_reset
    ) {
      is_form_dirty = true;
    }
    return is_form_dirty;
  }

  function showDirtyFormModal() {
    const string = `
      <div class="guide-profile__save-modal">
        <h2>Do you want to publish your changes?</h2>
        <p>Your edits will be lost if you do not publish them.</p>
        <div class="guide-profile__save-modal--actions">
          <button class="btn btn--secondary" onclick="$.fancybox.close()">Cancel</button>
          <button class="btn btn--primary" data-profile-save>Publish</button>
        </div>
      </div>
    `;
    $.fancybox.open(string);
  }

  function _checkFormBeforeRedirecting(e) {
    if (
      sessionStorage.getItem('active_account_navigation') !== 'educator-profile'
    ) {
      return;
    }
    if (isFormDirty()) {
      e.returnValue = ''; // Shows browser popup when attempting to navigate away while the form is dirty
    }
  }

  function _setContent() {
    var profile_markup =
      " \
      <form class='educator__profile' data-profile-id='" +
      theme.customer.id +
      "' data-guide-profile-form> \
        <input type='hidden' name='metafield_id' value='' data-guide-metafield-id /> \
        <input type='file' id='profile_image' accept='image/*' style='display: none;' data-guide-image-file /> \
        <input type='hidden' name='image_base64' value='' data-guide-image-b64 /> \
        <div class='guide-profile__image-container'> \
          <div class='guide-profile__image'> \
            <img src='" +
      educator_data.image +
      "' alt='' data-guide-image /> \
          </div> \
          <button class='btn btn--primary guide-profile__image-upload' data-guide-image-upload> \
            Upload Profile \
          </button> \
          <button class='text-link guide-profile__image-requirements' data-guide-photo-requirements>Photo Requirements</button> \
        </div> \
        <div class='guide-profile__info-container'> \
          <h2 class='guide-product__info-title'> \
            " +
      educator_data.name +
      " \
          </h2> \
          <div class='guide-profile__question'> \
            <h3 class='guide-profile__question-label' for='educator-description'> \
              Introduce Yourself to Kids \
              <div class='tooltip-wrapper' tabindex='0' data-tooltip> \
                <div class='tooltip-content' data-tooltip-content> \
                  <h2>Here's a few introduction ideas!</h2> \
                  <ul> \
                    <li>What are your likes, hobbies, and interests?</li> \
                    <li>Where are you from?</li> \
                    <li>What is your educational background?</li> \
                    <li>What brought you to teaching or being a Guide at HLN?</li> \
                    <li>What is your teaching/education philosophy?</li> \
                  </ul> \
                </div> \
              </div> \
            </h3> \
            <p class='guide-profile__question-content'> \
              This information is shared with Kids and families. Share what makes you unique and have fun with it! Max 200 characters. \
            </p> \
            <textarea id='educator-description' name='description'>" +
      (educator_data.description ? educator_data.description : '') +
      "</textarea> \
          </div> \
          <div class='guide-profile__question'> \
            <h3 class='guide-profile__question-label' for='educator-credentials'> \
              What are your credentials? * \
            </h3> \
            <p class='guide-profile__question-content'> \
              e.g. Certified Teacher • BSc, MSc \
            </p> \
            <textarea id='educator-credentials' name='credentials'>" +
      (educator_data.credentials ? educator_data.credentials : ``) +
      "</textarea> \
          </div> \
          <div class='guide-profile__question'> \
            <h3 class='guide-profile__question-label' for='educator-facts'> \
              A Fun Fact About Me is... \
              <div class='tooltip-wrapper' tabindex='0' data-tooltip> \
                <div class='tooltip-content' data-tooltip-content> \
                  <h2>Here's a few fun fact ideas!</h2> \
                  <ul> \
                    <li>Share your favourite childhood memory.</li> \
                    <li>Describe a hidden talent of yours.</li> \
                    <li>Talk about the places you've travelled.</li> \
                    <li>Describe your favourite dance move.</li> \
                    <li>Something about your favourite book.</li> \
                    <li>A random job you've done.</li> \
                  </ul> \
                </div> \
              </div> \
            </h3> \
            <p class='guide-profile__question-content'> \
              Tell Kids something interesting about you! Max 50 characters. \
            </p> \
            <textarea id='educator-facts' name='facts'>" +
      (educator_data.fun_facts ? educator_data.fun_facts : '') +
      "</textarea> \
          </div> \
          <div class='guide-profile__actions'> \
            <button class='btn btn--primary' data-profile-save> \
              Save \
            </button> \
          </div> \
        </div> \
      </form> \
      <div class='guide__infos'> \
        <div class='guide__info'> \
          <h2>How your Guide profile matters</h2> \
          <p>Your Guide profile helps Kids and grown-ups decide whether to register into your activity. Your profile is an opportunity for you to show what kind of educator you are and how you help make the HomeLearners Network vision come to life.</p> \
        </div> \
        <div class='guide__info'> \
          <h2>Your Guide profile is visible on</h2> \
          <ul> \
            <li>HomeLearners Network Guide page</li> \
            <li>HomeLearners Network Home page</li> \
            <li>Product pages of AHAs you guide</li> \
          </ul> \
        </div> \
      </div>";

    theme.Account.getContent().html(profile_markup);

    proxyApp.request('/collections/' + theme.customer.id, {
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      complete: function (res) {
        var data = JSON.parse(res.responseText);
        var profile = data.collection && data.collection.profile;
        $('[data-guide-metafield-id]').val(
          profile && profile.metafield_id ? profile.metafield_id : ''
        );
        $('#educator-credentials').val(
          profile && profile.credentials ? profile.credentials : ''
        );
        $('#educator-facts').val(
          profile && profile.fun_facts ? profile.fun_facts : ''
        );
        cache.current_profile = JSON.stringify(
          $('.educator__profile').serializeArray()
        );
      },
    });
  }

  function _handleSubmit(e) {
    e.preventDefault();
    $.fancybox.close();

    var data = $('[data-guide-profile-form]').serializeObject();

    if (!data.credentials) {
      theme.Global.generateModal(
        'error',
        'Error...',
        'Please fill out the credentials field!'
      );
      return;
    }

    theme.Global.generateModal('ring', 'Saving your profile', 'Please wait...');

    var data = {
      collection: {
        id: educator_data.id,
        description: data.description,
        image_base64: data.image_base64,
        profile: {
          metafield_id: data.metafield_id,
          credentials: data.credentials,
          fun_facts: data.facts,
        },
      },
    };

    new Promise(function (resolve) {
      proxyApp.request('/collections/' + theme.customer.collection_id, {
        type: 'PUT',
        data: JSON.stringify(data),
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: function (r) {
          $.fancybox.close(true);

          theme.Global.generateModal(
            'success',
            'Success!',
            '<p data-educator-profile-saved>Your profile update was succesfully received!</p><p>Your profile may take up to 1 minute to fully update.</p>'
          );
          setTimeout(() => {
            if ($('[data-educator-profile-saved]').length) {
              $.fancybox.close();
            }
          }, 5000);

          cache.form_reset = true;
          resolve(r);
        },
        error: function (r) {
          $.fancybox.close(true);
          console.error(r);
          theme.Global.generateModal(
            'error',
            'Error...',
            'An error has occured, please contact your administrator!',
            r.responseText
          );
        },
      });
    });
  }

  function _showPhotoRequirements(e) {
    e.preventDefault();

    theme.Global.generateModal(
      '',
      'Tips for a stellar profile photo:',
      '<ul><li>Smile! Make sure your face is centered. Include part of your neck in the photo.</li><li>Take the photo in a 1x1 aspect ratio.</li><li>Be in a well-lit space, like outside on a bright cloudy day. Try to avoid or soften harsh light that creates sharp shadows under your eyes or brows.</li><li>Use your best camera, with a clean lens.</li><li>Check your background and make sure it is free of distractions.</li></ul>'
    );
  }

  return {
    init: init,
    isFormDirty: isFormDirty,
    showDirtyFormModal: showDirtyFormModal,
  };
})();

theme.LearnerProfile = (function () {
  var cache = {
    hex_codes: [
      theme.colors.blue,
      theme.colors.purple,
      theme.colors.green,
      theme.colors.yellow,
      theme.colors.orange,
    ],
  };

  function _init() {
    if (theme.template == 'customers/account') {
      _showWelcomePrompt();
    }

    $(document).on('click', '[data-switch-profile]', buildProfileSelector);

    $(document).on('click', '[data-modal-profile-button]', function (e) {
      e.preventDefault();

      const selected_profile =
        theme.customer.profiles[$(this).data().profileId];
      selectProfile(selected_profile);
    });

    $(document).on('click', '[data-learner-edit]', editProfileForm);
    $(document).on('click', '[data-learner-save]', saveProfile);
    $(document).on('click', '[data-input-icon]', function () {
      $(this).siblings('input').focus();
    });
    $(document).on(
      'click',
      '[data-expand-privacy-information]',
      _handleExpandPrivacyInformation
    );
    $(document).on('input', '[data-kid-textarea]', _handleTextareaChanged);

    $(document).on(
      'click',
      '[data-learner-delete-trigger]',
      buildProfileDelete
    );
    $(document).on('click', '[data-learner-delete]', deleteProfile);

    if (theme.customer && theme.customer.is_learner) {
      _cacheActiveProfile();
    } else {
      sessionStorage.removeItem('active_profile');
    }
  }

  function _cacheActiveProfile() {
    _setProfile(_getActiveProfile());
  }

  function _getActiveProfile() {
    if (sessionStorage.getItem('active_profile')) {
      return theme.customer.profiles[sessionStorage.getItem('active_profile')];
    } else {
      return theme.customer.parent_profile
        ? theme.customer.parent_profile
        : undefined;
    }
  }

  /**
   * Sets the passed profile to sessionStorage and re-renders the current account view and header dropdown
   *
   * @param {object} profile An object containing data for a single profile
   * @see            selectProfile
   */
  function _setProfile(profile) {
    if (!profile) {
      profile = theme.customer.parent_profile
        ? theme.customer.parent_profile
        : { id: undefined, first_name: theme.customer.first_name };
    }

    cache.active_profile = profile;

    sessionStorage.setItem('active_profile', profile.id);

    $('.account-dropdown__title-initials').html(profile.first_name[0]);
    $('.account-dropdown__title-initials').css('background-color', profile.hex);

    $('.account-dropdown__title-name').html(profile.first_name);
    $('.site-header__toggle-action').html(`Hi, ${profile.first_name}`);

    if (theme.customer.parent_profile.id == profile.id) {
      $('.account-dropdown__title').addClass('account-dropdown__title--parent');
    } else {
      $('.account-dropdown__title').removeClass(
        'account-dropdown__title--parent'
      );
      $('.account-dropdown__learner-edit[data-learner-edit]').attr(
        'data-profile-id',
        profile.id
      );
    }

    if (theme.template.indexOf('customers/account') > -1) {
      // Skip activities loading if query params contains a navigation tab because it will be handled by AccountNavigation
      const params = new URLSearchParams(window.location.search);
      if (!params.has('q')) {
        theme.LearnerActivities.init(
          sessionStorage.getItem('active_account_navigation')
        );
      }
    }
  }

  /**
   * Sets the passed profile as the active profile and re-renders the account page profile banner with the new active profile.
   *
   * @param   {object} profile An object containing data for a single profile
   *
   * @listens document:click:.account__profile
   *
   * @see     _setProfile,
   */
  function selectProfile(profile) {
    _setProfile(profile);

    if (theme.template == 'product') {
      theme.Product.updatePostPurchaseData();
    }

    $.fancybox.close();
  }

  function generateProfileIcon(profile, show_name) {
    if (!profile) {
      return;
    }
    return `
      <div class='profile__icon fun' ${
        profile.hex ? `style='background-color: ${profile.hex}'` : ''
      }>
        <span data-profile-icon>${profile.first_name[0]}</span>
        ${show_name ? '' : ''}
      </div>
      ${
        show_name
          ? `<label class='profile__icon--name'>${profile.first_name}</label>`
          : ''
      }
     `;
  }

  /**
   * Opens a modal where a learner can select a profile to be the active profile.
   * Shows two different views depending on whether a profile is currently active or not.
   *
   * @listens document:click:[data-switch-profile]
   */
  function buildProfileSelector() {
    const active_profile = sessionStorage.getItem('active_profile');

    if (Object.values(theme.customer.profiles).length == 0) {
      return false;
    }

    let markup = `
      <div class='profiles-container'>
        <h2 class='profiles-container__title'>Switch Profile</h2>
        
        <ul class='profiles-container__list'>`;
    $.each(theme.customer.profiles, function (key, profile) {
      if (key == 'length') return true;
      if (key == active_profile) return true;

      markup += `
              <li class='profiles-container__profile'>
                <button data-profile-index='${key}' data-profile-id='${key}' class='naked-link' data-modal-profile-button>
                <span class='profiles-container__profile-icon' style='background-color: ${
                  profile.hex
                };'>
                  ${profile.first_name[0]}
                </span>
                <label class='profiles-container__profile-name'>
                  ${
                    theme.customer.parent_profile.id == profile.id
                      ? `<img src='https://cdn.shopify.com/s/files/1/0450/1418/8196/files/Crown-icon.png?v=1649358188' alt='A crown icon' />`
                      : ''
                  }
                  ${profile.first_name}
                </label>
              </button>
            </li>`;
    });
    markup += `
          <li class='profiles-container__profile'>
            <button class='text-link' data-learner-edit>
              <span class="material-icons">person_add</span>
              <label class='profiles-container__profile-name'>Add a kid</label>
            </button>
          </li>
        </ul>
      </div>`;

    $.fancybox.open(markup);
  }

  /**
   * Opens a modal prompting the user to confirm if they want to delete a profile
   *
   * @listens document:click:[data-account-learner-profile-delete]
   *
   * @param   {*} e jQuery event object
   */
  function buildProfileDelete() {
    var string = `
      <div class='modal'> \
        <div class='profile-delete'>
          <h2>Are you sure you want to delete?</h2>
          <p>Any activities assigned to this profile will be assigned to the grown-up's profile.</p>
          <div class="profile-delete__actions">
            <button class="btn btn--primary" data-learner-delete data-profile-id="${cache.active_profile.id}">Delete</button>
            <button class="btn btn--secondary" onclick="$.fancybox.close()">Cancel</button>
          </div>
        </div>
      </div>
    `;

    $.fancybox.open(string);
  }

  /**
   * Opens a modal with a form for creating a new learner profile
   *
   * @listens document:click:[data-learner-edit]
   */
  function editProfileForm(e) {
    $.fancybox.close();

    let profile = false;
    let is_parent = false;

    if (typeof e == 'object') {
      var profile_id = $(this).attr('data-profile-id');

      if (profile_id) {
        profile = theme.customer.profiles[profile_id];
      }
    } else if (typeof e == 'string') {
      profile = theme.customer.profiles[e];
    }

    if (profile && theme.customer.parent_profile.id == profile.id) {
      is_parent = true;
    }

    const random_index = Math.floor(Math.random() * cache.hex_codes.length);

    if (is_parent) {
      var form = `
        <form class="profile-edit__form" action='/profile/update' method='post' data-learner-edit-form>
          <input type="hidden" name="customer_id" required value="${
            theme.customer.id
          }" />
          <input type="hidden" name="id" value="${profile.id}" />
          ${
            profile.hex
              ? `<input type="hidden" name="hex" required value="${profile.hex}" />`
              : `<input type="hidden" name="hex" required value="${cache.hex_codes[random_index]}" />`
          }

          <fieldset>
            <legend>Family Profile</legend>
            <div class='row'>
              <label for='first_name' class='row__title'>First Name</label>
              <input type="text" required id='first_name' name="first_name" value='${
                profile.first_name
              }'' />
            </div>
            <div class="row">
              <label for='initials' class='row__title'>Family Education Approach</label>
              <div class='row__checkboxes'>
                <div class='row__checkbox'>
                  <input ${
                    profile.family_education_approach &&
                    profile.family_education_approach.indexOf('Homeschool') > -1
                      ? "checked='checked'"
                      : null
                  } id="family_education_approach.homeschool" type="checkbox" name="family_education_approach.[]" value="Homeschool" >
                  <label for='family_education_approach.homeschool'>Homeschool</label>
                </div>
                <div class='row__checkbox'>
                  <input ${
                    profile.family_education_approach &&
                    profile.family_education_approach.indexOf('Public School') >
                      -1
                      ? "checked='checked'"
                      : null
                  } id='family_education_approach.publicschool' type="checkbox" name="family_education_approach.[]" value="Public School" >
                  <label for='family_education_approach.publicschool'>Public School</label>
                </div>
                <div class='row__checkbox'>
                  <input ${
                    profile.family_education_approach &&
                    profile.family_education_approach.indexOf(
                      'Private School'
                    ) > -1
                      ? "checked='checked'"
                      : null
                  } id='family_education_approach.privateschool' type="checkbox" name="family_education_approach.[]" value="Private School" >
                  <label for='family_education_approach.privateschool'>Private School</label>
                </div>
                <div class='row__checkbox'>
                  <input ${
                    profile.family_education_approach &&
                    profile.family_education_approach.indexOf(
                      'Online Learning'
                    ) > -1
                      ? "checked='checked'"
                      : null
                  } id='family_education_approach.online' type="checkbox" name="family_education_approach.[]" value="Online Learning" >
                  <label for='family_education_approach.online'>Online Learning</label>
                </div>
                <div class='row__checkbox'>
                  <input ${
                    profile.family_education_approach &&
                    profile.family_education_approach.indexOf('Unschooling') >
                      -1
                      ? "checked='checked'"
                      : null
                  } id='family_education_approach.unschooling' type="checkbox" name="family_education_approach.[]" value="Unschooling" >
                  <label for='family_education_approach.unschooling'>Unschooling</label>
                </div>                  
              </div>
            </div>
          </fieldset>

          <div class='row center'>
            <button type="submit" class="btn btn--primary" data-learner-save>Save</button>
          </div>
        </form>
      `;
    } else {
      // Support for old style of online_support
      if (
        typeof profile.online_support === 'object' &&
        !Array.isArray(profile.online_support)
      ) {
        profile.online_support = Object.keys(profile.online_support);
      }

      var form = `
        <div class="profile-edit__banner">
          <div class="profile-edit__banner--title">
            <h2 class="center">${profile ? 'Edit a Kid' : 'Add a Kid'}</h2>
            <div><img src="https://cdn.shopify.com/s/files/1/0450/1418/8196/files/STICKfigures-Kidandparent-sm_1.png?v=1691617566" alt="Kid and parent stick figures"></div>
          </div>
          ${
            profile
              ? ''
              : `<p class="center">Create a Kid account to register your kid or teen for Activities.</p>`
          }
        </div>
        <form class="profile-edit__form" action='/profile/update' method='post' data-learner-edit-form>
          <input type="hidden" name="customer_id" required value="${
            theme.customer.id
          }" />
          ${
            profile
              ? `<input type="hidden" name="id" required value="${profile.id}" />`
              : ``
          }
          ${
            profile && profile.hex
              ? `<input type="hidden" name="hex" required value="${profile.hex}" />`
              : `<input type="hidden" name="hex" required value="${cache.hex_codes[random_index]}" />`
          }

          <div class="row__two-column">
            <div class='row'>
              <label for='first_name' class='row__title'>First Name of the kid *</label>
              <p class='row__info'>The name will be displayed in the Dashboard and menu.</p>
              <input type="text" required id='first_name' name="first_name" maxlength="15" value='${
                profile ? profile.first_name : ''
              }' placeholder="e.g. Jess">
            </div>

            <div class='row'>
              <label for='pronoun' class='row__title'>Pronouns *</label>
              <p class='row__info'>How should a Guide refer to this kid?</p>
              <input type="text" required id='pronoun' name="pronoun" maxlength="15" value='${
                profile ? profile.pronoun : ''
              }' placeholder="e.g. she, he, they, other">
            </div>
          </div>

          <div class="row__two-column">
            <div class='row'>              
              <label for='date_of_birth' class='row__title'>Date of Birth *</label>
              <div class="profile-edit__icon-input">
                <input autocomplete="off" type="text" required id='date_of_birth' class="date-picker" name="date_of_birth" value='${
                  profile ? profile.date_of_birth : ''
                }''>
                <span class="material-icons" data-input-icon>calendar_today</span>
              </div>
            </div>

            <div class='row'>        
              <label for='reading_level' class='row__title'>Reading Level *</label>
              <p class='row__info'>What is the kid's reading level?</p>
              <select id="reading_level" required name="reading_level">
                ${
                  profile
                    ? ''
                    : "<option disabled selected='selected'>Please choose</option>"
                }
                <option ${
                  profile && profile.reading_level == 'beginner'
                    ? "selected='selected'"
                    : ''
                } value='beginner'>Beginner</option>
                <option ${
                  profile && profile.reading_level == 'intermediate'
                    ? "selected='selected'"
                    : ''
                } value='intermediate'>Intermediate</option>
                <option ${
                  profile && profile.reading_level == 'advanced'
                    ? "selected='selected'"
                    : ''
                } value='advanced'>Advanced</option>
              </select>
            </div>
          </div>

          <div class='row'>          
            <label for='interests' class='row__title'>Interests</label>
            <p class='row__info'>What are this kid's interests? Separate each with a comma.</p>
            <div class="profile-edit__textarea-charlimit">
              <textarea required id='interests' name="interests" placeholder="e.g. kayaking, arts and crafts" maxlength="100" data-kid-textarea="interests">${
                profile && profile.interests ? profile.interests : ''
              }</textarea>
              <div class="profile-edit__textarea-count"><span id="kid_text_interests">${
                profile && profile.interests ? profile.interests.length : '0'
              }</span> / 100</div>
            </div>
          </div>
        
          
          <div class='row'>
            <label class='row__title'>Support Areas</label>
            <p class='row__info'>Review the steps, details, and tools required for an activity in advance  </p>
            <div class='row__checkboxes'>
            <label>My kid learns best when they:</label>
              <div class='inline_checkbox'>
              <input ${
                profile &&
                profile.online_support &&
                profile.online_support.indexOf('review_steps') > -1
                  ? "checked='checked'"
                  : null
              } id="online_support.review_steps" type="checkbox" name="online_support.[]" value="review_steps" >
              <label for='online_support.review_steps'>Review the steps, details, and tools required for an activity in advance </label>
            </div>
            <div class='inline_checkbox'>
                <input ${
                  profile &&
                  profile.online_support &&
                  profile.online_support.indexOf('additional_instructions') > -1
                    ? "checked='checked'"
                    : null
                } id="online_support.additional_instructions" type="checkbox" name="online_support.[]" value="additional_instructions" >
                <label for='online_support.additional_instructions'>Have visuals to support verbal instructions </label>
              </div>
              <div class='inline_checkbox'>
                <input ${
                  profile &&
                  profile.online_support &&
                  profile.online_support.indexOf('simplified_instructions') > -1
                    ? "checked='checked'"
                    : null
                } id='online_support.simplified_instructions' type="checkbox" name="online_support.[]" value="simplified_instructions" >
                <label for='online_support.simplified_instructions'>Have simplified instructions in a step-by-step form or checklist.</label>
              </div>
              <div class='inline_checkbox'>
                <input ${
                  profile &&
                  profile.online_support &&
                  profile.online_support.indexOf('focused_instructions') > -1
                    ? "checked='checked'"
                    : null
                } id='online_support.focused_instructions' type="checkbox" name="online_support.[]" value="focused_instructions" >
                <label for='online_support.focused_instructions'>See fewer items on a page or line and/or larger font size to read easily</label>
              </div>
              <div class='inline_checkbox'>
                <input ${
                  profile &&
                  profile.online_support &&
                  profile.online_support.indexOf('extra_time') > -1
                    ? "checked='checked'"
                    : null
                } id='online_support.extra_time' type="checkbox" name="online_support.[]" value="extra_time" >
                <label for='online_support.extra_time'>Have extra time to process oral information and directions</label>
              </div>
              <div class='inline_checkbox'>
              <input ${
                profile &&
                profile.online_support &&
                profile.online_support.indexOf('response_time') > -1
                  ? "checked='checked'"
                  : null
              } id='online_support.response_time' type="checkbox" name="online_support.[]" value="response_time" >
              <label for='online_support.response_time'>Have time to provide verbal or written responses when called upon </label>
            </div>
              <div class='inline_checkbox'>
                <input ${
                  profile &&
                  profile.online_support &&
                  profile.online_support.indexOf('self_regulation') > -1
                    ? "checked='checked'"
                    : null
                } id='online_support.self_regulation' type="checkbox" name="online_support.[]" value="self_regulation" >
                <label for='online_support.self_regulation'>Use self-regulation tools to help them focus such as fidget toys, doodling, etc.</label>
              </div>
              <div class='inline_checkbox'>
                <input ${
                  profile &&
                  profile.online_support &&
                  profile.online_support.indexOf('frequent_breaks') > -1
                    ? "checked='checked'"
                    : null
                } id='online_support.frequent_breaks' type="checkbox" name="online_support.[]" value="frequent_breaks" >
                <label for='online_support.frequent_breaks'>Have frequent breaks and/or movement breaks </label>
              </div>
              <div class='inline_checkbox'>
                <input ${
                  profile &&
                  profile.online_support &&
                  profile.online_support.indexOf('limited_comfort') > -1
                    ? "checked='checked'"
                    : null
                } id='online_support.limited_comfort' type="checkbox" name="online_support.[]" value="limited_comfort" >
                <label for='online_support.limited_comfort'>Have their camera and/or microphone off until they are comfortable. </label>
              </div>
              <div class='inline_checkbox'>
              <input ${
                profile &&
                profile.online_support &&
                profile.online_support.indexOf('zoom_message') > -1
                  ? "checked='checked'"
                  : null
              } id='online_support.zoom_message' type="checkbox" name="online_support.[]" value="zoom_message" >
              <label for='online_support.zoom_message'>Can message the Guide directly in Zoom, rather than using group chat. </label>
            </div>
            </div>
          </div>

          <div class='row'>          
          <label for='more_info' class='row__title'>More information I want the Guide to know</label>
          <div class="profile-edit__textarea-charlimit">
            <textarea required id='more_info' name="more_info" maxlength="500" data-kid-textarea="more_info">${
              profile && profile.more_info ? profile.more_info : ''
            }</textarea>
            <div class="profile-edit__textarea-count"><span id="kid_text_more_info">${
              profile && profile.more_info ? profile.more_info.length : '0'
            }</span> / 500</div>
          </div>
        </div>

        <div class='row'>          
        <label for='uses_technology' class='row__title'>My kid uses technology to support their learning in these ways:</label>
        <div class="profile-edit__textarea-charlimit">
          <textarea required id='uses_technology' name="uses_technology" maxlength="500" data-kid-textarea="uses_technology">${
            profile && profile.uses_technology ? profile.uses_technology : ''
          }</textarea>
          <div class="profile-edit__textarea-count"><span id="kid_text_uses_technology">${
            profile && profile.uses_technology
              ? profile.uses_technology.length
              : '0'
          }</span> / 500</div>
        </div>
      </div>

          <div class="profile-edit__privacy">
            <div class="profile-edit__privacy--title profile-edit__privacy--title-desktop h4">How We Use This Information</div>
            <button class="profile-edit__privacy--title profile-edit__privacy--title-mobile" data-expand-privacy-information aria-controls="profile-edit__privacy--body" aria-expanded="false">
              <span>How We Use This Information</span>
              <span class="material-icons profile-edit__privacy--down">arrow_drop_down</span>
              <span class="material-icons profile-edit__privacy--up">arrow_drop_up</span>
            </button>
            <div id="profile-edit__privacy--body" class="profile-edit__privacy--body">
              We collect this information to help our Guides provide better support during our Realtime Activities.
              It will only be shared with a Guide after you register a Kid for an Activity led by that Guide.
              All information collected is stored safely and securely as outlined in our <a href="/pages/privacy-policy" class="text-link" target="_blank"><strong>Privacy Policy</strong></a>.
            </div>
          </div>

          <div class="row center">
            <button type="submit" class="btn btn--primary small" data-learner-save>${
              profile ? 'Save' : 'Create Kid Account'
            }</button>
          </div>
        </form>`;
    }

    let markup = `
      <div class='modal profile-edit'>
        <div class='profile-edit__content'>
          ${form}
        </div>
      </div>`;

    $.fancybox.open(markup);
  }

  function _handleTextareaChanged(e) {
    let targetId = e.target.id;
    $(`[id="kid_text_${targetId}"]`).html(e.target.value.length);
  }

  function _handleExpandPrivacyInformation(e) {
    e.preventDefault();
    const expanded = $(this).attr('aria-expanded');

    if (expanded === 'false') {
      $('.profile-edit__privacy--down').hide();
      $('.profile-edit__privacy--body, .profile-edit__privacy--up').show();
      $(this).attr('aria-expanded', 'true');
    } else {
      $('.profile-edit__privacy--body, .profile-edit__privacy--up').hide();
      $('.profile-edit__privacy--down').show();
      $(this).attr('aria-expanded', 'false');
    }
  }

  function _openProfileCreatedModal() {
    const string = `
      <div class="modal profile-created">
        <img src="https://cdn.shopify.com/s/files/1/0450/1418/8196/files/CONGRATULATIONS_C_1.png?v=1657057127" alt="Congratulations banner">
        <h3>You've added a Kid</h3>
        <p>Now go register your kid or teen in something amazing.</p>
        <a href="/collections/realtime" class="btn btn--highlight">Explore Activities</a>
      </div>
    `;

    $.fancybox.open(string);
  }

  function _openProfileUpdatedModal(e) {
    const string = `
      <div class="modal profile-created profile-updated">
        <img src="https://cdn.shopify.com/s/files/1/0450/1418/8196/files/PHI_ICON_Blue.jpg?v=1646766840" alt="Blue checkmark">
        <h3>Changes saved</h3>
        <p>Guides can see the updated details about this Kid.</p>
        <a href="/account" class="btn btn--highlight">Return to Dashboard</a>
      </div>
    `;

    $.fancybox.open(string);
  }

  /**
   * Initiates AJAX call to the backend to save a learner profile
   *
   * @listens document:click:[data-learner-profile-submit]
   *
   * @param   {*} e jQuery event object
   *
   * @returns {Promise} AJAX call to the /user_profiles proxy app endpoint
   */
  function saveProfile(e) {
    e.preventDefault();

    var errors = [];

    var form = $('[data-learner-edit-form]').serializeArray();
    var data = {};

    form.forEach((field) => {
      if (field.name.indexOf('.') > -1) {
        var key = field.name.split('.')[0];

        if (!data[key]) {
          data[key] = [];
        }

        data[key].push(field.value.trim());
      } else {
        data[field.name] = field.value.trim();
      }
    });

    if (data.id) {
      var route = `/user_profiles/${theme.customer.id}`;
      var method = 'PUT';
    } else {
      var route = `/user_profiles`;
      var method = 'POST';
    }

    if (data.first_name == '') {
      errors.push({
        target: 'first_name',
        message: 'Required',
      });
    }

    if (data.pronoun == '') {
      errors.push({
        target: 'pronoun',
        message: 'Required',
      });
    }

    if (!data.reading_level) {
      errors.push({
        target: 'reading_level',
        message: 'Required',
      });
    }

    if (data.date_of_birth == '') {
      errors.push({
        target: 'date_of_birth',
        message: 'Required',
      });
    } else if (
      typeof data.date_of_birth == 'string' &&
      data.date_of_birth != ''
    ) {
      var pattern = /^\d{4}-\d{2}-\d{2}$/;

      if (!pattern.test(data.date_of_birth)) {
        errors.push({
          target: 'date_of_birth',
          message: 'Please enter a valid birthday',
        });
      }
    }

    if (typeof data.interests == 'string' && data.interests != '') {
      if (data.interests.length > 100) {
        errors.push({
          target: 'interests',
          message: 'Max character limit reached',
        });
      }
    }

    $('input, select, textarea').removeAttr('aria-invalid');
    $('.row__error').remove();
    $('.validation-error').removeClass('validation-error');

    // Hack way to find out if your profile is a parent or not.
    if (!data.pronoun) {
      if (!data.family_education_approach) {
        data.family_education_approach = [];
      }
    }

    if (errors.length > 0) {
      errors.forEach((error, index) => {
        var target = document.querySelector("[name='" + error.target + "']");
        target.classList.add('validation-error');
        target.insertAdjacentHTML(
          'afterend',
          "<p role='alert' class='row__error'>" + error.message + '</p>'
        );
        target.setAttribute('aria-invalid', true);

        document
          .querySelector('.row__error')
          .scrollIntoView({ behavior: 'smooth' }); // jQuery animate was not working at all within modals so use native scroll + scroll margin instead
      });
    } else {
      $.fancybox.close(true);
      theme.Global.generateModal(
        'ring',
        'Saving your profile',
        'Please wait...'
      );

      var promise = new Promise(function (resolve, reject) {
        proxyApp.request(route, {
          type: method,
          data: JSON.stringify({ user_profile: data }),
          dataType: 'json',
          contentType: 'application/json; charset=utf-8',
          success: function (r) {
            $.fancybox.close(true);

            if (method == 'POST') {
              _openProfileCreatedModal();
            } else {
              _openProfileUpdatedModal();
            }

            theme.customer.profiles[r.user_profile.id] = r.user_profile;
            resolve(r);
          },
          error: function (r) {
            $.fancybox.close(true);

            console.error(r);
            theme.Global.generateModal(
              'error',
              'Error...',
              'An error has occured, please contact your administrator!',
              r.responseText
            );
          },
        });
      });

      return promise;
    }
  }

  function deleteProfile() {
    $.fancybox.close(true);
    theme.Global.generateModal(
      'ring',
      'Deleting your profile',
      'Please wait...'
    );

    const profile_id = $(this).attr('data-profile-id');
    const route = `/user_profiles/${encodeURIComponent(
      profile_id
    )}?customer_id=${encodeURIComponent(theme.customer.id)}`;

    return new Promise(function (resolve) {
      proxyApp.request(route, {
        type: 'DELETE',
        data: {},
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: function (r) {
          $.fancybox.close(true);

          sessionStorage.removeItem('active_profile');
          delete theme.customer.profiles[profile_id];

          _cacheActiveProfile();

          theme.Global.generateModal(
            'success',
            'Success!',
            '<p>Your profile was successfully deleted!</p>'
          );
          resolve(r);
        },
        error: function (r) {
          $.fancybox.close(true);

          console.error(r);
          theme.Global.generateModal(
            'error',
            'Error...',
            'An error has occured, please contact your administrator!',
            r.responseText
          );
        },
      });
    });
  }

  function _showWelcomePrompt(override) {
    if (localStorage.getItem('newUser') || override) {
      fbq('trackCustom', 'consentGiven', { customerId: theme.customer.id });

      localStorage.removeItem('newUser');
      var markup = `
        <div class="account-welcome">
          <h2 class="account-welcome__title account-welcome__title--quote">Well hello! And welcome to</h2>
          <h2 class="account-welcome__title">HomeLearners Network</h2>
          <div class="account-welcome__body">
            <img src="https://cdn.shopify.com/s/files/1/0450/1418/8196/files/YellowabletGuy_1.png?v=1650489152" alt="Welcome Tablet Icon">
            <div>
              <p class="h2">Let's get started!</p>
              <button class="btn btn--primary small" data-learner-edit>Add a Kid</button>
            </div>
          </div>
        </div>
      `;
      $.fancybox.open(markup, { autoFocus: false });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    _init();
  });

  return {
    buildProfileSelector: buildProfileSelector,
    editProfileForm: editProfileForm,
    generateProfileIcon: generateProfileIcon,
    _showWelcomePrompt: _showWelcomePrompt,
  };
})();

theme.LearnerActivities = (function () {
  var cache = {
    loaded: false,
  };

  function init(container) {
    if (theme.customer && !theme.customer.is_learner) {
      return;
    }

    if (!cache.loaded) {
      cache.loaded = true;

      // Activity Card Functions
      $(document).on(
        'click',
        '[data-change-participant]',
        _initializeParticipantChange
      );
      $(document).on(
        'click',
        '[data-show-participation-switch-view]',
        _showParticipationSwitchView
      );
      $(document).on(
        'click',
        '[data-show-participation-change-view]',
        _showParticipationChangeView
      );
      $(document).on(
        'click',
        '[data-learner-activity-profile-update]',
        _updateActivityProfile
      );

      $(document).on(
        'click',
        '[data-learner-card-schedule-open]',
        _openActivityScheduleModal
      );
      $(document).on(
        'click',
        '[data-learner-activity-open]',
        _openActivityDetails
      );
      $(document).on('keydown', '[data-learner-activity-open]', function (e) {
        if (e.keyCode === 13 || e.keyCode === 32) {
          $(this).click();
        }
      });
      $(document).on(
        'click',
        '[data-toggle-session-resources]',
        _handleToggleSessionResources
      );
      $(document).on(
        'click',
        '[data-learner-activity-close]',
        _closeActivityDetails
      );
    }

    if (theme.Account) {
      // If the current profile is set to the parent profile. cache.current_profile will be set to 0.
      if (
        theme.customer &&
        theme.customer.is_learner &&
        theme.customer.parent_profile
      ) {
        if (sessionStorage.getItem('active_profile') == 'undefined') {
          sessionStorage.setItem(
            'active_profile',
            theme.customer.parent_profile.id
          );
        }

        cache.current_profile =
          sessionStorage.getItem('active_profile') ==
          theme.customer.parent_profile.id
            ? 0
            : sessionStorage.getItem('active_profile');
      }

      theme.Activities.getActivities().then(function (activity_data) {
        cache.activity_data = activity_data;

        const sortedActivities = _sortLearnerActivities(activity_data).filter(
          (activity) =>
            cache.current_profile === 0 ||
            cache.current_profile === activity.participant
        );

        if (container === 'learner-realtime-activities') {
          _buildRealtimeActivityCards(sortedActivities);
        } else if (container === 'learner-anytime-activities') {
          _buildAnytimeActivityCards(sortedActivities);
        } else if (container === 'learner-completed-activities') {
          _buildCompletedActivityCards(sortedActivities);
        }
      });
    }
  }

  function _sortLearnerActivities(activities) {
    if (!activities || !activities.length) {
      return [];
    }

    function sortActivities(a, b) {
      if (a.next_session == -1 || b.next_session == -1) {
        return 0;
      }

      if (a.sessions[a.next_session].date < b.sessions[b.next_session].date) {
        return -1;
      }

      if (a.sessions[a.next_session].date > b.sessions[b.next_session].date) {
        return 1;
      }
      return 0;
    }

    return activities.sort(sortActivities);
  }

  function _buildRealtimeActivityCards(activities) {
    const filteredActivities = activities.filter((activity) => {
      if (activity.type == 'Anytime') {
        return false;
      }

      const hasUncompletedSession = activity.sessions.some(
        (session) => session.status != 'completed'
      );

      return hasUncompletedSession;
    });

    let string = "<div class='account-activities'>";
    if (!filteredActivities.length) {
      string += `
        <div class='account-activities__empty'>
          You do not have any upcoming activities. <a class='text-link' href='/collections/all'>Start Shopping!</a>
        </div>
      `;
    } else {
      string += `<div class='account-activity-list' data-completed-activity-list>`;

      filteredActivities.forEach((activity, index) => {
        const currentSession = activity.sessions.findIndex(
          (session) => session.status !== 'completed'
        );
        string += _buildLearnerRealtimeActivityCard(activity, currentSession);
      });

      string += '</div>';
    }

    string += '</div>';

    theme.Account.getContent().html(string);
  }

  function _buildAnytimeActivityCards(activities) {
    const filteredActivities = activities.filter(
      (activity) => activity.type === 'Anytime'
    );

    let string = "<div class='account-activities'>";
    if (!filteredActivities.length) {
      string += `
        <div class='account-activities__empty'>
          You do not have any upcoming activities. <a class='text-link' href='/collections/all'>Start Shopping!</a>
        </div>
      `;
    } else {
      string += `<div class='account-activity-list' data-completed-activity-list>`;

      filteredActivities.forEach((activity) => {
        string += _buildLearnerAnytimeActivityCard(activity);
      });

      string += '</div>';
    }

    string += '</div>';

    theme.Account.getContent().html(string);
  }

  function _buildCompletedActivityCards(activities) {
    const filteredActivities = activities.filter((activity) => {
      if (activity.type === 'Anytime') {
        return false;
      }

      const hasUncompletedSession = activity.sessions.some(
        (session) => session.status !== 'completed'
      );

      return !hasUncompletedSession;
    });

    let string = "<div class='account-activities'>";
    if (!filteredActivities.length) {
      string += `
        <div class='account-activities__empty'>
          You have not completed any activities.
        </div>
      `;
    } else {
      string += `<div class='account-activity-list' data-completed-activity-list>`;

      filteredActivities.forEach((activity) => {
        string += _buildLearnerRealtimeActivityCard(activity, 0, true);
      });

      string += '</div>';
    }

    string += '</div>';

    theme.Account.getContent().html(string);
  }

  /**
   * Returns markup for a learner anytime activity card
   *
   * @param {Object}  activity          Activity data
   */
  function _buildLearnerAnytimeActivityCard(activity) {
    const string = `
      <div class='learner-card' data-activity-type='${
        activity.type
      }' data-unique-key="${
      activity.unique_key
    }" data-learner-activity-open tabindex="0" role="button">
        <div class='learner-card__badge learner-card__badge--${
          activity.type
        }'>${activity.type}</div>
        <div class='learner-card__image video-wrapper image-wrapper'>
          ${activity.media
            .map((media) => (media.type === 'image' ? media.markup : ''))
            .join('')}
        </div>
        <div class='learner-card__details'>
          <label class='learner-card__title'>${activity.title}</label>
          <label>Access for a lifetime</label>
        </div>
      </div>
    `;

    return string;
  }

  /**
   * Returns markup for a learner realtime activity card
   *
   * @param {Object}   product           Product data
   * @param {Number}   current_session   The next or current active session
   * @param {Boolean}  isComplete        Whether or not all of the sessions are completed
   */
  function _buildLearnerRealtimeActivityCard(
    activity,
    current_session,
    isComplete = false
  ) {
    let cardDetailsMarkup = '';
    if (isComplete) {
      cardDetailsMarkup = `<label>Completed ${theme.Time.convertTimeToDisplayDateAndYearOnly(
        activity.sessions[activity.sessions.length - 1].datetime
      )}</label>`;
    } else {
      cardDetailsMarkup = `
        <label class='learner-card__time'>${theme.Time.convertTimeToDisplayTimeOnly(
          activity.sessions[current_session].datetime
        )} - ${theme.Time.convertTimeToDisplayTimeOnly(
        activity.sessions[current_session].end_datetime
      )}</label>
        ${
          activity.type === 'Single'
            ? `<label class='learner-card__datetime'>${theme.Time.convertTimeToDisplayDateAndYearOnly(
                activity.sessions[current_session].datetime
              )}</label>`
            : `<div class='learner-card__schedule-label'>
              Next on: <button class='learner-card__schedule-open' data-unique-key="${
                activity.unique_key
              }" data-learner-card-schedule-open>${theme.Time.convertTimeToDisplayDateAndYearOnly(
                activity.sessions[current_session].datetime
              )} <span class="material-icons">keyboard_arrow_down</span></button>
            </div>`
        }
      `;
    }

    const string = `
      <div class='learner-card' data-activity-type='${
        activity.type
      }' data-unique-key="${
      activity.unique_key
    }" data-learner-activity-open data-current-session="${current_session}" tabindex="0" role="button">
        <div class='learner-card__badge learner-card__badge--${
          activity.type
        }'>${activity.type}</div>
        <div class='learner-card__image video-wrapper image-wrapper'>
          ${activity.media
            .map((media) => (media.type === 'image' ? media.markup : ''))
            .join('')}
        </div>
        <div class='learner-card__details'>
          <label class='learner-card__title'>${activity.title}</label>
          ${cardDetailsMarkup}
        </div>
      </div>
    `;

    return string;
  }

  /**
   * Opens a modal showing the session schedule for the activity
   *
   * @listens document:click:[data-learner-card-schedule-open]
   */
  function _openActivityScheduleModal(e) {
    e.stopPropagation();

    const uniqueKey = this.getAttribute('data-unique-key');
    const activity = cache.activity_data.find(
      (a) => `${a.unique_key}` === uniqueKey
    );

    if (!activity) {
      return;
    }

    const string = `
      <div class="learner-schedule-modal">
        <div class="learner-schedule-modal__content">
          <h1 class="h3">Session Dates</h1>
          <ul>
            ${activity.sessions
              .map(
                (session) =>
                  `<li>${theme.Time.convertTimeToDisplayDateOnly(
                    session.datetime
                  )} &#8226; ${theme.Time.convertTimeToDisplayTimeOnly(
                    session.datetime,
                    session.end_datetime
                  )}</li>`
              )
              .join('')}
          </ul>
          <div>Total Duration of Activity: ${theme.Global.renderActivityDuration(
            activity.sessions[0].duration * activity.sessions.length
          )}.</div>
        </div>
      </div>
    `;

    $.fancybox.open(string);
  }

  function _openActivityDetails() {
    const uniqueKey = this.getAttribute('data-unique-key');
    const activity = cache.activity_data.find(
      (a) => `${a.unique_key}` === uniqueKey
    );

    if (!activity) {
      return;
    }

    const activityImage = activity.media.find(
      (media) => media.type === 'image'
    );
    const activityVideo = activity.media.find(
      (media) => media.type === 'video'
    );

    let string = '';
    if (activity.type === 'Anytime') {
      let resourceLink = '';
      if (
        activity.session_data &&
        activity.session_data.length &&
        activity.session_data[0].before_resources &&
        activity.session_data[0].before_resources.length
      ) {
        resourceLink = activity.session_data[0].before_resources[0].link;
      }

      string = `
        <div class="learner-activity-details page-width">
          <div class="learner-activity-details__back-container">
            <button class="learner-activity-details__back" data-learner-activity-close>
              <span class="material-icons">arrow_back_ios</span>
              <span>Back to Anytime Activities</span>
            </button>  
          </div>
          <div class="learner-activity-details__desktop-row">
            ${
              activityImage
                ? `<div class="learner-activity-details__image image-wrapper video-wrapper">${activityImage.markup}</div>`
                : ''
            }
            <div class="learner-activity-details__overview">
              <div class="learner-activity-details__badge-container">
                <div class="learner-activity-details__badge learner-activity-details--${
                  activity.type
                }">${activity.type}</div>
                <span>Lifetime access</span>
              </div>
              <h1 class="learner-activity-details__title">${activity.title}</h1>
              <label class="learner-activity-details__educator">Guided by <a href="${
                activity.educator_url
              }">${activity.educator_name}</a></label>

              <div class="learner-activity-details__ordered">
                <p class="learner-activity-details__special">${
                  activity.special
                }</p>
                <div class="learner-activity-details__actions">
                  ${
                    resourceLink
                      ? `<a href="${theme.Global.addProtocolToLink(
                          resourceLink
                        )}" class="btn btn--primary" target="_blank">Download PDF</a>`
                      : ''
                  }
                </div>
              </div>
            </div>
          </div>

          <div class="learner-activity-details__video">
            ${
              activityVideo
                ? `<div class="image-wrapper video-wrapper">${activityVideo.markup}</div>`
                : ''
            }
          </div>
        </div>
      `;
    } else {
      const currentSession = this.getAttribute('data-current-session');
      const isComplete = activity.sessions.every(
        (session) => session.status === 'completed'
      );
      const seconds_till_start =
        activity.sessions[currentSession].seconds_till_start;

      string = `
        <div class="learner-activity-details learner-activity-details__realtime page-width">
          <div class="learner-activity-details__back-container">
            <button class="learner-activity-details__back" data-learner-activity-close>
              <span class="material-icons">arrow_back_ios</span>
              <span>Back to ${
                sessionStorage.getItem('active_account_navigation') ===
                'learner-realtime-activities'
                  ? 'Upcoming Activities'
                  : 'Completed Activities'
              }</span>
            </button>  
          </div>
          <div class="learner-activity-details__desktop-row">
          ${
            activityImage
              ? `<div class="learner-activity-details__image image-wrapper video-wrapper">${activityImage.markup}</div>`
              : ''
          }
            <div class="learner-activity-details__overview">
              <div class="learner-activity-details__badge-container">
                <div class="learner-activity-details__badge learner-activity-details--${
                  activity.type
                }">${activity.type}</div>
                <span>
                  <span>${
                    activity.sessions.length === 1
                      ? '1 session'
                      : `${activity.sessions.length} sessions`
                  }</span>
                  ${
                    activity.type === 'Single'
                      ? `<span class="learner-activity-details__divider">•</span>
                      <span class="learner-activity-details__datetime">
                        ${theme.Time.convertTimeToDisplayDateAndYearOnly(
                          activity.sessions[0].datetime
                        )}
                        |
                        ${theme.Time.convertTimeToDisplayTimeOnly(
                          activity.sessions[0].datetime
                        )} - ${theme.Time.convertTimeToDisplayTimeOnly(
                          activity.sessions[0].end_datetime
                        )}
                      </span>
                    `
                      : ''
                  }
                </span>
              </div>
              <h1 class="learner-activity-details__title">${activity.title}</h1>
              <label class="learner-activity-details__educator">Guided by <a href="${
                activity.educator_url
              }">${activity.educator_name}</a></label>

              <div class="learner-activity-details__ordered">
                <p class="learner-activity-details__special">${
                  activity.special
                }</p>
                <p> ${activity.session_data[0].introduction} </p>
                <p> ${activity.session_data[0].description} </p>
                <p> ${activity.session_data[0].closing} </p>
                <div class="learner-activity-details__actions">
                  <div class="learner-activity-details__actions--desktop-row">
                  ${_generateActivitySessionTimerAndJoinButton(
                    activity,
                    currentSession,
                    isComplete
                  )}

                  ${
                    cache.current_profile == 0
                      ? `
                        <button
                          class="learner-activity-details__change-participant"
                          data-change-participant
                          data-unique-key='${activity.unique_key}'
                          data-id="${activity.order_id}"
                          data-participant="${activity.participant}"
                          ${isComplete ? 'disabled' : ''}
                        >
                          Edit Activity
                        </button>
                      `
                      : ''
                  }
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          ${_generateActivitySessionGrid(activity)}

          <p class="learner-activity-details__special">${activity.special}</p>

          <div class="learner-activity-details__realtime-resources">
            <div class="learner-activity-details__resources-wrapper">
              <button class="learner-activity-details__resources-toggle h4" data-toggle-session-resources aria-expanded="false" aria-controls="learner-activity-details__resources">
                <span>Overview of All Materials</span>
                <span class="material-icons learner-activity-details__resources--down">keyboard_arrow_down</span>
                <span class="material-icons learner-activity-details__resources--up">keyboard_arrow_up</span>
              </button>
              <div id="learner-activity-details__resources" class="learner-activity-details__resources">
                <label class="h4">Here is a list of all the materials needed to complete the entire Activity.</label>
                <p>${activity.materials}</p>
              </div>
            </div>

            ${
              activity.type === 'Single' &&
              (activity.session_data[0].before_resources.length ||
                activity.session_data[0].after_resources.length)
                ? `
              <div class="learner-activity-details__resources-wrapper">
                <button class="learner-activity-details__resources-toggle h4" data-toggle-session-resources aria-expanded="false" aria-controls="learner-activity-details__resources">
                  <span>Resources</span>
                  <span class="material-icons learner-activity-details__resources--down">keyboard_arrow_down</span>
                  <span class="material-icons learner-activity-details__resources--up">keyboard_arrow_up</span>
                </button>
                <div id="learner-activity-details__resources" class="learner-activity-details__resources">
                  ${
                    activity.session_data[0].before_resources.length
                      ? "<label class='h4'>Before Activity</label>"
                      : ''
                  }
                  ${activity.session_data[0].before_resources
                    .map(
                      (resource) =>
                        `<a href="${theme.Global.addProtocolToLink(
                          resource.link
                        )}" class="learner-activity-details__resource-link h4" target="_blank">${
                          resource.title
                        }</a>`
                    )
                    .join('')}

                  ${
                    activity.session_data[0].after_resources.length
                      ? "<label class='h4'>After Activity</label>"
                      : ''
                  }
                  ${activity.session_data[0].after_resources
                    .map(
                      (resource) =>
                        `<a href="${theme.Global.addProtocolToLink(
                          resource.link
                        )}" class="learner-activity-details__resource-link h4" target="_blank">${
                          resource.title
                        }</a>`
                    )
                    .join('')}
                </div>
              </div>
            `
                : ''
            }
          </div>
  
        </div>
      `;
    }

    $('[data-learner-activity-details]').html(string).show();
    $('.account-body-container, .account__banner').hide();
  }

  function _generateActivitySessionTimerAndJoinButton(
    activity,
    currentSession,
    isComplete
  ) {
    const seconds_till_start =
      activity.sessions[currentSession].seconds_till_start;

    if (isComplete) {
      return `<button class="btn btn--primary" disabled>Activity Completed</button>`;
    } else {
      if (seconds_till_start <= 3600) {
        return `
          <label class="learner-activity-details__timer">
            ${
              seconds_till_start < 0
                ? `${activity.educator_name} is waiting!`
                : `Starts in ${Math.floor(seconds_till_start / 60)} min`
            }
          </label>
          <a href="${
            activity.link
          }" class="btn btn--primary" target="_blank">Join Activity Room</a>
        `;
      } else {
        return `
          <button class="btn btn--primary" disabled>Join Activity Room</button>
        `;
      }
    }
  }

  function _generateActivitySessionGrid(activity) {
    if (!activity || activity.type === 'Single') {
      return '';
    }

    return `
      <div class="learner-activity-details__sessions">
        ${activity.sessions
          .map((session, index) => {
            if (!activity.session_data[index]) {
              return;
            }

            return `
            <div class="learner-activity-details__session">
              <label>
                ${theme.Time.convertTimeToDisplayDateAndYearOnly(
                  session.datetime
                )}
                |
                ${theme.Time.convertTimeToDisplayTimeOnly(
                  session.datetime
                )} - ${theme.Time.convertTimeToDisplayTimeOnly(
              session.end_datetime
            )}
              </label>
              <label class="h4">${index + 1} - ${
              activity.session_data[index].title
            }</label>
              <div class="learner-activity-details__session--resources-wrapper">
                <button class="learner-activity-details__session--resources-toggle h4" data-toggle-session-resources aria-expanded="false" aria-controls="learner-activity-details__session--resources-${index}">
                  <span>Materials & Resources</span>
                  <span class="material-icons learner-activity-details__session--down">keyboard_arrow_down</span>
                  <span class="material-icons learner-activity-details__session--up">keyboard_arrow_up</span>
                </button>
                <div id="learner-activity-details__session--resources-${index}" class="learner-activity-details__session--resources">
                  <label class="h4">Materials for this Session</label>
                  <p>${activity.session_data[index].materials}</p>

                  ${
                    activity.session_data[index].before_resources.length
                      ? "<label class='h4'>Pre-Session Resources</label>"
                      : ''
                  }
                  ${activity.session_data[index].before_resources
                    .map(
                      (resource) =>
                        `<a href="${theme.Global.addProtocolToLink(
                          resource.link
                        )}" class="learner-activity-details__session--resource-link h4" target="_blank">${
                          resource.title
                        }</a>`
                    )
                    .join('')}

                  ${
                    activity.session_data[index].after_resources.length
                      ? "<label class='h4'>Post-Session Resources</label>"
                      : ''
                  }
                  ${activity.session_data[index].after_resources
                    .map(
                      (resource) =>
                        `<a href="${theme.Global.addProtocolToLink(
                          resource.link
                        )}" class="learner-activity-details__session--resource-link h4" target="_blank">${
                          resource.title
                        }</a>`
                    )
                    .join('')}
                </div>
              </div>
            </div>
          `;
          })
          .join('')}
      </div>
    `;
  }

  function _handleToggleSessionResources() {
    const currentlyExpanded = $(this).attr('aria-expanded');

    if (currentlyExpanded === 'true') {
      $(this).next().hide();
      $(this).attr('aria-expanded', 'false');
    } else {
      $(this).next().show();
      $(this).attr('aria-expanded', 'true');
    }
  }

  function _closeActivityDetails() {
    $('[data-learner-activity-details]').hide();
    $('.account-body-container, .account__banner').show();
  }

  /**
   * Creates a popup which will show multiple options
   * for a user to change
   *
   * @listens document:click:[data-change-participant]
   *
   * @param {e} e jQuery event
   */
  function _initializeParticipantChange(e) {
    const { id, participant, uniqueKey } = $(this).data();

    const string = `
      <div class='participation-popup'>
        <div class="participation-popup__change-view" data-participation-change-view>
          <h1 class="participation-popup__title h3">Make a Change?</h1>

          <div class="participation-popup__card">
            <div>
              <img src="https://cdn.shopify.com/s/files/1/0450/1418/8196/files/Changeprofile.png?v=1648059346">
            </div>
            <div>
              <p class="participation-popup__subtitle">Switch Participant</p>
              <button class="participation-popup__button text-link" data-show-participation-switch-view>Change Now</button>
            </div>
          </div>

          <div class="participation-popup__card">
            <div>
              <img src="https://cdn.shopify.com/s/files/1/0450/1418/8196/files/ChangeTime.png?v=1648059346">
            </div>
            <div>
              <p class="participation-popup__subtitle">Cancel or Change Time</p>
              <p>Send us an email so we can help:<br>support@homelearnersnetwork.ca</p>
            </div>
          </div>
        </div>

        <div class="participation-popup__switch-view" data-participation-switch-view>
          <div class="participation-popup__actions">
            <button class="text-link" data-show-participation-change-view>
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 14 14"><path d="M10.129.604a1.125 1.125 0 0 0-1.591 0L3.023 6.12s.049-.049-.003.004l-.082.08c-.439.44-.44 1.153 0 1.592l5.6 5.6a1.125 1.125 0 0 0 1.59-1.59L5.325 7l4.805-4.805c.44-.439.44-1.151 0-1.59z" fill="#fff"/></svg>  
              Back
            </button>
          </div>

          <h1 class="participation-popup__title h3">Switch Participant</h1>

          <div class='participation-popup__profile-selector'>
            <select id='new-activity-participant' data-learner-new-participant>
              <option selected value='${participant}'>${
      theme.customer.profiles[participant].first_name
    }</option>
                ${Object.values(theme.customer.profiles)
                  .filter(
                    (value) =>
                      typeof value === 'object' && value.id !== participant
                  )
                  .map(
                    (profile) =>
                      `<option value="${profile.id}">${profile.first_name}</option>`
                  )
                  .join('')}
            </select>
          </div>

          <button class='btn btn--primary' data-learner-activity-profile-update data-unique-key='${uniqueKey}' data-order-id='${id}' data-current-participant='${participant}'>Submit</button>
        </div>

      </div>
    `;

    $.fancybox.open(string);
  }

  /**
   * Changes views in the change participant modal
   *
   * @listens document:click:[data-show-participation-switch-view]
   */
  function _showParticipationSwitchView() {
    $('[data-participation-change-view]').hide();
    $('[data-participation-switch-view]').show();
  }

  /**
   * Changes views in the change participant modal
   *
   * @listens document:click:[data-show-participation-change-view]
   */
  function _showParticipationChangeView() {
    $('[data-participation-switch-view]').hide();
    $('[data-participation-change-view]').show();
  }

  /**
   * Support function that will call and API to update
   * the current profile of an activity. Once the profile is swapped
   * it will close all open fancyboxes and update the name of the
   * activity's profile.
   *
   * @param {event}    activity_id
   *
   * @listens document:click:[data-learner-activity-profile-update]
   */
  function _updateActivityProfile() {
    const order_id = $(this).attr('data-order-id');
    const uniqueKey = $(this).attr('data-unique-key');

    const currentParticipant = $('[data-learner-activity-profile-update]').attr(
      'data-current-participant'
    );
    var new_participant = $('[data-learner-new-participant]').val();

    if (new_participant !== currentParticipant) {
      theme.Global.generateModal(
        'ring',
        'Updating Activity Participant',
        'Please wait...'
      );
      theme.Activities.changeActivityProfile(
        order_id,
        new_participant,
        uniqueKey
      )
        .then(function (unique_key) {
          $.fancybox.close(true);
        })
        .catch(function (r) {
          theme.Global.generateModal(
            '',
            'Something went wrong :(',
            'An unexpected error has occured. Please contact your administrator.',
            r
          );
        });
    } else {
      $.fancybox.close(true);
    }
  }

  /**
   *
   * @param   {array}       resources An array of resource objects
   * @returns {null | Date}           A javascript Date object of the most recently added resource or null if the resources array is empty
   */
  function getDateOfNewestResource(resources) {
    let date = null;

    resources.forEach((resource) => {
      if (!date || new Date(resource.created_at > date)) {
        date = new Date(resource.created_at);
      }
    });

    return date;
  }

  return {
    init: init,
  };
})();

theme.AnytimeActivity = (function () {
  function AnytimeNavigation(container) {
    $(document).on('click', '[data-tab]', _setSelectedTab);
    $(document).on('change', '[data-tab-dropdown]', _setSelectedBlock);

    $('[data-tab]').first().click();
  }

  function _setSelectedTab(e) {
    $('[data-tab]').attr('aria-selected', false);
    $('[data-tab-dropdown]').val($(this).attr('aria-controls')).change();
  }

  function _setSelectedBlock(e) {
    var block = $(this).val();

    $("[aria-controls='" + block + "']").attr('aria-selected', true);

    $('[data-tab-block]').hide();
    $('#' + block).show();
  }

  // TODO: Make a good error page.
  function _domError() {
    return '<label>Error loading page</label>';
  }

  return AnytimeNavigation;
})();

document.addEventListener('DOMContentLoaded', function () {
  var sections = new theme.Sections();
  theme.Global.init();
  theme.Shopify.init();
  theme.Activities.init();

  sections.register('anytime-activity', theme.AnytimeActivity);
  sections.register('account-navigation', theme.AccountNavigation);

  theme.Resources.init();

  // Fix captcha page
  if ($('.shopify-challenge__message').length > 0) {
    var replace =
      ' \
      <span>Oh heeey!</span> \
      ' +
      $('.shopify-challenge__message').html() +
      " \
      <img src='https://cdn.shopify.com/s/files/1/0488/1042/6535/files/TABLET_A_0e570c72-0bf4-44cf-873c-ac0012ad2582.gif?v=1645221129' alt='Orange tablet waving' />";

    $('.shopify-challenge__message').html(replace);
  }

  // Common a11y fixes
  slate.a11y.pageLinkFocus(
    document.getElementById(window.location.hash.substr(1))
  );

  var inPageLink = document.querySelector('.in-page-link');

  if (inPageLink) {
    inPageLink.addEventListener('click', function (evt) {
      slate.a11y.pageLinkFocus(
        document.getElementById(evt.currentTarget.hash.substr(1))
      );
    });
  }

  document.querySelectorAll('a[href="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (evt) {
      evt.preventDefault();
    });
  });

  slate.a11y.accessibleLinks({
    messages: {
      newWindow: theme.strings.newWindow,
      external: theme.strings.external,
      newWindowExternal: theme.strings.newWindowExternal,
    },
    links: document.querySelectorAll(
      'a[href]:not([aria-describedby]), .product-single__thumbnail'
    ),
  });

  if (document.fonts) {
    document.fonts.ready.then(function () {
      window.performance.mark('debut:fonts_loaded');
    });
  }
});
